import React, { useEffect, useState, useRef } from 'react';
import AdminService from '../services/adminService';
import CategoriesService from '../services/categoriesService';
import DepartementService from '../services/departementService';
import VilleService from '../services/villeService';
import CONFIG from '../../globalVariables';
import resolveImageUrl from '../utils/resolveImageUrl';
import { InlineEditProvider } from '../components/admin/InlineEditContext';
import Home from './Home';
import Services from './Services';
import Professional from './Professional';
import About from './About';
import Contact from './Contact';
import Dashboard from './Dashboard';

  const Admin = () => {
  const [token, setToken] = useState(localStorage.getItem('admin_token') || null);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [templates, setTemplates] = useState([]);
  // Section Admin: 'templates' ou 'data' ; null = écran de sélection
  const [adminSection, setAdminSection] = useState(null);
  const [showEditor, setShowEditor] = useState(false);
  const [editor, setEditor] = useState({ section: 'hero', property: 'background_image', value: '', type: 'overall', categorieId: null });
  const [type, setType] = useState('overall');
  const [showDetails, setShowDetails] = useState(false);
  // Type change buffer per template
  const [typeChanges, setTypeChanges] = useState({});
  // Categories for type 'category'
  const [categories, setCategories] = useState([]);
  // Image link input in editor
  const [imageUrlInput, setImageUrlInput] = useState('');

  // Données liées (Départements/Villes)
  const [departements, setDepartements] = useState([]);
  const [villes, setVilles] = useState([]);
  const [depLoading, setDepLoading] = useState(false);
  const [villeLoading, setVilleLoading] = useState(false);
  const [depError, setDepError] = useState(null);
  const [villeError, setVilleError] = useState(null);
  const [depForm, setDepForm] = useState({ id: null, nom: '', code: '' });
  const [villeForm, setVilleForm] = useState({ id: null, nom: '', code_postal: '', departement: '' });
  const [catForm, setCatForm] = useState({ id: null, nom: '', type: '', zone: '', image: '', description: '', sous_categories: [] });
  const [showCatDetails, setShowCatDetails] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  // Affichage des mini formulaires (création/modification)
  const [showDepForm, setShowDepForm] = useState(false);
  const [showVilleForm, setShowVilleForm] = useState(false);
  const [showCatForm, setShowCatForm] = useState(false);
  // Sélections multiples (Départements/Villes)
  const [depSelectedIds, setDepSelectedIds] = useState([]);
  const [villeSelectedIds, setVilleSelectedIds] = useState([]);
  const [catSelectedIds, setCatSelectedIds] = useState([]);
  const [showDepBulkDeleteConfirm, setShowDepBulkDeleteConfirm] = useState(false);
  const [showVilleBulkDeleteConfirm, setShowVilleBulkDeleteConfirm] = useState(false);
  const [showCatBulkDeleteConfirm, setShowCatBulkDeleteConfirm] = useState(false);
  const [catQuery, setCatQuery] = useState('');
  const [catLoading, setCatLoading] = useState(false);
  const [catError, setCatError] = useState(null);
  // Filtre type catégories: 'all' | 'particulier' | 'professionnel'
  const [catTypeFilter, setCatTypeFilter] = useState('all');

  // Full editor states
  const [showFullEditor, setShowFullEditor] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [fullTexteJSON, setFullTexteJSON] = useState('');
  const [fullActif, setFullActif] = useState(false);
  const [fullTexte, setFullTexte] = useState(null);
  const [fullName, setFullName] = useState('');
  const [nameEdited, setNameEdited] = useState(false);
  const [newCategoryId, setNewCategoryId] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createCategoryId, setCreateCategoryId] = useState('');
  // Recherches (déplacées ici pour éviter les hooks conditionnels)
  const [depQuery, setDepQuery] = useState('');
  const [villeQuery, setVilleQuery] = useState('');
  const [templatesQuery, setTemplatesQuery] = useState('');
  // Pages dédiées (Accueil / À propos)
  const [pageTemplate, setPageTemplate] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);
  const [pageError, setPageError] = useState(null);
  const [pageName, setPageName] = useState('');

  // Pages (PageContent) - section unique et flexible
  const DEFAULT_PAGES = ['accueil', 'services', 'professionnel', 'apropos', 'contact', 'dashboard'];
  const [pagesList, setPagesList] = useState([]);
  const [pagesLoading, setPagesLoading] = useState(false);
  const [pagesError, setPagesError] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null); // document PageContent
  const [pageEditorMode, setPageEditorMode] = useState('quick'); // 'quick' or 'full'
  const [pageDetailsEditMode, setPageDetailsEditMode] = useState(false);
  const [detailsOverallTemplate, setDetailsOverallTemplate] = useState(null);
  const [showQuickEdit, setShowQuickEdit] = useState(false);
  const [quickEditForm, setQuickEditForm] = useState({ slug: '', title: '', name: '', actif: true, hero: { titre_principal: '', sous_titre: '', background_image: '' } });
    const [overallDetailsForm, setOverallDetailsForm] = useState({ hero: { titre_principal: '', sous_titre: '', description: '', bouton_principal: '', bouton_secondaire: '', background_image: '' } });
    // Drag & drop helpers for gallery images within section editor
    const draggingImageIndexRef = useRef(null);
  const [showPageEditor, setShowPageEditor] = useState(false);
  const [pageForm, setPageForm] = useState({ slug: '', title: '', actif: true, meta: {}, sections: [] });
  const [garantiesInitAllDone, setGarantiesInitAllDone] = useState(false);

  // Éditeur dédié pour une page spécifique (Services, Professionnel, Contact, Dashboard)
  const [singlePage, setSinglePage] = useState(null);
  const [singlePageLoading, setSinglePageLoading] = useState(false);
  const [singlePageError, setSinglePageError] = useState(null);
  const [showSinglePageEditor, setShowSinglePageEditor] = useState(false);
  const [singlePageEditMode, setSinglePageEditMode] = useState(false);
  const [singlePageForm, setSinglePageForm] = useState({ slug: '', title: '', actif: true, meta: {}, sections: [] });

  const handleLogout = () => {
    try {
      localStorage.removeItem('admin_token');
      setToken(null);
      setTemplates([]);
      setAdminSection(null);
      setError(null);
    } catch (_) {
      // no-op
    }
  };

  const getTemplatesByType = async (t) => {
    if (t === 'all') {
      const [a, b] = await Promise.all([
        AdminService.getTemplates('overall', token).catch(() => []),
        AdminService.getTemplates('category', token).catch(() => [])
      ]);
      const merged = [...a, ...b];
      const seen = new Set();
      const result = [];
      for (const it of merged) {
        const id = it && it._id ? it._id : '' + Math.random();
        if (!seen.has(id)) {
          seen.add(id);
          result.push(it);
        }
      }
      return result;
    }
    return AdminService.getTemplates(t, token);
  };

  useEffect(() => {
    const fetch = async () => {
      if (!token || adminSection !== 'templates') return;
      try {
        setLoading(true);
        setTemplates([]);
        const list = await getTemplatesByType(type);
        setTemplates(list);
        // Initialize type change buffer
        const init = {};
        list.forEach(t => { init[t._id] = { type: t.type, categorieId: t?.categorie?._id || null }; });
        setTypeChanges(init);
      } catch (e) {
        // Si le token est invalide ou manquant, forcer la déconnexion pour réafficher le formulaire
        const msg = e?.message || '';
        if (msg.includes('Token invalide') || msg.includes('Token manquant') || msg.includes('Accès refusé')) {
          try {
            localStorage.removeItem('admin_token');
          } catch (_) { /* no-op */ }
          setToken(null);
          // Conserver le message d'erreur afin de l'afficher sur l'écran de connexion
          setError('Session invalide. Veuillez vous reconnecter.');
        } else {
          setError(msg);
        }
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [token, type, adminSection]);

  useEffect(() => {
    const run = async () => {
      if (!token || adminSection !== 'templates' || garantiesInitAllDone) return;
      try {
        setLoading(true);
        const typesToInit = ['overall', 'category'];
        for (const t of typesToInit) {
          let list = [];
          try { list = await AdminService.getTemplates(t, token); } catch (_) {}
          for (const tpl of list) {
            const g = tpl?.texte?.garanties;
            const hasObj = g && typeof g === 'object';
            const images = hasObj && Array.isArray(g.images) ? g.images : [];
            const liste = hasObj && Array.isArray(g.liste) ? g.liste : [];
            const titre = hasObj && typeof g.titre === 'string' ? g.titre : '';
            if (!hasObj || !Array.isArray(g.images) || !Array.isArray(g.liste)) {
              const payload = { texte: { ...(tpl?.texte || {}), garanties: { titre, images, liste } }, actif: !!tpl?.actif, name: tpl?.name || '' };
              try { await AdminService.updateTemplate(tpl._id, payload, token); } catch (_) {}
            }
          }
        }
        try {
          const listNow = await getTemplatesByType(type);
          setTemplates(listNow);
          const init = {};
          listNow.forEach(t => { init[t._id] = { type: t.type, categorieId: t?.categorie?._id || null }; });
          setTypeChanges(init);
        } catch (_) {}
      } finally {
        setGarantiesInitAllDone(true);
        setLoading(false);
      }
    };
    run();
  }, [token, adminSection, type, garantiesInitAllDone]);

  // Charger Départements/Villes quand on passe en section Ville/Département
  useEffect(() => {
    const loadData = async () => {
      if (!(adminSection === 'ville' || adminSection === 'departement')) return;
      // Fermer les modales templates si ouvertes
      setShowFullEditor(false);
      setShowEditor(false);
      setShowDetails(false);
      try {
        setDepLoading(true);
        setDepError(null);
        const deps = await DepartementService.getAll();
        setDepartements(deps);
      } catch (e) {
        setDepError(e?.message || 'Erreur chargement départements');
      } finally {
        setDepLoading(false);
      }
      try {
        setVilleLoading(true);
        setVilleError(null);
        const vs = await VilleService.getAll();
        setVilles(vs);
      } catch (e) {
        setVilleError(e?.message || 'Erreur chargement villes');
      } finally {
        setVilleLoading(false);
      }
    };
    loadData();
  }, [adminSection]);

  // Charger Catégories quand on passe en section Catégorie
  useEffect(() => {
    const loadCategories = async () => {
      if (adminSection !== 'categorie') return;
      // Fermer modales templates si ouvertes
      setShowFullEditor(false);
      setShowEditor(false);
      setShowDetails(false);
      try {
        setCatLoading(true);
        setCatError(null);
        const cats = await CategoriesService.getAllCategories();
        setCategories(cats);
      } catch (e) {
        setCatError(e?.message || 'Erreur chargement catégories');
      } finally {
        setCatLoading(false);
      }
    };
    loadCategories();
  }, [adminSection]);

  // Charger/Créer la page Accueil ou À propos
  useEffect(() => {
    const loadPage = async () => {
      if (!(adminSection === 'accueil' || adminSection === 'apropos')) return;
      setShowFullEditor(false);
      setShowEditor(false);
      setShowDetails(false);
      const desiredName = adminSection === 'accueil' ? 'Accueil' : 'A propos';
      setPageName(desiredName);
      try {
        setPageLoading(true);
        setPageError(null);
        const list = await AdminService.getTemplates('overall', token);
        let tpl = list.find(t => (t?.name || '').toLowerCase() === desiredName.toLowerCase())
          || list.find(t => ((t?.texte?.hero?.titre_principal) || '').toLowerCase() === desiredName.toLowerCase());
        if (!tpl) {
          // Créer un template overall minimal avec le titre hero
          const created = await AdminService.updateProperty('overall', 'hero', 'titre_principal', desiredName, token);
          // Mettre le name explicitement
          try {
            tpl = await AdminService.updateTemplate(created._id, { texte: created.texte, actif: true, name: desiredName }, token);
          } catch (_) {
            tpl = created;
          }
        }
        setPageTemplate(tpl);
      } catch (e) {
        setPageError(e?.message || 'Erreur chargement page');
      } finally {
        setPageLoading(false);
      }
    };
    loadPage();
  }, [adminSection, token]);

  // Charger la liste des PageContent quand la section Pages est ouverte
  useEffect(() => {
    const loadPages = async () => {
      if (adminSection !== 'pages') return;
      try {
        setPagesLoading(true);
        setPagesError(null);
        const list = await AdminService.getPages(token);
        setPagesList(Array.isArray(list) ? list : []);
      } catch (e) {
        setPagesError(e?.message || 'Erreur chargement pages');
      } finally {
        setPagesLoading(false);
      }
    };
    loadPages();
  }, [adminSection, token]);

  // Charger automatiquement une page dédiée (Services / Professionnel / Contact / Dashboard)
  const getSlugFromAdminSection = (section) => {
    switch (section) {
      case 'page-services': return 'services';
      case 'page-professionnel': return 'professionnel';
      case 'page-contact': return 'contact';
      case 'page-dashboard': return 'dashboard';
      case 'page-apropos': return 'apropos';
      default: return null;
    }
  };

  useEffect(() => {
    const slug = getSlugFromAdminSection(adminSection);
    if (!slug || !token) return;
    const loadSingle = async () => {
      try {
        setSinglePageLoading(true);
        setSinglePageError(null);
        let pageDoc;
        try {
          pageDoc = await AdminService.getPage(slug, token);
        } catch (e) {
          // Créer minimal si non trouvé
          const title = slug.charAt(0).toUpperCase() + slug.slice(1);
          pageDoc = await AdminService.upsertPage({ slug, title }, token);
        }
        setSinglePage(pageDoc);
        setSinglePageForm({
          slug: pageDoc.slug,
          title: pageDoc.title || (slug.charAt(0).toUpperCase() + slug.slice(1)),
          actif: !!pageDoc.actif,
          meta: pageDoc.meta || {},
          sections: Array.isArray(pageDoc.sections) ? pageDoc.sections : []
        });
        setShowSinglePageEditor(true);
        setSinglePageEditMode(false); // Par défaut: vue lecture seule
      } catch (e) {
        setSinglePageError(e?.message || 'Erreur chargement page');
      } finally {
        setSinglePageLoading(false);
      }
    };
    loadSingle();
  }, [adminSection, token]);

  // Actions CRUD Départements
  const depFormRef = useRef(null);
  const editDepartement = (d) => {
    setShowDepForm(true);
    setDepForm({ id: d._id, nom: d.nom || '', code: d.code || '' });
    // Scroll vers le formulaire pour clarifier l'action Modifier
    depFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const resetDepForm = () => setDepForm({ id: null, nom: '', code: '' });
  const saveDepartement = async () => {
    try {
      setDepLoading(true);
      setDepError(null);
      const payload = { nom: depForm.nom, code: depForm.code };
      if (depForm.id) {
        await DepartementService.update(depForm.id, payload);
      } else {
        await DepartementService.create(payload);
      }
      const deps = await DepartementService.getAll();
      setDepartements(deps);
      resetDepForm();
    } catch (e) {
      setDepError(e?.message || 'Erreur sauvegarde département');
    } finally {
      setDepLoading(false);
    }
  };
  const deleteDepartement = async (id) => {
    try {
      setDepLoading(true);
      await DepartementService.remove(id);
      const deps = await DepartementService.getAll();
      setDepartements(deps);
      // Nettoyer les villes si elles référencent ce département
      setVilles(prev => prev.filter(v => v?.departement?._id !== id));
      if (depForm.id === id) resetDepForm();
      setDepSelectedIds(prev => prev.filter(x => x !== id));
    } catch (e) {
      setDepError(e?.message || 'Erreur suppression département');
    } finally {
      setDepLoading(false);
    }
  };

  // Sélection multiple & suppression groupée - Départements
  const depAllSelected = departements.length > 0 && depSelectedIds.length === departements.length;
  const toggleDepSelected = (id) => {
    setDepSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const selectAllDepartements = () => setDepSelectedIds(departements.map(d => d._id));
  const deselectAllDepartements = () => setDepSelectedIds([]);
  const handleDepBulkDelete = async () => {
    try {
      setDepLoading(true);
      await Promise.all(depSelectedIds.map(id => DepartementService.remove(id)));
      const deps = await DepartementService.getAll();
      setDepartements(deps);
      setDepSelectedIds([]);
      // Nettoyer les villes si elles référencent des départements supprimés
      const deletedSet = new Set(depSelectedIds);
      setVilles(prev => prev.filter(v => !deletedSet.has(v?.departement?._id)));
    } catch (e) {
      setDepError(e?.message || 'Erreur suppression groupée départements');
    } finally {
      setDepLoading(false);
    }
  };

  // Actions CRUD Villes
  const villeFormRef = useRef(null);
  const editVille = (v) => {
    setShowVilleForm(true);
    setVilleForm({
      id: v._id,
      nom: v.nom || '',
      code_postal: v.code_postal || '',
      departement: v?.departement?._id || ''
    });
    // Scroll vers le formulaire pour clarifier l'action Modifier
    villeFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const resetVilleForm = () => setVilleForm({ id: null, nom: '', code_postal: '', departement: '' });
  const saveVille = async () => {
    try {
      setVilleLoading(true);
      setVilleError(null);
      const payload = { nom: villeForm.nom, code_postal: villeForm.code_postal, departement: villeForm.departement };
      if (!payload.departement) throw new Error('Département requis');
      if (villeForm.id) {
        await VilleService.update(villeForm.id, payload);
      } else {
        await VilleService.create(payload);
      }
      const vs = await VilleService.getAll();
      setVilles(vs);
      resetVilleForm();
    } catch (e) {
      setVilleError(e?.message || 'Erreur sauvegarde ville');
    } finally {
      setVilleLoading(false);
    }
  };
  const deleteVille = async (id) => {
    try {
      setVilleLoading(true);
      await VilleService.remove(id);
      const vs = await VilleService.getAll();
      setVilles(vs);
      if (villeForm.id === id) resetVilleForm();
      setVilleSelectedIds(prev => prev.filter(x => x !== id));
    } catch (e) {
      setVilleError(e?.message || 'Erreur suppression ville');
    } finally {
      setVilleLoading(false);
    }
  };

  // Sélection multiple & suppression groupée - Villes
  const villeAllSelected = villes.length > 0 && villeSelectedIds.length === villes.length;
  const toggleVilleSelected = (id) => {
    setVilleSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const selectAllVilles = () => setVilleSelectedIds(villes.map(v => v._id));
  const deselectAllVilles = () => setVilleSelectedIds([]);
  const handleVilleBulkDelete = async () => {
    try {
      setVilleLoading(true);
      await Promise.all(villeSelectedIds.map(id => VilleService.remove(id)));
      const vs = await VilleService.getAll();
      setVilles(vs);
      setVilleSelectedIds([]);
    } catch (e) {
      setVilleError(e?.message || 'Erreur suppression groupée villes');
    } finally {
      setVilleLoading(false);
    }
  };

  // Load categories for type switch UI
  useEffect(() => {
    const loadCats = async () => {
      if (!token) return;
      try {
        const cats = await CategoriesService.getAllCategories();
        setCategories(cats || []);
      } catch (e) {
        console.warn('Chargement catégories échoué:', e?.message);
      }
    };
    loadCats();
  }, [token]);

  // Actions CRUD Catégories
  const catFormRef = useRef(null);
  const editCategorie = (c) => {
    setShowCatForm(true);
    setCatForm({
      id: c._id,
      nom: c.nom || '',
      enable: c.enable !== false, // défaut à true si absent
      type: c.type || '',
      zone: c.zone || '',
      image: c.image || '',
      description: c.description || '',
      sous_categories: Array.isArray(c.sous_categories) ? c.sous_categories : []
    });
    catFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const resetCatForm = () => setCatForm({ id: null, nom: '', enable: true, type: '', zone: '', image: '', description: '', sous_categories: [] });
  const saveCategorie = async () => {
    try {
      setCatLoading(true);
      setCatError(null);
      const payload = { nom: catForm.nom, enable: !!catForm.enable, type: catForm.type, zone: catForm.zone, image: catForm.image, description: catForm.description, sous_categories: catForm.sous_categories };
      if (catForm.id) {
        await CategoriesService.update(catForm.id, payload);
      } else {
        await CategoriesService.create(payload);
      }
      const cats = await CategoriesService.getAllCategories();
      setCategories(cats);
      resetCatForm();
      setShowCatForm(false);
    } catch (e) {
      setCatError(e?.message || 'Erreur sauvegarde catégorie');
    } finally {
      setCatLoading(false);
    }
  };
  const deleteCategorie = async (id) => {
    try {
      setCatLoading(true);
      await CategoriesService.remove(id);
      const cats = await CategoriesService.getAllCategories();
      setCategories(cats);
      if (catForm.id === id) resetCatForm();
      setCatSelectedIds(prev => prev.filter(x => x !== id));
    } catch (e) {
      setCatError(e?.message || 'Erreur suppression catégorie');
    } finally {
      setCatLoading(false);
    }
  };

  // Gestion image Catégorie: URL / Upload / Drag & Drop
  const handleCatImageUpload = async (e) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;
      const url = await AdminService.uploadImage(file, token);
      setCatForm(prev => ({ ...prev, image: url }));
    } catch (err) {
      setCatError(err?.message || 'Upload image échoué');
    }
  };
  const handleCatImageDrop = async (e) => {
    e.preventDefault();
    try {
      const file = e.dataTransfer.files?.[0];
      if (!file) return;
      const url = await AdminService.uploadImage(file, token);
      setCatForm(prev => ({ ...prev, image: url }));
    } catch (err) {
      setCatError(err?.message || 'Upload image échoué');
    }
  };
  const removeCatImage = async () => {
    try {
      const val = catForm.image;
      if (typeof val === 'string' && /\/uploads\//.test(val)) {
        try { await AdminService.deleteImageByUrl(val, token); } catch (_) { /* no-op */ }
      }
    } catch (_) { /* no-op */ }
    setCatForm(prev => ({ ...prev, image: '' }));
  };

  // Sélection multiple & suppression groupée - Catégories
  const catAllSelected = categories.length > 0 && catSelectedIds.length === categories.length;
  const toggleCatSelected = (id) => {
    setCatSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const selectAllCategories = () => setCatSelectedIds(categories.map(c => c._id));
  const deselectAllCategories = () => setCatSelectedIds([]);
  const handleCatBulkDelete = async () => {
    try {
      setCatLoading(true);
      await Promise.all(catSelectedIds.map(id => CategoriesService.remove(id)));
      const cats = await CategoriesService.getAllCategories();
      setCategories(cats);
      setCatSelectedIds([]);
    } catch (e) {
      setCatError(e?.message || 'Erreur suppression groupée catégories');
    } finally {
      setCatLoading(false);
    }
  };

  // Basculer visibilité d'une catégorie (Enable)
  const toggleCategoryEnable = async (cat, nextEnabled) => {
    try {
      setCatLoading(true);
      setCatError(null);
      await CategoriesService.update(cat._id, { enable: nextEnabled });
      setCategories(prev => prev.map(c => (c._id === cat._id ? { ...c, enable: nextEnabled } : c)));
      setSelectedCategory(prev => (prev && prev._id === cat._id ? { ...prev, enable: nextEnabled } : prev));
    } catch (e) {
      setCatError(e?.message || 'Erreur mise à jour visibilité catégorie');
    } finally {
      setCatLoading(false);
    }
  };

  const openEditor = (section, property, value, currentType = 'overall', categorieId = null) => {
    setEditor({ section, property, value, type: currentType, categorieId });
    setShowEditor(true);
  };

  const openFullEditor = (tpl) => {
    setSelectedTemplate(tpl);
    const initialObj = tpl?.texte || {};
    const initial = JSON.stringify(initialObj, null, 2);
    setFullTexteJSON(initial);
    setFullTexte(initialObj);
    setFullName(tpl?.name || tpl?.categorie?.nom || initialObj?.hero?.titre_principal || '');
    setNameEdited(false);
    setFullActif(!!tpl?.actif);
    setShowFullEditor(true);
  };

  // Ouvrir l'éditeur complet en mode création
  const openCreateEditor = (initialType = 'overall') => {
    const newId = 'NEW';
    const initialTexte = { garanties: { titre: '', images: [], liste: [] } };
    const resolvedType = initialType === 'all' ? 'overall' : initialType;
    const tpl = { _id: newId, type: resolvedType, categorie: null, actif: false, name: '', texte: initialTexte, __isNew: true };
    setSelectedTemplate(tpl);
    setFullTexteJSON(JSON.stringify(initialTexte, null, 2));
    setFullTexte(initialTexte);
    setFullName('');
    setNameEdited(false);
    setFullActif(false);
    setTypeChanges(prev => ({ ...prev, [newId]: { type: resolvedType, categorieId: resolvedType === 'category' ? '' : null } }));
    setShowFullEditor(true);
  };

  // Verrouiller le scroll du background quand une modale est ouverte, et activer
  // le scroll interne de la modale via overflow-y-auto.
  useEffect(() => {
    const modalOpen = showEditor || showFullEditor || showDetails;
    if (modalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showEditor, showFullEditor, showDetails]);

  // Initialiser automatiquement le Name en mode création
  useEffect(() => {
    if (!showFullEditor || !selectedTemplate?.__isNew) return;
    const pending = typeChanges[selectedTemplate._id] || { type: selectedTemplate.type, categorieId: null };
    if (pending.type === 'category') {
      const cat = categories.find(c => c._id === pending.categorieId);
      if (cat && !nameEdited) setFullName(cat.nom || '');
    } else {
      const heroTitle = fullTexte?.hero?.titre_principal || '';
      if (heroTitle && !nameEdited) setFullName(prev => prev || heroTitle);
    }
  }, [showFullEditor, selectedTemplate, typeChanges, categories, fullTexte, nameEdited]);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      setLoading(true);
      const url = await AdminService.uploadImage(file, token);
      setEditor(prev => ({
        ...prev,
        value: Array.isArray(prev.value) ? [...prev.value, url] : url
      }));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  // Create a new category template
  const handleCreateCategoryTemplate = async () => {
    if (!newCategoryId) {
      setError('Veuillez choisir une catégorie');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      await AdminService.createCategoryTemplate(newCategoryId, token);
      const list = await AdminService.getTemplates('category', token);
      setTemplates(list);
      setSelectedIds([]);
      setNewCategoryId('');
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  // Delete a template
  const handleDeleteTemplate = async (tpl) => {
    try {
      setLoading(true);
      setError(null);
      await AdminService.deleteTemplate(tpl._id, token);
      const list = await getTemplatesByType(type);
      setTemplates(list);
      setSelectedIds(prev => prev.filter(id => id !== tpl._id));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const selectAll = () => {
    const ids = templates.map(t => t._id);
    setSelectedIds(ids);
  };

  const deselectAll = () => setSelectedIds([]);

  const allSelected = templates.length > 0 && selectedIds.length === templates.length;

  const handleBulkDelete = async () => {
    try {
      setLoading(true);
      setError(null);
      await Promise.all(selectedIds.map(id => AdminService.deleteTemplate(id, token)));
      const list = await getTemplatesByType(type);
      setTemplates(list);
      setSelectedIds([]);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  // Drag & drop pour l'éditeur de propriétés (single/array)
  const handleDropFiles = async (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer?.files || []);
    if (!files.length) return;
    try {
      setLoading(true);
      const uploaded = [];
      for (const f of files) {
        const url = await AdminService.uploadImage(f, token);
        uploaded.push(url);
      }
      setEditor(prev => ({
        ...prev,
        value: Array.isArray(prev.value) ? [...prev.value, ...uploaded] : uploaded[0]
      }));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const preventDragDefaults = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const addImageLink = () => {
    if (!imageUrlInput) return;
    setEditor(prev => ({
      ...prev,
      value: Array.isArray(prev.value) ? [...prev.value, imageUrlInput] : imageUrlInput
    }));
    setImageUrlInput('');
  };

  const removeImageAtIndex = async (idx) => {
    try {
      const val = editor.value[idx];
      if (typeof val === 'string' && /\/uploads\//.test(val)) {
        try { await AdminService.deleteImageByUrl(val, token); } catch (_) { /* no-op */ }
      }
    } catch (_) { /* no-op */ }
    setEditor(prev => ({
      ...prev,
      value: prev.value.filter((_, i) => i !== idx)
    }));
  };

  const clearSingleImage = async () => {
    try {
      const val = editor.value;
      if (typeof val === 'string' && /\/uploads\//.test(val)) {
        try { await AdminService.deleteImageByUrl(val, token); } catch (_) { /* no-op */ }
      }
    } catch (_) { /* no-op */ }
    setEditor(prev => ({ ...prev, value: '' }));
  };

  // ----- Helpers pour l'affichage lisible des détails (sans JSON brut)
  const isImageUrl = (s) => typeof s === 'string' && (s.startsWith('http') || s.startsWith('/uploads/'));
  const renderValue = (val) => {
    if (val === null || val === undefined) return (<span className="text-gray-400">—</span>);
    if (typeof val === 'string') {
      if (isImageUrl(val)) {
        return (
          <div className="flex items-center gap-2">
            <img src={resolveImageUrl(val)} alt="img" className="w-16 h-16 object-cover rounded" />
            <a href={resolveImageUrl(val)} target="_blank" rel="noreferrer" className="text-blue-400 underline break-all">{val}</a>
          </div>
        );
      }
      return (<p className="text-sm text-white whitespace-pre-wrap">{val}</p>);
    }
    if (Array.isArray(val)) {
      return (
        <div className="space-y-2">
          {val.map((item, idx) => (
            <div key={idx} className="border border-gray-700 rounded p-2">
              {renderValue(item)}
            </div>
          ))}
        </div>
      );
    }
    if (typeof val === 'object') {
      return (
        <div className="space-y-3">
          {Object.entries(val).map(([k, v]) => (
            <div key={k}>
              <div className="text-gray-400 text-xs uppercase tracking-wide">{k}</div>
              <div className="mt-1">{renderValue(v)}</div>
            </div>
          ))}
        </div>
      );
    }
    return (<span className="text-sm text-white">{String(val)}</span>);
  };

  const saveProperty = async () => {
    try {
      setLoading(true);
      await AdminService.updateProperty(editor.type, editor.section, editor.property, editor.value, token, editor.categorieId);
      const list = await AdminService.getTemplates(editor.type, token);
      setTemplates(list);
      setShowEditor(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const saveFullTemplate = async () => {
    try {
      setLoading(true);
      setError(null);
      // Utiliser l'objet fullTexte (formulaire)
      const payload = { texte: fullTexte || {}, actif: fullActif, name: fullName };
      const isNew = !!selectedTemplate?.__isNew;
      if (isNew) {
        const pendingNew = typeChanges[selectedTemplate._id] || { type: selectedTemplate.type, categorieId: null };
        const finalType = pendingNew.type;
        if (finalType === 'overall') {
          await AdminService.createOverallTemplate(payload, token);
        } else if (finalType === 'category') {
          const catId = pendingNew.categorieId || '';
          if (!catId) throw new Error('Veuillez choisir une catégorie');
          await AdminService.createCategoryTemplate(catId, token);
          const listAfterCreate = await AdminService.getTemplates('category', token);
          const created = listAfterCreate.find(t => t?.categorie?._id === catId);
          if (created?._id) {
            await AdminService.updateTemplate(created._id, payload, token);
          }
        }
        const list = await getTemplatesByType(type);
        setTemplates(list);
        const sync = {};
        list.forEach(t => { sync[t._id] = { type: t.type, categorieId: t?.categorie?._id || null }; });
        setTypeChanges(sync);
        setShowFullEditor(false);
        setSelectedTemplate(null);
        setFullTexte(null);
      } else {
        // Appliquer éventuel changement de type/catégorie avant la sauvegarde du contenu
        const pending = typeChanges[selectedTemplate._id] || { type: selectedTemplate.type, categorieId: selectedTemplate?.categorie?._id || null };
        const hasTypeChange = (
          pending.type !== selectedTemplate.type ||
          (pending.type === 'category' && (pending.categorieId || '') !== (selectedTemplate?.categorie?._id || '')) ||
          (pending.type === 'overall' && (selectedTemplate?.categorie?._id || null) !== null)
        );
        if (hasTypeChange) {
          if (pending.type === 'category' && !(pending.categorieId)) {
            throw new Error('Veuillez choisir une catégorie pour le type "category"');
          }
          await AdminService.changeTemplateType(selectedTemplate._id, pending.type, token, pending.categorieId || null);
        }
        await AdminService.updateTemplate(selectedTemplate._id, payload, token);
        const list = await getTemplatesByType(type);
        setTemplates(list);
        const sync = {};
        list.forEach(t => { sync[t._id] = { type: t.type, categorieId: t?.categorie?._id || null }; });
        setTypeChanges(sync);
        setShowFullEditor(false);
        setSelectedTemplate(null);
        setFullTexte(null);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const setPendingType = (id, newType) => {
    setTypeChanges(prev => ({
      ...prev,
      [id]: { type: newType, categorieId: newType === 'category' ? (prev[id]?.categorieId || '' ) : null }
    }));
  };

  const setPendingCategorie = (id, categorieId) => {
    setTypeChanges(prev => ({
      ...prev,
      [id]: { type: prev[id]?.type || 'category', categorieId }
    }));
  };

  const applyTypeChange = async (tpl) => {
    const pending = typeChanges[tpl._id] || { type: tpl.type, categorieId: tpl?.categorie?._id || null };
    try {
      setLoading(true);
      if (pending.type === 'category' && !(pending.categorieId)) {
        setError('Veuillez choisir une catégorie avant de valider le type "category"');
        setLoading(false);
        return;
      }
      await AdminService.changeTemplateType(tpl._id, pending.type, token, pending.categorieId || null);
      const list = await getTemplatesByType(type);
      setTemplates(list);
      const sync = {};
      list.forEach(t => { sync[t._id] = { type: t.type, categorieId: t?.categorie?._id || null }; });
      setTypeChanges(sync);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      const t = await AdminService.login(String(password || '').trim());
      localStorage.setItem('admin_token', t);
      setToken(t);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="h-screen bg-gray-900 flex items-center justify-center">
        <form onSubmit={handleLogin} className="bg-gray-800 p-8 rounded-xl w-full max-w-md shadow-xl text-center">
          <h1 className="text-white text-2xl font-bold mb-4">Admin 2RENOV</h1>
          <p className="text-gray-400 mb-6">Veuillez entrer le mot de passe pour accéder à l'admin.</p>
          {error && <div className="text-red-400 mb-4">{error}</div>}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            className="w-full p-3 rounded bg-gray-700 text-white mb-4 focus:outline-none"
          />
          <button type="submit" className="w-full bg-primary text-white py-3 rounded hover:bg-primary/90">
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="w-full px-2 md:px-3 py-8">
        {/* Barre d'en-tête: flèche à gauche, titre centré absolu, logout à droite */}
        <div className="flex items-center justify-between mb-8">
          <div className="relative flex items-center justify-between w-full mx-4 md:mx-10">
            <div className="flex justify-start">
              {adminSection !== null && (
                <button
                  className="rounded-full w-8 h-8 flex items-center justify-center bg-gray-800 border border-gray-600 text-white hover:bg-gray-700"
                  title="Retour aux sections"
                  aria-label="Retour aux sections"
                  onClick={() => setAdminSection(null)}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                </button>
              )}
            </div>
            <div className="absolute left-1/2 -translate-x-1/2">
              <h1 className="text-3xl font-bold text-center">
                {adminSection === null
                  ? 'Administration'
                  : (
                    adminSection === 'templates' ? 'Contenu'
                    : adminSection === 'ville' ? 'Ville'
                    : adminSection === 'departement' ? 'Département'
                    : adminSection === 'user' ? 'User'
                    : adminSection === 'prestation' ? 'Prestation'
                    : adminSection === 'devis' ? 'Devis'
                    : adminSection === 'categorie' ? 'Catégorie'
                    : adminSection === 'accueil' ? 'Accueil'
                    : adminSection === 'apropos' ? 'À propos'
                    : adminSection === 'pages' ? 'Pages'
                    : adminSection === 'page-services' ? 'Services'
                    : adminSection === 'page-professionnel' ? 'Professionnel'
                    : adminSection === 'page-contact' ? 'Contact'
                    : adminSection === 'page-dashboard' ? 'Dashboard'
                    : 'Administration'
                  )}
              </h1>
            </div>
            <div className="flex justify-end w-full">
              {adminSection === null && (
                <button
                  className="rounded-sm h-8 px-4 flex items-center justify-center bg-red-600 text-white border border-red-700 hover:bg-red-700"
                  title="Se déconnecter"
                  aria-label="Se déconnecter"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>
        {/* Section Contenu: actions + filtres sur une seule ligne, largeur de la page */}
        {adminSection === 'templates' && (
          <div className="mt-6">
            <div className="bg-gray-800 rounded-xl p-6 mx-4 md:mx-10">
              {/* Ligne combinée: gauche sélection/poubelle, milieu filtres, droite + */}
              <div className="mb-4 flex items-center justify-between gap-3">
                {/* Gauche: sélection + poubelle */}
                <div className="flex items-center gap-2">
                  <span className="text-xs text-gray-400">{selectedIds.length}</span>
                  {!allSelected ? (
                    <button
                      className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                      title="Tout sélectionner"
                      aria-label="Tout sélectionner"
                      onClick={selectAll}
                    >
                      ✓
                    </button>
                  ) : (
                    <button
                      className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                      title="Tout désélectionner"
                      aria-label="Tout désélectionner"
                      onClick={deselectAll}
                    >
                      ☐
                    </button>
                  )}
                  <button
                    className={`rounded-full w-8 h-8 flex items-center justify-center ${selectedIds.length === 0 ? 'bg-gray-700 text-gray-400 cursor-not-allowed' : 'bg-red-600 text-white hover:bg-red-700'}`}
                    disabled={selectedIds.length === 0}
                    title="Supprimer la sélection"
                    aria-label="Supprimer la sélection"
                    onClick={() => setShowBulkDeleteConfirm(true)}
                  >
                    🗑️
                  </button>
                </div>
                {/* Milieu: Filtres */}
                <div className="flex items-center justify-center gap-3">
                  <button className={`px-3 py-2 rounded ${type === 'all' ? 'bg-primary text-white' : 'border border-gray-500'}`} onClick={() => setType('all')}>Tout</button>
                  <button className={`px-3 py-2 rounded ${type === 'overall' ? 'bg-primary text-white' : 'border border-gray-500'}`} onClick={() => setType('overall')}>Overall</button>
                  <button className={`px-3 py-2 rounded ${type === 'category' ? 'bg-primary text-white' : 'border border-gray-500'}`} onClick={() => setType('category')}>Catégorie</button>
                </div>
                {/* Droite: + / − */}
                <div className="flex items-center">
                  <button
                    className="rounded-full bg-primary text-white w-8 h-8 flex items-center justify-center hover:bg-primary/90"
                    title={showFullEditor && selectedTemplate?.__isNew ? 'Fermer' : 'Ajouter'}
                    aria-label={showFullEditor && selectedTemplate?.__isNew ? 'Fermer' : 'Ajouter'}
                    onClick={() => {
                      if (showFullEditor && selectedTemplate?.__isNew) {
                        setShowFullEditor(false);
                        setSelectedTemplate(null);
                      } else {
                        openCreateEditor(type);
                      }
                    }}
                  >{showFullEditor && selectedTemplate?.__isNew ? '−' : '+'}
                  </button>
                </div>
              </div>
              {/* Barre de recherche (style Ville) */}
              <div className="mb-4 flex items-center gap-3">
                <input
                  type="text"
                  className="w-full p-2 rounded bg-gray-700 text-white"
                  placeholder="Rechercher un template (nom, catégorie, titre hero)"
                  value={templatesQuery}
                  onChange={(e) => setTemplatesQuery(e.target.value)}
                />
                {loading && <span className="text-sm text-gray-400">Chargement…</span>}
              </div>
              {/* Liste des templates (style aligné sur Ville/Département) */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                {(templates.filter((tpl) => {
                  const heroTitle = tpl?.texte?.hero?.titre_principal || '';
                  const title = tpl?.categorie?.nom || 'Overall';
                  const displayName = tpl?.name || title || heroTitle;
                  const q = (templatesQuery||'').toLowerCase();
                  return (
                    displayName.toLowerCase().includes(q) ||
                    title.toLowerCase().includes(q) ||
                    heroTitle.toLowerCase().includes(q)
                  );
                })).map((tpl) => {
                  const heroTitle = tpl?.texte?.hero?.titre_principal || '';
                  const title = tpl?.categorie?.nom || 'Overall';
                  const displayName = tpl?.name || title || heroTitle;
                  const categoryImage = (tpl?.type === 'category' && tpl?.categorie && tpl.categorie.image) ? tpl.categorie.image : null;
                  const cardImage = tpl?.texte?.hero?.background_image
                    || (Array.isArray(tpl?.texte?.specialites?.images) && tpl.texte.specialites.images[0])
                    || (Array.isArray(tpl?.texte?.solutions_innovantes?.images) && tpl.texte.solutions_innovantes.images[0])
                    || categoryImage
                    || '';
                  return (
                    <div
                      key={tpl._id}
                      className={`relative bg-gray-700 rounded p-3 pb-10 flex items-center justify-between ${selectedIds.includes(tpl._id) ? 'ring-1 ring-primary/50' : ''}`}
                    >
                      <div className="flex items-center gap-3">
                        <button
                          className="rounded-full border border-gray-500 w-6 h-6 flex items-center justify-center text-gray-300 hover:bg-gray-600"
                          title={selectedIds.includes(tpl._id) ? 'Désélectionner' : 'Sélectionner'}
                          aria-label={selectedIds.includes(tpl._id) ? 'Désélectionner' : 'Sélectionner'}
                          onClick={() => toggleSelect(tpl._id)}
                        >
                          {selectedIds.includes(tpl._id) ? '✓' : '☐'}
                        </button>
                        {cardImage ? (
                          <img
                            src={resolveImageUrl(cardImage)}
                            alt={displayName}
                            className="w-16 h-16 rounded object-cover"
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                          />
                        ) : (
                          <div className="w-16 h-16 rounded bg-gray-600 flex items-center justify-center text-gray-300 text-xs">N/A</div>
                        )}
                        <div className="flex flex-col">
                          <div className="text-sm font-semibold">{displayName}</div>
                          <div className="text-xs text-gray-400">Type: {tpl.type} • Actif: {tpl.actif ? 'Oui' : 'Non'}</div>
                          <div className="text-xs text-gray-400">Hero: {heroTitle}</div>
                          <div className="text-xs text-gray-400">ObjectID: {tpl._id}</div>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button
                          className="border border-gray-500 text-white px-2 py-1 rounded"
                          onClick={(e) => { e.stopPropagation(); setSelectedTemplate(tpl); setShowFullEditor(false); setShowDetails(true); }}
                        >Voir détail</button>
                        <button
                          className="border border-gray-500 text-white px-2 py-1 rounded"
                          onClick={(e) => { e.stopPropagation(); openFullEditor(tpl); }}
                        >Modifier</button>
                      </div>
                      {/* Icône poubelle en bas à droite, sans bordure */}
                      <button
                        className="absolute bottom-2 right-2 text-red-400 hover:text-white hover:bg-red-500 rounded-full p-2"
                        title="Supprimer"
                        aria-label="Supprimer"
                        onClick={(e) => { e.stopPropagation(); setDeleteTarget(tpl); setShowDeleteConfirm(true); }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path d="M9 3h6a1 1 0 011 1v1h4a1 1 0 110 2h-1v12a3 3 0 01-3 3H8a3 3 0 01-3-3V7H4a1 1 0 110-2h4V4a1 1 0 011-1zm2 3h2V5h-2v1zM7 7v12a1 1 0 001 1h8a1 1 0 001-1V7H7z" />
                        </svg>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ECRAN DE SELECTION DES SECTIONS */}
      {adminSection === null && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl px-6 pt-6 pb-4 mx-4 md:mx-10 mb-8">
            <h2 className="text-xl font-bold mb-4">Choisir une section</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-16">
              {/* Sections d'administration principales */}
              {/* Pages retiré: édition des pages via /admin/<page> */}
              {/* Accueil retiré du menu principal, géré via routes admin */}
              <button className="bg-gray-700 hover:bg-gray-600 rounded-xl p-6 text-left" onClick={() => setAdminSection('templates')}>
                <div className="text-lg font-semibold mb-1">Contenu</div>
                <div className="text-sm text-gray-300">Templates overall et par catégorie.</div>
              </button>
              <button className="bg-gray-700 hover:bg-gray-600 rounded-xl p-6 text-left" onClick={() => setAdminSection('ville')}>
                <div className="text-lg font-semibold mb-1">Ville</div>
                <div className="text-sm text-gray-300">Gestion des villes et leur département.</div>
              </button>
              <button className="bg-gray-700 hover:bg-gray-600 rounded-xl p-6 text-left" onClick={() => setAdminSection('departement')}>
                <div className="text-lg font-semibold mb-1">Département</div>
                <div className="text-sm text-gray-300">Gestion des départements.</div>
              </button>
              <button className="bg-gray-700 hover:bg-gray-600 rounded-xl p-6 text-left" onClick={() => setAdminSection('user')}>
                <div className="text-lg font-semibold mb-1">User</div>
                <div className="text-sm text-gray-300">Gestion des utilisateurs (à venir).</div>
              </button>
              <button className="bg-gray-700 hover:bg-gray-600 rounded-xl p-6 text-left" onClick={() => setAdminSection('prestation')}>
                <div className="text-lg font-semibold mb-1">Prestation</div>
                <div className="text-sm text-gray-300">Gestion des prestations (à venir).</div>
              </button>
              <button className="bg-gray-700 hover:bg-gray-600 rounded-xl p-6 text-left" onClick={() => setAdminSection('devis')}>
                <div className="text-lg font-semibold mb-1">Devis</div>
                <div className="text-sm text-gray-300">Gestion des devis (à venir).</div>
              </button>
      <button className="bg-gray-700 hover:bg-gray-600 rounded-xl p-6 text-left" onClick={() => setAdminSection('categorie')}>
        <div className="text-lg font-semibold mb-1">Catégorie</div>
        <div className="text-sm text-gray-300">Gestion des catégories (à venir).</div>
      </button>
      {/* Pages déplacé en premier ci-dessus */}
      {/* Supprimer les raccourcis dédiés (gérés depuis 'Pages') */}
            </div>
          </div>
        </div>
      )}

      {/* Supprimer la section Accueil (gérée via PageContent dans 'Pages') */}

      {/* SECTION PAGES (PageContent) */}
      {false && adminSection === 'pages' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mb-6 mx-4 md:mx-10">
            <div className="mb-4 flex items-center justify-between gap-3">
              <div className="text-lg font-semibold">Pages</div>
              <div className="flex items-center gap-2">
                <button
                  className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => setAdminSection(null)}
                >
                  ←
                </button>
              </div>
            </div>
            {/* Liste des pages */}
            <div className="mb-4">
              <div className="text-sm text-gray-300 mb-2">Sélectionner une page pour Modifier ou Voir détails</div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {DEFAULT_PAGES.map(slug => {
                  const existing = pagesList.find(p => p.slug === slug);
                  const title = existing?.title || slug.charAt(0).toUpperCase() + slug.slice(1);
                  return (
                    <div key={slug} className="bg-gray-700 rounded p-4 flex items-center justify-between">
                      <div>
                        <div className="text-sm font-semibold">{title}</div>
                        <div className="text-xs text-gray-400">Slug: {slug} • {existing ? (existing.actif ? 'Actif' : 'Inactif') : 'Non créé'}</div>
                        {existing && (
                          <div className="text-xs text-gray-400 mt-1">
                            Sections: {Array.isArray(existing.sections) ? existing.sections.length : 0} • Meta: {Object.keys(existing.meta || {}).length}
                          </div>
                        )}
                      </div>
                      <div className="flex gap-2">
                        {/* Voir détail à gauche */}
                        <button
                          className="border border-gray-500 text-white px-2 py-1 rounded"
                          onClick={async () => {
                            try {
                              setPagesLoading(true);
                              setPagesError(null);
                          if (slug === 'accueil' || slug === 'apropos') {
                            const desiredName = slug === 'accueil' ? 'Accueil' : 'A propos';
                            const list = await AdminService.getTemplates('overall', token);
                            const tpl = list.find(t => (t?.name || '').toLowerCase() === desiredName.toLowerCase())
                              || list.find(t => ((t?.texte?.hero?.titre_principal) || '').toLowerCase() === desiredName.toLowerCase());
                        if (!tpl) throw new Error(`Template ${desiredName} introuvable`);
                        setDetailsOverallTemplate(tpl);
                        setSelectedPage({ slug, title: desiredName, actif: tpl?.actif });
                        setOverallDetailsForm({
                          hero: {
                            titre_principal: tpl?.texte?.hero?.titre_principal || desiredName,
                            sous_titre: tpl?.texte?.hero?.sous_titre || '',
                            description: tpl?.texte?.hero?.description || '',
                            bouton_principal: tpl?.texte?.hero?.bouton_principal || '',
                            bouton_secondaire: tpl?.texte?.hero?.bouton_secondaire || '',
                            background_image: tpl?.texte?.hero?.background_image || ''
                          }
                        });
                        // Charger également le PageContent pour afficher/éditer les sections Accueil
                        try {
                          const pageDoc = await AdminService.getPage(slug, token);
                          setPageForm({
                            slug: pageDoc.slug,
                            title: pageDoc.title || desiredName,
                            actif: pageDoc.actif ?? tpl?.actif ?? true,
                            meta: pageDoc.meta || {},
                            sections: Array.isArray(pageDoc.sections) ? pageDoc.sections : []
                          });
                        } catch (e) {
                          setPageForm({ slug, title: desiredName, actif: tpl?.actif ?? true, meta: {}, sections: [] });
                        }
                        setPageDetailsEditMode(false);
                        setShowDetails(true);
                      } else {
                                const pageDoc = await AdminService.getPage(slug, token);
                                setSelectedPage(pageDoc);
                                setPageForm({
                                  slug: pageDoc.slug,
                                  title: pageDoc.title || title,
                                  actif: !!pageDoc.actif,
                                  meta: pageDoc.meta || {},
                                  sections: Array.isArray(pageDoc.sections) ? pageDoc.sections : []
                                });
                                setDetailsOverallTemplate(null);
                                setPageDetailsEditMode(false);
                                setShowPageEditor(false);
                                setShowDetails(true);
                              }
                            } catch (err) {
                              setPagesError(err?.message || 'Erreur affichage page');
                            } finally {
                              setPagesLoading(false);
                            }
                          }}
                        >Voir détail</button>
                        {/* Modifier à droite */}
                        <button
                          className="border border-gray-500 text-white px-2 py-1 rounded"
                          onClick={async () => {
                            try {
                              setPagesLoading(true);
                              setPagesError(null);
                              if (slug === 'accueil' || slug === 'apropos') {
                                const desiredName = slug === 'accueil' ? 'Accueil' : 'A propos';
                                const list = await AdminService.getTemplates('overall', token);
                                const tpl = list.find(t => (t?.name || '').toLowerCase() === desiredName.toLowerCase())
                                  || list.find(t => ((t?.texte?.hero?.titre_principal) || '').toLowerCase() === desiredName.toLowerCase());
                                if (!tpl) throw new Error(`Template ${desiredName} introuvable`);
                                setDetailsOverallTemplate(null);
                                setQuickEditForm({
                                  slug,
                                  title: desiredName,
                                  name: tpl?.name || desiredName,
                                  actif: !!tpl?.actif,
                                  hero: {
                                    titre_principal: tpl?.texte?.hero?.titre_principal || desiredName,
                                    sous_titre: tpl?.texte?.hero?.sous_titre || '',
                                    background_image: tpl?.texte?.hero?.background_image || ''
                                  }
                                });
                                setShowQuickEdit(true);
                          } else {
                                let pageDoc;
                                try {
                                  pageDoc = await AdminService.getPage(slug, token);
                                } catch (e) {
                                  pageDoc = await AdminService.upsertPage({ slug, title }, token);
                                }
                                setSelectedPage(pageDoc);
                                // Quick edit pour éléments principaux
                                const heroSec = (Array.isArray(pageDoc.sections) ? pageDoc.sections : []).find(s => (s.key === 'hero' || s.type === 'hero')) || {};
                                const heroData = heroSec.data || {};
                                setQuickEditForm({
                                  slug: pageDoc.slug,
                                  title: pageDoc.title || title,
                                  name: pageDoc.title || title,
                                  actif: !!pageDoc.actif,
                                  hero: {
                                    titre_principal: (heroData?.title?.fr) || heroSec.title || '',
                                    sous_titre: (heroData?.subtitle?.fr) || '',
                                    background_image: heroData?.background_image || ''
                                  }
                                });
                                setShowQuickEdit(true);
                          }
                            } catch (err) {
                              setPagesError(err?.message || 'Erreur chargement page');
                            } finally {
                              setPagesLoading(false);
                            }
                          }}
                        >Modifier</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {pagesLoading && <span className="text-sm text-gray-400">Chargement…</span>}
            {pagesError && <div className="text-red-400 mb-3">{pagesError}</div>}

            {/* Éditeur de page simple */}
            {showPageEditor && selectedPage && (
              <div className="bg-gray-700 rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Slug</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={pageForm.slug} readOnly />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Titre</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={pageForm.title} onChange={(e) => setPageForm(prev => ({ ...prev, title: e.target.value }))} />
                  </div>
                  <div className="flex items-end gap-2">
                    <label className="inline-flex items-center gap-2">
                      <input type="checkbox" checked={pageForm.actif} onChange={(e) => setPageForm(prev => ({ ...prev, actif: e.target.checked }))} />
                      <span className="text-sm text-gray-300">Actif</span>
                    </label>
                    <button className="bg-primary text-white px-4 py-2 rounded" onClick={async () => {
                      try {
                        setPagesLoading(true);
                        setPagesError(null);
                        const updated = await AdminService.upsertPage(pageForm, token);
                        setSelectedPage(updated);
                        setPagesList(prev => {
                          const others = prev.filter(p => p.slug !== updated.slug);
                          return [...others, updated];
                        });
                      } catch (err) {
                        setPagesError(err?.message || 'Sauvegarde échouée');
                      } finally {
                        setPagesLoading(false);
                      }
                    }}>Enregistrer</button>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="font-semibold mb-2">Meta</div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Title (FR)</label>
                      <input
                        className="w-full p-2 rounded bg-gray-600 text-white"
                        value={(pageForm.meta?.title?.fr) || ''}
                        onChange={(e) => setPageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            title: { ...((prev.meta && prev.meta.title) || {}), fr: e.target.value }
                          }
                        }))}
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Title (EN)</label>
                      <input
                        className="w-full p-2 rounded bg-gray-600 text-white"
                        value={(pageForm.meta?.title?.en) || ''}
                        onChange={(e) => setPageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            title: { ...((prev.meta && prev.meta.title) || {}), en: e.target.value }
                          }
                        }))}
                      />
                    </div>
                  </div>
                  <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Description (FR)</label>
                      <textarea
                        className="w-full p-2 rounded bg-gray-600 text-white h-20"
                        value={(pageForm.meta?.description?.fr) || ''}
                        onChange={(e) => setPageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            description: { ...((prev.meta && prev.meta.description) || {}), fr: e.target.value }
                          }
                        }))}
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Description (EN)</label>
                      <textarea
                        className="w-full p-2 rounded bg-gray-600 text-white h-20"
                        value={(pageForm.meta?.description?.en) || ''}
                        onChange={(e) => setPageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            description: { ...((prev.meta && prev.meta.description) || {}), en: e.target.value }
                          }
                        }))}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="font-semibold mb-2">Sections</div>
                  <div className="space-y-3">
                    {(pageForm.sections || []).map((sec, idx) => (
                      <div key={sec.key || idx} className="bg-gray-600 rounded p-3">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Identifiant interne (section)</label>
                            <input className="w-full p-2 rounded bg-gray-500 text-white" value={sec.key || ''} onChange={(e) => {
                              const copy = [...pageForm.sections];
                              copy[idx] = { ...sec, key: e.target.value };
                              setPageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Type</label>
                            <input className="w-full p-2 rounded bg-gray-500 text-white" value={sec.type || ''} onChange={(e) => {
                              const copy = [...pageForm.sections];
                              copy[idx] = { ...sec, type: e.target.value };
                              setPageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Titre</label>
                            <input className="w-full p-2 rounded bg-gray-500 text-white" value={sec.title || ''} onChange={(e) => {
                              const copy = [...pageForm.sections];
                              copy[idx] = { ...sec, title: e.target.value };
                              setPageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Ordre</label>
                            <input type="number" className="w-full p-2 rounded bg-gray-500 text-white" value={sec.order || 0} onChange={(e) => {
                              const copy = [...pageForm.sections];
                              copy[idx] = { ...sec, order: Number(e.target.value) };
                              setPageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                        </div>
                        <div className="mt-2 flex items-center gap-2">
                          <label className="inline-flex items-center gap-2">
                            <input type="checkbox" checked={!!sec.actif} onChange={(e) => {
                              const copy = [...pageForm.sections];
                              copy[idx] = { ...sec, actif: e.target.checked };
                              setPageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                            <span className="text-sm text-gray-300">Actif</span>
                          </label>
                          <button className="border border-gray-400 text-white px-2 py-1 rounded" onClick={async () => {
                            try {
                              setPagesLoading(true);
                              setPagesError(null);
                              const updated = await AdminService.upsertPageSection(pageForm.slug, pageForm.sections[idx], token);
                              setSelectedPage(updated);
                              setPageForm(prev => ({ ...prev, sections: updated.sections }));
                            } catch (err) {
                              setPagesError(err?.message || 'Sauvegarde section échouée');
                            } finally {
                              setPagesLoading(false);
                            }
                          }}>Sauver section</button>
                          <button className="text-red-400 hover:text-red-300 text-sm" onClick={async () => {
                            try {
                              setPagesLoading(true);
                              setPagesError(null);
                              if (pageForm.sections[idx]?.key) {
                                const updated = await AdminService.deletePageSection(pageForm.slug, pageForm.sections[idx].key, token);
                                setSelectedPage(updated);
                                setPageForm(prev => ({ ...prev, sections: updated.sections }));
                              } else {
                                // local remove if no key
                                const copy = [...pageForm.sections];
                                copy.splice(idx, 1);
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }
                            } catch (err) {
                              setPagesError(err?.message || 'Suppression section échouée');
                            } finally {
                              setPagesLoading(false);
                            }
                          }}>Suppr.</button>
                        </div>
                        {/* Édition structurée des textes (i18n) */}
                        <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Title (FR)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.title?.fr) || ''}
                              onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.title = { ...(nextData.title || {}), fr: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Title (EN)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.title?.en) || ''}
                              onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.title = { ...(nextData.title || {}), en: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Background Image (URL)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              placeholder="/uploads/filename.jpg ou URL complète"
                              value={(sec.data?.background_image) || ''}
                              onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.background_image = e.target.value;
                                copy[idx] = { ...sec, data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Subtitle (FR)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.subtitle?.fr) || ''}
                              onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.subtitle = { ...(nextData.subtitle || {}), fr: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Subtitle (EN)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.subtitle?.en) || ''}
                              onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.subtitle = { ...(nextData.subtitle || {}), en: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Description (FR)</label>
                          <textarea
                            className="w-full p-2 rounded bg-gray-500 text-white h-20"
                            value={(sec.data?.description?.fr) || ''}
                            onChange={(e) => {
                              const copy = [...pageForm.sections];
                              const nextData = { ...(sec.data || {}) };
                              nextData.description = { ...(nextData.description || {}), fr: e.target.value };
                              copy[idx] = { ...sec, data: nextData };
                              setPageForm(prev => ({ ...prev, sections: copy }));
                            }}
                          />
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Description (EN)</label>
                          <textarea
                            className="w-full p-2 rounded bg-gray-500 text-white h-20"
                            value={(sec.data?.description?.en) || ''}
                            onChange={(e) => {
                              const copy = [...pageForm.sections];
                              const nextData = { ...(sec.data || {}) };
                              nextData.description = { ...(nextData.description || {}), en: e.target.value };
                              copy[idx] = { ...sec, data: nextData };
                              setPageForm(prev => ({ ...prev, sections: copy }));
                            }}
                          />
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Uploader une image</label>
                          <div className="flex items-center gap-2 mb-2">
                            <input
                              type="text"
                              placeholder="URL de l'image"
                              className="flex-1 bg-gray-500 text-white text-sm rounded px-2 py-1"
                              value={sec.data?.background_image || ''}
                              onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.background_image = e.target.value;
                                copy[idx] = { ...sec, data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                            <span className="text-xs text-gray-300">ou</span>
                          </div>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={async (e) => {
                              const file = e.target.files?.[0];
                              if (!file) return;
                              try {
                                setPagesLoading(true);
                                const url = await AdminService.uploadImage(file, token);
                                const copy = [...pageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.background_image = url;
                                copy[idx] = { ...sec, data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              } catch (err) {
                                setPagesError(err?.message || 'Upload image échoué');
                              } finally {
                                setPagesLoading(false);
                              }
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-3">
                    <button className="bg-primary text-white px-3 py-2 rounded" onClick={() => {
                      const copy = [...(pageForm.sections || [])];
                      copy.push({ key: `sec_${Date.now()}`, type: 'block', title: '', order: copy.length, actif: true, data: {} });
                      setPageForm(prev => ({ ...prev, sections: copy }));
                    }}>Ajouter une section</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* SECTIONS DÉDIÉES: Services / Professionnel / Contact / Dashboard / À propos */}
      {(['page-services', 'page-professionnel', 'page-contact', 'page-dashboard', 'page-apropos'].includes(adminSection)) && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mb-6 mx-4 md:mx-10">
            <div className="mb-4 flex items-center justify-between gap-3">
              <div className="text-lg font-semibold">
                {(() => {
                  const slug = getSlugFromAdminSection(adminSection);
                  return (slug ? slug.charAt(0).toUpperCase() + slug.slice(1) : '') + ' — Éditeur de page';
                })()}
              </div>
              <div className="flex items-center gap-2">
                <button
                  className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => setAdminSection('pages')}
                >
                  ←
                </button>
                {showSinglePageEditor && (
                  singlePageEditMode ? (
                    <button
                      className="bg-gray-600 hover:bg-gray-500 text-white px-3 py-2 rounded"
                      onClick={() => setSinglePageEditMode(false)}
                    >Terminer</button>
                  ) : (
                    <button
                      className="bg-primary text-white px-3 py-2 rounded"
                      onClick={() => setSinglePageEditMode(true)}
                    >Modifier</button>
                  )
                )}
              </div>
            </div>

            {singlePageLoading && <span className="text-sm text-gray-400">Chargement…</span>}
            {singlePageError && <div className="text-red-400 mb-3">{singlePageError}</div>}

            {showSinglePageEditor && singlePage && (
              <div className="bg-gray-700 rounded p-4">
                {(!singlePageEditMode && singlePageForm.slug === 'contact') && (
                  <div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                      <div className="bg-gray-600 rounded p-3">
                        <div className="text-xs text-gray-300">Slug</div>
                        <div className="text-sm text-white font-semibold">{singlePageForm.slug}</div>
                      </div>
                      <div className="bg-gray-600 rounded p-3">
                        <div className="text-xs text-gray-300">Titre</div>
                        <div className="text-sm text-white font-semibold">{singlePageForm.title}</div>
                      </div>
                      <div className="bg-gray-600 rounded p-3">
                        <div className="text-xs text-gray-300">Statut</div>
                        <div className="text-sm text-white font-semibold">{singlePageForm.actif ? 'Actif' : 'Inactif'}</div>
                      </div>
                    </div>
                    <div className="mt-4 bg-gray-600 rounded p-3">
                      <div className="font-semibold mb-2">Informations de contact</div>
                      {(() => {
                        const contactSec = (singlePageForm.sections || []).find(s => (
                          s.type === 'contact' || s.type === 'contact_info' || s.key === 'contact' || s.key === 'contact_info'
                        ));
                        const d = contactSec?.data || {};
                        return (
                          <ul className="text-sm text-gray-200 space-y-1">
                            <li>• Téléphone: {d.phone || '—'}</li>
                            <li>• Email: {d.email || '—'}</li>
                            <li>• Adresse: {d.address || '—'}</li>
                            <li>• Horaires: {d.hours || '—'}</li>
                            <li>• Carte: {d.map_embed_url || d.map_embed ? 'Définie' : '—'}</li>
                          </ul>
                        );
                      })()}
                    </div>
                  </div>
                )}
                <div className={( !singlePageEditMode && singlePageForm.slug === 'contact') ? 'hidden' : ''}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Slug</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={singlePageForm.slug} readOnly />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Titre</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={singlePageForm.title} onChange={(e) => setSinglePageForm(prev => ({ ...prev, title: e.target.value }))} />
                  </div>
                  <div className="flex items-end gap-2">
                    <label className="inline-flex items-center gap-2">
                      <input type="checkbox" checked={singlePageForm.actif} onChange={(e) => setSinglePageForm(prev => ({ ...prev, actif: e.target.checked }))} />
                      <span className="text-sm text-gray-300">Actif</span>
                    </label>
                    <button className="bg-primary text-white px-4 py-2 rounded" onClick={async () => {
                      try {
                        setSinglePageLoading(true);
                        setSinglePageError(null);
                        const updated = await AdminService.upsertPage(singlePageForm, token);
                        setSinglePage(updated);
                        setPagesList(prev => {
                          const others = prev.filter(p => p.slug !== updated.slug);
                          return [...others, updated];
                        });
                      } catch (err) {
                        setSinglePageError(err?.message || 'Sauvegarde échouée');
                      } finally {
                        setSinglePageLoading(false);
                      }
                    }}>Enregistrer</button>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="font-semibold mb-2">Meta</div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Title (FR)</label>
                      <input
                        className="w-full p-2 rounded bg-gray-600 text-white"
                        value={(singlePageForm.meta?.title?.fr) || ''}
                        onChange={(e) => setSinglePageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            title: { ...((prev.meta && prev.meta.title) || {}), fr: e.target.value }
                          }
                        }))}
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Title (EN)</label>
                      <input
                        className="w-full p-2 rounded bg-gray-600 text-white"
                        value={(singlePageForm.meta?.title?.en) || ''}
                        onChange={(e) => setSinglePageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            title: { ...((prev.meta && prev.meta.title) || {}), en: e.target.value }
                          }
                        }))}
                      />
                    </div>
                  </div>
                  <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Description (FR)</label>
                      <textarea
                        className="w-full p-2 rounded bg-gray-600 text-white h-20"
                        value={(singlePageForm.meta?.description?.fr) || ''}
                        onChange={(e) => setSinglePageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            description: { ...((prev.meta && prev.meta.description) || {}), fr: e.target.value }
                          }
                        }))}
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Meta Description (EN)</label>
                      <textarea
                        className="w-full p-2 rounded bg-gray-600 text-white h-20"
                        value={(singlePageForm.meta?.description?.en) || ''}
                        onChange={(e) => setSinglePageForm(prev => ({
                          ...prev,
                          meta: {
                            ...(prev.meta || {}),
                            description: { ...((prev.meta && prev.meta.description) || {}), en: e.target.value }
                          }
                        }))}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="font-semibold mb-2">Sections</div>
                  <div className="space-y-3">
                    {(singlePageForm.sections || []).map((sec, idx) => (
                      <div key={sec.key || idx} className="bg-gray-600 rounded p-3">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Identifiant interne (section)</label>
                            <input className="w-full p-2 rounded bg-gray-500 text-white" value={sec.key || ''} onChange={(e) => {
                              const copy = [...singlePageForm.sections];
                              copy[idx] = { ...sec, key: e.target.value };
                              setSinglePageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Type</label>
                            <input className="w-full p-2 rounded bg-gray-500 text-white" value={sec.type || ''} onChange={(e) => {
                              const copy = [...singlePageForm.sections];
                              copy[idx] = { ...sec, type: e.target.value };
                              setSinglePageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Titre</label>
                            <input className="w-full p-2 rounded bg-gray-500 text-white" value={sec.title || ''} onChange={(e) => {
                              const copy = [...singlePageForm.sections];
                              copy[idx] = { ...sec, title: e.target.value };
                              setSinglePageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                          <div>
                            <label className="block text-sm text-gray-300 mb-1">Ordre</label>
                            <input type="number" className="w-full p-2 rounded bg-gray-500 text-white" value={sec.order || 0} onChange={(e) => {
                              const copy = [...singlePageForm.sections];
                              copy[idx] = { ...sec, order: Number(e.target.value) };
                              setSinglePageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                          </div>
                        </div>
                        <div className="mt-2 flex items-center gap-2">
                          <label className="inline-flex items-center gap-2">
                            <input type="checkbox" checked={!!sec.actif} onChange={(e) => {
                              const copy = [...singlePageForm.sections];
                              copy[idx] = { ...sec, actif: e.target.checked };
                              setSinglePageForm(prev => ({ ...prev, sections: copy }));
                            }} />
                            <span className="text-sm text-gray-300">Actif</span>
                          </label>
                          <button className="border border-gray-400 text-white px-2 py-1 rounded" onClick={async () => {
                            try {
                              setSinglePageLoading(true);
                              setSinglePageError(null);
                              const updated = await AdminService.upsertPageSection(singlePageForm.slug, singlePageForm.sections[idx], token);
                              setSinglePage(updated);
                              setSinglePageForm(prev => ({ ...prev, sections: updated.sections }));
                            } catch (err) {
                              setSinglePageError(err?.message || 'Sauvegarde section échouée');
                            } finally {
                              setSinglePageLoading(false);
                            }
                          }}>Sauver section</button>
                          <button className="text-red-400 hover:text-red-300 text-sm" onClick={async () => {
                            try {
                              setSinglePageLoading(true);
                              setSinglePageError(null);
                              if (singlePageForm.sections[idx]?.key) {
                                const updated = await AdminService.deletePageSection(singlePageForm.slug, singlePageForm.sections[idx].key, token);
                                setSinglePage(updated);
                                setSinglePageForm(prev => ({ ...prev, sections: updated.sections }));
                              } else {
                                // local remove if no key
                                const copy = [...singlePageForm.sections];
                                copy.splice(idx, 1);
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              }
                            } catch (err) {
                              setSinglePageError(err?.message || 'Suppression section échouée');
                            } finally {
                              setSinglePageLoading(false);
                            }
                          }}>Suppr.</button>
                        </div>
                        {/* Édition structurée des textes (i18n) */}
                        <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Title (FR)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.title?.fr) || ''}
                              onChange={(e) => {
                                const copy = [...singlePageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.title = { ...(nextData.title || {}), fr: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Title (EN)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.title?.en) || ''}
                              onChange={(e) => {
                                const copy = [...singlePageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.title = { ...(nextData.title || {}), en: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Background Image (URL)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              placeholder="/uploads/filename.jpg ou URL complète"
                              value={(sec.data?.background_image) || ''}
                              onChange={(e) => {
                                const copy = [...singlePageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.background_image = e.target.value;
                                copy[idx] = { ...sec, data: nextData };
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Subtitle (FR)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.subtitle?.fr) || ''}
                              onChange={(e) => {
                                const copy = [...singlePageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.subtitle = { ...(nextData.subtitle || {}), fr: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Subtitle (EN)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-500 text-white"
                              value={(sec.data?.subtitle?.en) || ''}
                              onChange={(e) => {
                                const copy = [...singlePageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.subtitle = { ...(nextData.subtitle || {}), en: e.target.value };
                                copy[idx] = { ...sec, data: nextData };
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Description (FR)</label>
                          <textarea
                            className="w-full p-2 rounded bg-gray-500 text-white h-20"
                            value={(sec.data?.description?.fr) || ''}
                            onChange={(e) => {
                              const copy = [...singlePageForm.sections];
                              const nextData = { ...(sec.data || {}) };
                              nextData.description = { ...(nextData.description || {}), fr: e.target.value };
                              copy[idx] = { ...sec, data: nextData };
                              setSinglePageForm(prev => ({ ...prev, sections: copy }));
                            }}
                          />
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Description (EN)</label>
                          <textarea
                            className="w-full p-2 rounded bg-gray-500 text-white h-20"
                            value={(sec.data?.description?.en) || ''}
                            onChange={(e) => {
                              const copy = [...singlePageForm.sections];
                              const nextData = { ...(sec.data || {}) };
                              nextData.description = { ...(nextData.description || {}), en: e.target.value };
                              copy[idx] = { ...sec, data: nextData };
                              setSinglePageForm(prev => ({ ...prev, sections: copy }));
                            }}
                          />
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Uploader une image</label>
                          <div className="flex items-center gap-2 mb-2">
                            <input
                              type="text"
                              placeholder="URL de l'image"
                              className="flex-1 bg-gray-500 text-white text-sm rounded px-2 py-1"
                              value={sec.data?.background_image || ''}
                              onChange={(e) => {
                                const copy = [...singlePageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.background_image = e.target.value;
                                copy[idx] = { ...sec, data: nextData };
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              }}
                            />
                            <span className="text-xs text-gray-300">ou</span>
                          </div>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={async (e) => {
                              const file = e.target.files?.[0];
                              if (!file) return;
                              try {
                                setSinglePageLoading(true);
                                const url = await AdminService.uploadImage(file, token);
                                const copy = [...singlePageForm.sections];
                                const nextData = { ...(sec.data || {}) };
                                nextData.background_image = url;
                                copy[idx] = { ...sec, data: nextData };
                                setSinglePageForm(prev => ({ ...prev, sections: copy }));
                              } catch (err) {
                                setSinglePageError(err?.message || 'Upload image échoué');
                              } finally {
                                setSinglePageLoading(false);
                              }
                            }}
                          />
                        </div>
                        {/* Stats editor (no JSON) */}
                        {sec.type === 'stats' && (
                          <div className="mt-4">
                            <div className="text-sm text-gray-200 font-semibold mb-2">Éléments de statistiques</div>
                            <div className="space-y-3">
                              {((sec.data?.items) || []).map((item, sIdx) => (
                                <div key={sIdx} className="bg-gray-500 rounded p-3">
                                  <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                    <div>
                                      <label className="block text-xs text-gray-300 mb-1">Nombre</label>
                                      <input
                                        className="w-full p-2 rounded bg-gray-400 text-white"
                                        value={item.number || ''}
                                        onChange={(e) => {
                                          const copy = [...singlePageForm.sections];
                                          const nextData = { ...(sec.data || {}), items: [ ...((sec.data?.items) || []) ] };
                                          nextData.items[sIdx] = { ...(item || {}), number: e.target.value };
                                          copy[idx] = { ...sec, data: nextData };
                                          setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <label className="block text-xs text-gray-300 mb-1">Label (FR)</label>
                                      <input
                                        className="w-full p-2 rounded bg-gray-400 text-white"
                                        value={(typeof item.label === 'string' ? item.label : (item.label?.fr) || '')}
                                        onChange={(e) => {
                                          const copy = [...singlePageForm.sections];
                                          const nextData = { ...(sec.data || {}), items: [ ...((sec.data?.items) || []) ] };
                                          const baseLabel = typeof item.label === 'string' ? { fr: item.label, en: '' } : ((item && item.label) || {});
                                          const nextItem = { ...(item || {}), label: { ...baseLabel, fr: e.target.value } };
                                          nextData.items[sIdx] = nextItem;
                                          copy[idx] = { ...sec, data: nextData };
                                          setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <label className="block text-xs text-gray-300 mb-1">Label (EN)</label>
                                      <input
                                        className="w-full p-2 rounded bg-gray-400 text-white"
                                        value={(typeof item.label === 'string' ? '' : (item.label?.en) || '')}
                                        onChange={(e) => {
                                          const copy = [...singlePageForm.sections];
                                          const nextData = { ...(sec.data || {}), items: [ ...((sec.data?.items) || []) ] };
                                          const baseLabel = typeof item.label === 'string' ? { fr: item.label, en: '' } : ((item && item.label) || {});
                                          const nextItem = { ...(item || {}), label: { ...baseLabel, en: e.target.value } };
                                          nextData.items[sIdx] = nextItem;
                                          copy[idx] = { ...sec, data: nextData };
                                          setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <label className="block text-xs text-gray-300 mb-1">Icône</label>
                                      <input
                                        className="w-full p-2 rounded bg-gray-400 text-white"
                                        placeholder="Emoji ou nom d’icône"
                                        value={item.icon || ''}
                                        onChange={(e) => {
                                          const copy = [...singlePageForm.sections];
                                          const nextData = { ...(sec.data || {}), items: [ ...((sec.data?.items) || []) ] };
                                          nextData.items[sIdx] = { ...(item || {}), icon: e.target.value };
                                          copy[idx] = { ...sec, data: nextData };
                                          setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 flex items-center gap-2">
                                    <button
                                      className="text-red-300 hover:text-red-200 text-xs"
                                      onClick={() => {
                                        const copy = [...singlePageForm.sections];
                                        const nextData = { ...(sec.data || {}), items: [ ...((sec.data?.items) || []) ] };
                                        nextData.items = nextData.items.filter((_, i) => i !== sIdx);
                                        copy[idx] = { ...sec, data: nextData };
                                        setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                      }}
                                    >Supprimer</button>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="mt-2">
                              <button
                                className="bg-primary text-white px-3 py-1 rounded text-sm"
                                onClick={() => {
                                  const copy = [...singlePageForm.sections];
                                  const items = [ ...((sec.data?.items) || []) ];
                                  items.push({ number: '', label: { fr: '', en: '' }, icon: '' });
                                  const nextData = { ...(sec.data || {}), items };
                                  copy[idx] = { ...sec, data: nextData };
                                  setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                }}
                              >Ajouter un élément</button>
                            </div>
                          </div>
                        )}
                        {/* Contact info editor */}
                        {(sec.type === 'contact_info' || sec.type === 'contact') && (
                          <div className="mt-4">
                            <div className="text-sm text-gray-200 font-semibold mb-2">Informations de contact</div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div>
                                <label className="block text-xs text-gray-300 mb-1">Téléphone</label>
                                <input
                                  className="w-full p-2 rounded bg-gray-400 text-white"
                                  value={(sec.data?.phone) || ''}
                                  onChange={(e) => {
                                    const copy = [...singlePageForm.sections];
                                    const nextData = { ...(sec.data || {}) };
                                    nextData.phone = e.target.value;
                                    copy[idx] = { ...sec, data: nextData };
                                    setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                  }}
                                />
                              </div>
                              <div>
                                <label className="block text-xs text-gray-300 mb-1">Email</label>
                                <input
                                  className="w-full p-2 rounded bg-gray-400 text-white"
                                  value={(sec.data?.email) || ''}
                                  onChange={(e) => {
                                    const copy = [...singlePageForm.sections];
                                    const nextData = { ...(sec.data || {}) };
                                    nextData.email = e.target.value;
                                    copy[idx] = { ...sec, data: nextData };
                                    setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                  }}
                                />
                              </div>
                            </div>
                            <div className="mt-2">
                              <label className="block text-xs text-gray-300 mb-1">Adresse</label>
                              <input
                                className="w-full p-2 rounded bg-gray-400 text-white"
                                value={(sec.data?.address) || ''}
                                onChange={(e) => {
                                  const copy = [...singlePageForm.sections];
                                  const nextData = { ...(sec.data || {}) };
                                  nextData.address = e.target.value;
                                  copy[idx] = { ...sec, data: nextData };
                                  setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                }}
                              />
                            </div>
                            <div className="mt-2">
                              <label className="block text-xs text-gray-300 mb-1">Horaires</label>
                              <textarea
                                className="w-full p-2 rounded bg-gray-400 text-white h-20"
                                value={(sec.data?.hours) || ''}
                                onChange={(e) => {
                                  const copy = [...singlePageForm.sections];
                                  const nextData = { ...(sec.data || {}) };
                                  nextData.hours = e.target.value;
                                  copy[idx] = { ...sec, data: nextData };
                                  setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                }}
                              />
                            </div>
                            <div className="mt-2">
                              <label className="block text-xs text-gray-300 mb-1">Carte (URL embed)</label>
                              <input
                                className="w-full p-2 rounded bg-gray-400 text-white"
                                placeholder="https://maps.google.com/…"
                                value={(sec.data?.map_embed_url) || ''}
                                onChange={(e) => {
                                  const copy = [...singlePageForm.sections];
                                  const nextData = { ...(sec.data || {}) };
                                  nextData.map_embed_url = e.target.value;
                                  copy[idx] = { ...sec, data: nextData };
                                  setSinglePageForm(prev => ({ ...prev, sections: copy }));
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="mt-3">
                    <button className="bg-primary text-white px-3 py-2 rounded" onClick={() => {
                      const copy = [...(singlePageForm.sections || [])];
                      copy.push({ key: `sec_${Date.now()}`, type: 'block', title: '', order: copy.length, actif: true, data: {} });
                      setSinglePageForm(prev => ({ ...prev, sections: copy }));
                    }}>Ajouter une section</button>
                  </div>
                </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* SECTION DÉPARTEMENT */}
      {adminSection === 'departement' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mb-6 mx-4 md:mx-10">
            {/* Ligne d’actions de la section (en dessous du header global) */}
            <div className="mb-4 flex items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-400">{depSelectedIds.length}</span>
                {!depAllSelected ? (
                  <button
                    className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                    title="Tout sélectionner"
                    aria-label="Tout sélectionner"
                    onClick={selectAllDepartements}
                  >
                    ✓
                  </button>
                ) : (
                  <button
                    className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                    title="Tout désélectionner"
                    aria-label="Tout désélectionner"
                    onClick={deselectAllDepartements}
                  >
                    ☐
                  </button>
                )}
                <button
                  className={`rounded-full w-8 h-8 flex items-center justify-center ${depSelectedIds.length === 0 ? 'bg-gray-700 text-gray-400 cursor-not-allowed' : 'bg-red-600 text-white hover:bg-red-700'}`}
                  disabled={depSelectedIds.length === 0}
                  title="Supprimer la sélection"
                  aria-label="Supprimer la sélection"
                  onClick={() => setShowDepBulkDeleteConfirm(true)}
                >
                  🗑️
                </button>
              </div>
              <button
                className="rounded-full bg-primary text-white w-8 h-8 flex items-center justify-center hover:bg-primary/90"
                title="Nouveau département"
                aria-label="Nouveau département"
                onClick={() => {
                  if (showDepForm) {
                    setShowDepForm(false);
                  } else {
                    setShowDepForm(true);
                    resetDepForm();
                    depFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >{showDepForm ? '−' : '+'}
              </button>
            </div>
            {/* Formulaire département (placé en haut) */}
            {showDepForm && (
              <div ref={depFormRef} className="bg-gray-700 rounded p-4 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Nom</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={depForm.nom} onChange={(e) => setDepForm(prev => ({ ...prev, nom: e.target.value }))} />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Code</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={depForm.code} onChange={(e) => setDepForm(prev => ({ ...prev, code: e.target.value }))} />
                  </div>
                  <div className="flex items-end justify-end gap-2">
                    <button className="bg-primary text-white px-4 py-2 rounded" onClick={saveDepartement}>{depForm.id ? 'Mettre à jour' : 'Créer'}</button>
                    {depForm.id && <button className="border border-gray-500 text-white px-4 py-2 rounded" onClick={resetDepForm}>Annuler</button>}
                  </div>
                </div>
              </div>
            )}
            {/* Barre de recherche */}
            <div className="mb-4 flex items-center gap-3">
              <input
                type="text"
                className="w-full p-2 rounded bg-gray-700 text-white"
                placeholder="Rechercher un département (nom ou code)"
                value={depQuery}
                onChange={(e) => setDepQuery(e.target.value)}
              />
              {depLoading && <span className="text-sm text-gray-400">Chargement…</span>}
            </div>
            {depError && <div className="text-red-400 mb-3">{depError}</div>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              {(departements.filter(d => (
                (d.nom || '').toLowerCase().includes((depQuery||'').toLowerCase()) ||
                (d.code || '').toLowerCase().includes((depQuery||'').toLowerCase())
              ))).map(d => (
                <div key={d._id} className={`bg-gray-700 rounded p-3 flex items-center justify-between ${depSelectedIds.includes(d._id) ? 'ring-1 ring-primary/50' : ''}`}>
                  <div className="flex items-center gap-2">
                    <button
                      className="rounded-full border border-gray-500 w-6 h-6 flex items-center justify-center text-gray-300 hover:bg-gray-600"
                      title={depSelectedIds.includes(d._id) ? 'Désélectionner' : 'Sélectionner'}
                      aria-label={depSelectedIds.includes(d._id) ? 'Désélectionner' : 'Sélectionner'}
                      onClick={() => toggleDepSelected(d._id)}
                    >
                      {depSelectedIds.includes(d._id) ? '✓' : '☐'}
                    </button>
                    <div className="font-semibold">{d.nom}</div>
                    <div className="text-sm text-gray-300">Code: {d.code}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <button className="border border-gray-500 text-white px-3 py-1 rounded" onClick={() => editDepartement(d)}>Modifier</button>
                    <button className="bg-red-600 text-white px-3 py-1 rounded" onClick={() => deleteDepartement(d._id)}>Supprimer</button>
                  </div>
                </div>
              ))}
              {departements.length === 0 && !depLoading && (
                <div className="text-sm text-gray-400">Aucun département</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* SECTION VILLE */}
      {adminSection === 'ville' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mx-4 md:mx-10">
            {/* Ligne d’actions de la section (en dessous du header global) */}
            <div className="mb-4 flex items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-400">{villeSelectedIds.length}</span>
                {!villeAllSelected ? (
                  <button
                    className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                    title="Tout sélectionner"
                    aria-label="Tout sélectionner"
                    onClick={selectAllVilles}
                  >
                    ✓
                  </button>
                ) : (
                  <button
                    className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                    title="Tout désélectionner"
                    aria-label="Tout désélectionner"
                    onClick={deselectAllVilles}
                  >
                    ☐
                  </button>
                )}
                <button
                  className={`rounded-full w-8 h-8 flex items-center justify-center ${villeSelectedIds.length === 0 ? 'bg-gray-700 text-gray-400 cursor-not-allowed' : 'bg-red-600 text-white hover:bg-red-700'}`}
                  disabled={villeSelectedIds.length === 0}
                  title="Supprimer la sélection"
                  aria-label="Supprimer la sélection"
                  onClick={() => setShowVilleBulkDeleteConfirm(true)}
                >
                  🗑️
                </button>
              </div>
              <button
                className="rounded-full bg-primary text-white w-8 h-8 flex items-center justify-center hover:bg-primary/90"
                title="Nouvelle ville"
                aria-label="Nouvelle ville"
                onClick={() => {
                  if (showVilleForm) {
                    setShowVilleForm(false);
                  } else {
                    setShowVilleForm(true);
                    resetVilleForm();
                    villeFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >{showVilleForm ? '−' : '+'}
              </button>
            </div>
            {/* Formulaire ville (placé en haut) */}
            {showVilleForm && (
              <div ref={villeFormRef} className="bg-gray-700 rounded p-4 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Nom</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={villeForm.nom} onChange={(e) => setVilleForm(prev => ({ ...prev, nom: e.target.value }))} />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Code postal</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={villeForm.code_postal} onChange={(e) => setVilleForm(prev => ({ ...prev, code_postal: e.target.value }))} />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Département</label>
                    <select className="w-full p-2 rounded bg-gray-600 text-white" value={villeForm.departement} onChange={(e) => setVilleForm(prev => ({ ...prev, departement: e.target.value }))}>
                      <option value="">-- choisir --</option>
                      {departements.map(d => <option key={d._id} value={d._id}>{d.nom}</option>)}
                    </select>
                  </div>
                  <div className="flex items-end justify-end gap-2">
                    <button className="bg-primary text-white px-4 py-2 rounded" onClick={saveVille}>{villeForm.id ? 'Mettre à jour' : 'Créer'}</button>
                    {villeForm.id && <button className="border border-gray-500 text-white px-4 py-2 rounded" onClick={resetVilleForm}>Annuler</button>}
                  </div>
                </div>
              </div>
            )}
            {/* Barre de recherche */}
            <div className="mb-4 flex items-center gap-3">
              <input
                type="text"
                className="w-full p-2 rounded bg-gray-700 text-white"
                placeholder="Rechercher une ville (nom ou code postal)"
                value={villeQuery}
                onChange={(e) => setVilleQuery(e.target.value)}
              />
              {villeLoading && <span className="text-sm text-gray-400">Chargement…</span>}
            </div>
            {villeError && <div className="text-red-400 mb-3">{villeError}</div>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              {(villes.filter(v => (
                (v.nom || '').toLowerCase().includes((villeQuery||'').toLowerCase()) ||
                (v.code_postal || '').toLowerCase().includes((villeQuery||'').toLowerCase())
              ))).map(v => (
                <div key={v._id} className={`bg-gray-700 rounded p-3 flex items-center justify-between ${villeSelectedIds.includes(v._id) ? 'ring-1 ring-primary/50' : ''}`}>
                  <div className="flex items-center gap-2">
                    <button
                      className="rounded-full border border-gray-500 w-6 h-6 flex items-center justify-center text-gray-300 hover:bg-gray-600"
                      title={villeSelectedIds.includes(v._id) ? 'Désélectionner' : 'Sélectionner'}
                      aria-label={villeSelectedIds.includes(v._id) ? 'Désélectionner' : 'Sélectionner'}
                      onClick={() => toggleVilleSelected(v._id)}
                    >
                      {villeSelectedIds.includes(v._id) ? '✓' : '☐'}
                    </button>
                    <div>
                      <div className="font-semibold">{v.nom}</div>
                      <div className="text-sm text-gray-300">CP: {v.code_postal} • Dép: {v?.departement?.nom || '—'}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <button className="border border-gray-500 text-white px-3 py-1 rounded" onClick={() => editVille(v)}>Modifier</button>
                    <button className="bg-red-600 text-white px-3 py-1 rounded" onClick={() => deleteVille(v._id)}>Supprimer</button>
                  </div>
                </div>
              ))}
              {villes.length === 0 && !villeLoading && (
                <div className="text-sm text-gray-400">Aucune ville</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* SECTION CATÉGORIE */}
      {adminSection === 'categorie' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mx-4 md:mx-10">
            {/* Ligne d’actions de la section (comme Ville) */}
            <div className="mb-4 flex items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-400">{catSelectedIds.length}</span>
                {!catAllSelected ? (
                  <button
                    className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                    title="Tout sélectionner"
                    aria-label="Tout sélectionner"
                    onClick={selectAllCategories}
                  >
                    ✓
                  </button>
                ) : (
                  <button
                    className="rounded-full border border-gray-500 w-8 h-8 flex items-center justify-center text-gray-300 hover:bg-gray-700"
                    title="Tout désélectionner"
                    aria-label="Tout désélectionner"
                    onClick={deselectAllCategories}
                  >
                    ☐
                  </button>
                )}
                <button
                  className={`rounded-full w-8 h-8 flex items-center justify-center ${catSelectedIds.length === 0 ? 'bg-gray-700 text-gray-400 cursor-not-allowed' : 'bg-red-600 text-white hover:bg-red-700'}`}
                  disabled={catSelectedIds.length === 0}
                  title="Supprimer la sélection"
                  aria-label="Supprimer la sélection"
                  onClick={() => setShowCatBulkDeleteConfirm(true)}
                >
                  🗑️
                </button>
              </div>
              <button
                className="rounded-full bg-primary text-white w-8 h-8 flex items-center justify-center hover:bg-primary/90"
                title={showCatForm ? 'Fermer' : 'Ajouter'}
                aria-label={showCatForm ? 'Fermer' : 'Ajouter'}
                onClick={() => setShowCatForm(prev => !prev)}
              >{showCatForm ? '−' : '+'}
              </button>
            </div>

            {showCatForm && (
              <div ref={catFormRef} className="mb-4 bg-gray-700 rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex items-center justify-between md:col-span-2">
                    <div className="text-sm text-gray-300">Visible / Enable</div>
                    <label className="inline-flex items-center gap-2">
                      <input
                        id="enableToggle"
                        type="checkbox"
                        className="h-5 w-5"
                        checked={!!catForm.enable}
                        onChange={(e) => setCatForm(prev => ({ ...prev, enable: e.target.checked }))}
                      />
                      <span className="text-white text-sm">{catForm.enable ? 'On' : 'Off'}</span>
                    </label>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Nom</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={catForm.nom} onChange={(e) => setCatForm(prev => ({ ...prev, nom: e.target.value }))} />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Type</label>
                    <select className="w-full p-2 rounded bg-gray-600 text-white" value={catForm.type} onChange={(e) => setCatForm(prev => ({ ...prev, type: e.target.value }))}>
                      <option value="">-- choisir --</option>
                      <option value="particulier">particulier</option>
                      <option value="professionnel">professionnel</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Zone</label>
                    <select className="w-full p-2 rounded bg-gray-600 text-white" value={catForm.zone} onChange={(e) => setCatForm(prev => ({ ...prev, zone: e.target.value }))}>
                      <option value="">-- choisir --</option>
                      <option value="interior">interior</option>
                      <option value="exterior">exterior</option>
                      <option value="both">both</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Image (URL)</label>
                    <input className="w-full p-2 rounded bg-gray-600 text-white" value={catForm.image} onChange={(e) => setCatForm(prev => ({ ...prev, image: e.target.value }))} />
                    <div className="mt-2 flex items-center gap-2">
                      <input type="file" accept="image/*" onChange={handleCatImageUpload} />
                      <button type="button" className="border border-gray-500 text-white px-2 py-1 rounded" onClick={removeCatImage}>Effacer</button>
                    </div>
                    <div
                      className="mt-2 border border-dashed border-gray-500 rounded p-3 text-xs text-gray-300"
                      onDrop={handleCatImageDrop}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      Glisser-déposer une image ici (URL/upload/drag & drop)
                    </div>
                    {catForm.image && (
                      <div className="mt-2 flex items-center gap-2">
                        <img src={catForm.image} alt="preview" className="w-12 h-12 object-cover rounded" />
                        <a href={catForm.image} target="_blank" rel="noreferrer" className="text-blue-400 underline break-all">{catForm.image}</a>
                      </div>
                    )}
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm text-gray-300 mb-1">Description</label>
                    <textarea className="w-full p-2 rounded bg-gray-600 text-white" rows={3} value={catForm.description} onChange={(e) => setCatForm(prev => ({ ...prev, description: e.target.value }))} />
                  </div>

                  {/* Sous-catégories */}
                  <div className="md:col-span-2">
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm text-gray-300">Sous-catégories</label>
                      <button
                        type="button"
                        className="text-xs bg-indigo-600 px-3 py-1 rounded"
                        onClick={() => setCatForm(prev => ({ ...prev, sous_categories: [ ...(prev.sous_categories || []), { nom: '', surface_piece: false, surface_elements: false, multi_pieces: false, nombre_elements: false, prix_materiel_unit: 1, prix_intervention_m2: 0 } ] }))}
                      >Ajouter</button>
                    </div>
                    <div className="space-y-3">
                      {(catForm.sous_categories || []).map((sc, idx) => (
                        <div key={idx} className="bg-gray-600 rounded p-3">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            <div>
                              <label className="block text-xs text-gray-300 mb-1">Nom</label>
                              <input className="w-full p-2 rounded bg-gray-500 text-white" value={sc.nom || ''} onChange={(e) => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.map((item, i) => i === idx ? { ...item, nom: e.target.value } : item) }))} />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-300 mb-1">Prix matériel (unité)</label>
                              <input type="number" className="w-full p-2 rounded bg-gray-500 text-white" value={sc.prix_materiel_unit ?? 1} onChange={(e) => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.map((item, i) => i === idx ? { ...item, prix_materiel_unit: Number(e.target.value) } : item) }))} />
                            </div>
                            <div>
                              <label className="block text-xs text-gray-300 mb-1">Prix intervention (m²)</label>
                              <input type="number" className="w-full p-2 rounded bg-gray-500 text-white" value={sc.prix_intervention_m2 ?? 0} onChange={(e) => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.map((item, i) => i === idx ? { ...item, prix_intervention_m2: Number(e.target.value) } : item) }))} />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
                            <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={!!sc.surface_piece} onChange={(e) => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.map((item, i) => i === idx ? { ...item, surface_piece: e.target.checked } : item) }))} /> Surface pièce</label>
                            <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={!!sc.surface_elements} onChange={(e) => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.map((item, i) => i === idx ? { ...item, surface_elements: e.target.checked } : item) }))} /> Surface éléments</label>
                            <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={!!sc.multi_pieces} onChange={(e) => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.map((item, i) => i === idx ? { ...item, multi_pieces: e.target.checked } : item) }))} /> Multi pièces</label>
                            <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={!!sc.nombre_elements} onChange={(e) => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.map((item, i) => i === idx ? { ...item, nombre_elements: e.target.checked } : item) }))} /> Nombre éléments</label>
                          </div>
                          <div className="mt-3 flex items-center justify-end">
                            <button type="button" className="text-xs border border-gray-500 px-2 py-1 rounded" onClick={() => setCatForm(prev => ({ ...prev, sous_categories: prev.sous_categories.filter((_, i) => i !== idx) }))}>Supprimer</button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex items-end justify-end gap-2 md:col-span-2">
                    <button className="bg-primary text-white px-4 py-2 rounded" onClick={saveCategorie}>{catForm.id ? 'Mettre à jour' : 'Créer'}</button>
                    {catForm.id && <button className="border border-gray-500 text-white px-4 py-2 rounded" onClick={() => { resetCatForm(); setShowCatForm(false); }}>Annuler</button>}
                  </div>
                </div>
              </div>
            )}

            {/* Barre de recherche + filtre type */}
            <div className="mb-4 flex items-center gap-3 flex-wrap">
              <input
                type="text"
                className="w-full p-2 rounded bg-gray-700 text-white"
                placeholder="Rechercher une catégorie (nom, type, zone)"
                value={catQuery}
                onChange={(e) => setCatQuery(e.target.value)}
              />
              {/* Filtre par type */}
              <div className="flex items-center gap-2">
                <button
                  className={`px-3 py-2 rounded ${catTypeFilter === 'all' ? 'bg-primary text-white' : 'border border-gray-500 text-gray-200'}`}
                  onClick={() => setCatTypeFilter('all')}
                >Tous</button>
                <button
                  className={`px-3 py-2 rounded ${catTypeFilter === 'particulier' ? 'bg-primary text-white' : 'border border-gray-500 text-gray-200'}`}
                  onClick={() => setCatTypeFilter('particulier')}
                >Particulier</button>
                <button
                  className={`px-3 py-2 rounded ${catTypeFilter === 'professionnel' ? 'bg-primary text-white' : 'border border-gray-500 text-gray-200'}`}
                  onClick={() => setCatTypeFilter('professionnel')}
                >Professionnel</button>
              </div>
              {catLoading && <span className="text-sm text-gray-400">Chargement…</span>}
            </div>
            {catError && <div className="text-red-400 mb-3">{catError}</div>}

            {/* Liste des catégories */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              {(categories.filter(c => {
                const q = (catQuery||'').toLowerCase();
                const matchesQuery =
                  (c.nom || '').toLowerCase().includes(q) ||
                  (c.type || '').toLowerCase().includes(q) ||
                  (c.zone || '').toLowerCase().includes(q);
                const matchesType = (catTypeFilter === 'all') || ((c.type || '').toLowerCase() === catTypeFilter);
                return matchesQuery && matchesType;
              })).map(c => (
                <div key={c._id} className={`relative bg-gray-700 rounded p-4 pb-10 flex items-start justify-between ${catSelectedIds.includes(c._id) ? 'ring-1 ring-primary/50' : ''}`}>
                  <div className="flex items-start gap-3">
                    <button
                      className="rounded-full border border-gray-500 w-6 h-6 flex items-center justify-center text-gray-300 hover:bg-gray-600"
                      title={catSelectedIds.includes(c._id) ? 'Désélectionner' : 'Sélectionner'}
                      aria-label={catSelectedIds.includes(c._id) ? 'Désélectionner' : 'Sélectionner'}
                      onClick={() => toggleCatSelected(c._id)}
                    >
                      {catSelectedIds.includes(c._id) ? '✓' : '☐'}
                    </button>
                    {c.image && (
                      <img src={c.image} alt={c.nom} className="w-16 h-16 rounded object-cover" />
                    )}
                    <div>
                      <div className="font-semibold">{c.nom}</div>
                       <div className="text-sm text-gray-300">Type: {c.type || '—'}</div>
                       <div className="text-sm text-gray-300">Zone: {c.zone || '—'}</div>
                       <div className="text-sm text-gray-300">Sous-catégories: {Array.isArray(c.sous_categories) ? c.sous_categories.length : 0}</div>
                       <div className="mt-2 flex items-center gap-2">
                         <span className="text-xs text-gray-300">Visible / Enable</span>
                         <label className="inline-flex items-center gap-2">
                           <input
                             type="checkbox"
                             className="h-4 w-4"
                             checked={c.enable !== false}
                             onChange={(e) => toggleCategoryEnable(c, e.target.checked)}
                           />
                           <span className="text-xs text-white">{(c.enable !== false) ? 'On' : 'Off'}</span>
                         </label>
                       </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <button className="bg-gray-600 text-white px-3 py-1 rounded" onClick={() => { setSelectedCategory(c); setShowCatDetails(true); }}>Voir détail</button>
                    <button className="border border-gray-500 text-white px-3 py-1 rounded" onClick={() => editCategorie(c)}>Modifier</button>
                  </div>
                  {/* Icône poubelle en bas à droite, sans bordure */}
                  <button
                    className="absolute bottom-2 right-2 text-red-400 hover:text-white hover:bg-red-500 rounded-full p-2"
                    title="Supprimer"
                    aria-label="Supprimer"
                    onClick={() => deleteCategorie(c._id)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                      <path d="M9 3h6a1 1 0 011 1v1h4a1 1 0 110 2h-1v12a3 3 0 01-3 3H8a3 3 0 01-3-3V7H4a1 1 0 110-2h4V4a1 1 0 011-1zm2 3h2V5h-2v1zM7 7v12a1 1 0 001 1h8a1 1 0 001-1V7H7z" />
                    </svg>
                  </button>
                </div>
              ))}
              {categories.length === 0 && !catLoading && (
                <div className="text-sm text-gray-400">Aucune catégorie</div>
              )}
            </div>

            {/* Confirmation suppression groupée */}
            {showCatBulkDeleteConfirm && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                <div className="bg-gray-800 rounded p-4 w-80">
                  <div className="text-lg font-semibold mb-2">Supprimer {catSelectedIds.length} catégorie(s) ?</div>
                  <div className="text-sm text-gray-300 mb-4">Cette action est irréversible.</div>
                  <div className="flex items-center justify-end gap-2">
                    <button className="border border-gray-500 text-white px-3 py-1 rounded" onClick={() => setShowCatBulkDeleteConfirm(false)}>Annuler</button>
                    <button className="bg-red-600 text-white px-3 py-1 rounded" onClick={() => { setShowCatBulkDeleteConfirm(false); handleCatBulkDelete(); }}>Supprimer</button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Aperçu intégré de la page avec édition en place */}
          {showSinglePageEditor && singlePage && (
            <div className="bg-gray-800 rounded-xl p-4 mx-4 md:mx-10 mt-4">
              <div className="text-sm text-gray-300 mb-2">Aperçu de la page — édition directe activable avec le bouton ci-dessus</div>
              <InlineEditProvider
                slug={singlePageForm.slug}
                token={token}
                editing={singlePageEditMode}
                initialSections={singlePageForm.sections || []}
              >
                <div className="border border-gray-700 rounded-lg overflow-hidden">
                  {(() => {
                    const slug = getSlugFromAdminSection(adminSection);
                    switch (slug) {
                      case 'accueil':
                        return <Home />;
                      case 'services':
                        return <Services />;
                      case 'professionnel':
                        return <Professional />;
                      case 'apropos':
                        return <About />;
                      case 'contact':
                        return <Contact />;
                      case 'dashboard':
                        return <Dashboard />;
                      default:
                        return null;
                    }
                  })()}
                </div>
              </InlineEditProvider>
            </div>
          )}
        </div>
      )}

      {/* Détails Catégorie (modale structurée, alignée avec Contenu) */}
      {adminSection === 'categorie' && showCatDetails && selectedCategory && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto relative">
            <div className="relative flex items-center justify-between mb-4">
              <div className="flex justify-start">
                <button
                  className="rounded-full w-8 h-8 flex items-center justify-center bg-gray-800 border border-gray-600 text-white hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => { setShowCatDetails(false); setSelectedCategory(null); }}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                </button>
              </div>
              <div className="absolute left-1/2 -translate-x-1/2">
                <h2 className="text-2xl font-bold text-center">Détails de la catégorie: {selectedCategory?.nom}</h2>
              </div>
              <div className="flex justify-end w-full">
                <button
                  className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
                  title="Éditer"
                  aria-label="Éditer"
                  onClick={() => { setShowCatDetails(false); editCategorie(selectedCategory); }}
                >Éditer</button>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <div className="text-gray-400 text-sm">ObjectID</div>
                <div className="text-white text-sm break-all">{selectedCategory?._id}</div>
              </div>
              <div>
                <div className="text-gray-400 text-sm">Type</div>
                <div className="text-white text-sm">{selectedCategory?.type || '—'}</div>
              </div>
              <div>
                <div className="text-gray-400 text-sm">Zone</div>
                <div className="text-white text-sm">{selectedCategory?.zone || '—'}</div>
              </div>
            </div>
            <div className="mb-4 bg-gray-900 rounded p-3 flex items-center justify-between">
              <div className="text-sm text-gray-300">Visible / Enable</div>
              <label className="inline-flex items-center gap-2">
                <input
                  type="checkbox"
                  className="h-5 w-5"
                  checked={selectedCategory?.enable !== false}
                  onChange={(e) => toggleCategoryEnable(selectedCategory, e.target.checked)}
                />
                <span className="text-white text-sm">{selectedCategory?.enable !== false ? 'On' : 'Off'}</span>
              </label>
            </div>
            {selectedCategory?.image && (
              <div className="mb-4">
                <div className="text-gray-400 text-sm mb-1">Image</div>
                {renderValue(selectedCategory.image)}
              </div>
            )}
            {selectedCategory?.description && (
              <div className="mb-4">
                <div className="text-gray-400 text-sm mb-1">Description</div>
                <div className="bg-gray-900 rounded p-4 text-sm">{selectedCategory.description}</div>
              </div>
            )}
            <div className="max-h-[50vh] overflow-auto bg-gray-900 rounded p-4 text-xs">
              {renderValue(selectedCategory)}
            </div>
            <div className="flex justify-end gap-3 mt-6">
              <button className="border border-gray-500 px-4 py-2 rounded" onClick={() => { setShowCatDetails(false); setSelectedCategory(null); }}>Fermer</button>
            </div>
          </div>
        </div>
      )}

      {/* SECTIONS PLACEHOLDER: User, Prestation, Devis, Catégorie */}
      {adminSection === 'user' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mx-4 md:mx-10">
            <p className="text-sm text-gray-300">Module de gestion des utilisateurs à venir.</p>
          </div>
        </div>
      )}
      {adminSection === 'prestation' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mx-4 md:mx-10">
            <p className="text-sm text-gray-300">Module de gestion des prestations à venir.</p>
          </div>
        </div>
      )}
      {adminSection === 'devis' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mx-4 md:mx-10">
            <p className="text-sm text-gray-300">Module de gestion des devis à venir.</p>
          </div>
        </div>
      )}
      {adminSection === 'categorie' && (
        <div className="mt-6">
          <div className="bg-gray-800 rounded-xl p-6 mx-4 md:mx-10">
            <p className="text-sm text-gray-300">Module de gestion des catégories à venir.</p>
          </div>
        </div>
      )}

      {/* Confirmation suppression (simple) */}
      {showDeleteConfirm && deleteTarget && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Confirmer la suppression</h2>
            <p className="text-gray-300 mb-6">Supprimer le template « {deleteTarget?.name || deleteTarget?.categorie?.nom || 'Overall'} » ? Cette action est irréversible.</p>
            <div className="flex justify-end gap-2">
              <button
                className="border border-gray-500 text-white px-4 py-2 rounded"
                onClick={() => { setShowDeleteConfirm(false); setDeleteTarget(null); }}
              >Annuler</button>
              <button
                className="bg-red-600 text-white px-4 py-2 rounded"
                onClick={async () => {
                  await handleDeleteTemplate(deleteTarget);
                  setShowDeleteConfirm(false);
                  setDeleteTarget(null);
                }}
              >Supprimer</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation suppression (groupée) */}
      {showBulkDeleteConfirm && selectedIds.length > 0 && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Supprimer la sélection</h2>
            <p className="text-gray-300 mb-6">Supprimer {selectedIds.length} template(s) sélectionné(s) ? Cette action est irréversible.</p>
            <div className="flex justify-end gap-2">
              <button
                className="border border-gray-500 text-white px-4 py-2 rounded"
                onClick={() => setShowBulkDeleteConfirm(false)}
              >Annuler</button>
              <button
                className="bg-red-600 text-white px-4 py-2 rounded"
                onClick={async () => {
                  await handleBulkDelete();
                  setShowBulkDeleteConfirm(false);
                }}
              >Supprimer</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation suppression groupée - Départements */}
      {showDepBulkDeleteConfirm && depSelectedIds.length > 0 && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Supprimer la sélection</h2>
            <p className="text-gray-300 mb-6">Supprimer {depSelectedIds.length} département(s) sélectionné(s) ? Cette action est irréversible.</p>
            <div className="flex justify-end gap-2">
              <button
                className="border border-gray-500 text-white px-4 py-2 rounded"
                onClick={() => setShowDepBulkDeleteConfirm(false)}
              >Annuler</button>
              <button
                className="bg-red-600 text-white px-4 py-2 rounded"
                onClick={async () => {
                  await handleDepBulkDelete();
                  setShowDepBulkDeleteConfirm(false);
                }}
              >Supprimer</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation suppression groupée - Villes */}
      {showVilleBulkDeleteConfirm && villeSelectedIds.length > 0 && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Supprimer la sélection</h2>
            <p className="text-gray-300 mb-6">Supprimer {villeSelectedIds.length} ville(s) sélectionnée(s) ? Cette action est irréversible.</p>
            <div className="flex justify-end gap-2">
              <button
                className="border border-gray-500 text-white px-4 py-2 rounded"
                onClick={() => setShowVilleBulkDeleteConfirm(false)}
              >Annuler</button>
              <button
                className="bg-red-600 text-white px-4 py-2 rounded"
                onClick={async () => {
                  await handleVilleBulkDelete();
                  setShowVilleBulkDeleteConfirm(false);
                }}
              >Supprimer</button>
            </div>
          </div>
        </div>
      )}

      {/* Modale de création de template catégorie */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-xl">
            <h2 className="text-xl font-bold mb-4">Créer un template de catégorie</h2>
            <div className="mb-4">
              <label className="block text-sm text-gray-300 mb-1">Catégorie</label>
              <select
                className="bg-gray-700 text-white text-sm rounded px-2 py-2 w-full"
                value={createCategoryId}
                onChange={(e) => setCreateCategoryId(e.target.value)}
              >
                <option value="">-- choisir une catégorie --</option>
                {categories.map(cat => {
                  const alreadyHasTpl = templates.some(t => t?.categorie?._id === cat._id);
                  return (
                    <option key={cat._id} value={cat._id} disabled={alreadyHasTpl}>
                      {cat.nom}{alreadyHasTpl ? ' (déjà présent)' : ''}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="flex justify-end gap-2">
              <button className="border border-gray-500 text-white px-4 py-2 rounded" onClick={() => { setShowCreateModal(false); setCreateCategoryId(''); }}>Annuler</button>
              <button
                className={`px-4 py-2 rounded ${!createCategoryId ? 'bg-gray-700 text-gray-400 cursor-not-allowed' : 'bg-primary text-white'}`}
                disabled={!createCategoryId}
                onClick={async () => {
                  try {
                    setLoading(true);
                    setError(null);
                    await AdminService.createCategoryTemplate(createCategoryId, token);
                    const list = await AdminService.getTemplates('category', token);
                    setTemplates(list);
                    const created = list.find(t => t?.categorie?._id === createCategoryId);
                    setShowCreateModal(false);
                    setCreateCategoryId('');
                    if (created) openFullEditor(created);
                  } catch (e) {
                    setError(e.message);
                  } finally {
                    setLoading(false);
                  }
                }}
              >Créer</button>
            </div>
          </div>
        </div>
      )}

      {error && <div className="text-red-400 mb-4">{error}</div>}

        {adminSection === 'templates' && (!loading && templates.length === 0) && (
          <div className="bg-gray-800 rounded-xl p-6 mb-6 mx-4 md:mx-10">
            <div className="text-lg font-semibold mb-1">Aucun template</div>
            <div className="text-sm text-gray-400">Type sélectionné: {type}. Vérifiez la connexion et la base.</div>
          </div>
        )}

        


      
      {showFullEditor && selectedTemplate && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto relative">
            {/* En-tête modale alignée comme l’en-tête principal */}
            <div className="relative flex items-center justify-between mb-4">
              <div className="flex justify-start">
                <button
                  className="rounded-full w-8 h-8 flex items-center justify-center bg-gray-800 border border-gray-600 text-white hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => setShowFullEditor(false)}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                </button>
              </div>
              <div className="absolute left-1/2 -translate-x-1/2">
                <h2 className="text-2xl font-bold text-center">
                  {selectedTemplate?.__isNew ? 'Créer un template' : 'Modifier le template complet'}: {
                    selectedTemplate?.categorie?.nom
                      ? selectedTemplate.categorie.nom
                      : ((selectedTemplate?.__isNew && (typeChanges[selectedTemplate._id]?.type === 'overall'))
                          ? 'Overall'
                          : (selectedTemplate?.name || ''))
                  }
                </h2>
              </div>
              <div className="flex justify-end w-full">
                {/* Bouton supprimé (incorrect pour l'éditeur de templates) */}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <div className="text-gray-400 text-sm">ObjectID</div>
                <div className="text-white text-sm break-all">{selectedTemplate?.__isNew ? '—' : selectedTemplate?._id}</div>
              </div>
              <div>
                <div className="text-gray-400 text-sm">Type</div>
                <select
                  className="bg-gray-700 text-white text-sm rounded px-2 py-1 w-full"
                  value={typeChanges[selectedTemplate._id]?.type || selectedTemplate?.type}
                  onChange={(e) => setPendingType(selectedTemplate._id, e.target.value)}
                >
                  <option value="overall">overall</option>
                  <option value="category">category</option>
                </select>
              </div>
              {(typeChanges[selectedTemplate._id]?.type || selectedTemplate?.type) === 'category' && (
                <div>
                  <div className="text-gray-400 text-sm">Catégorie</div>
                  <select
                    className="bg-gray-700 text-white text-sm rounded px-2 py-1 w-full"
                    value={typeChanges[selectedTemplate._id]?.categorieId || selectedTemplate?.categorie?._id || ''}
                    onChange={(e) => setPendingCategorie(selectedTemplate._id, e.target.value)}
                  >
                    <option value="">-- choisir --</option>
                    {categories.map(cat => (
                      <option key={cat._id} value={cat._id}>{cat.nom}</option>
                    ))}
                  </select>
                </div>
              )}
              <div className="flex items-end md:items-center gap-2">
                <label className="text-gray-400 text-sm" htmlFor="actifToggle">Actif</label>
                <input
                  id="actifToggle"
                  type="checkbox"
                  checked={fullActif}
                  onChange={(e) => setFullActif(e.target.checked)}
                />
              </div>
            </div>

            {/* Name field */}
            <div className="mb-4">
              <label className="block text-sm text-gray-300 mb-1">Name (affichage)</label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => { setFullName(e.target.value); setNameEdited(true); }}
                className="w-full p-3 rounded bg-gray-700 text-white"
                placeholder="Nom lisible du template"
              />
            </div>

            {/* HERO section form */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Section HERO</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre principal</label>
                  <input
                    type="text"
                    value={fullTexte?.hero?.titre_principal || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      hero: { ...prev?.hero, titre_principal: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Sous-titre</label>
                  <input
                    type="text"
                    value={fullTexte?.hero?.sous_titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      hero: { ...prev?.hero, sous_titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm text-gray-300 mb-1">Description</label>
                  <textarea
                    value={fullTexte?.hero?.description || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      hero: { ...prev?.hero, description: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white min-h-[100px]"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Bouton principal</label>
                  <input
                    type="text"
                    value={fullTexte?.hero?.bouton_principal || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      hero: { ...prev?.hero, bouton_principal: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Bouton secondaire</label>
                  <input
                    type="text"
                    value={fullTexte?.hero?.bouton_secondaire || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      hero: { ...prev?.hero, bouton_secondaire: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm text-gray-300 mb-1">Background image URL</label>
                  <input
                    type="text"
                    value={fullTexte?.hero?.background_image || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      hero: { ...prev?.hero, background_image: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                    placeholder="https://..."
                  />
                  {/* Dropzone pour drag-and-drop d'image */}
                  <div
                    className="mt-2 border-2 border-dashed border-gray-600 rounded p-4 text-center text-sm text-gray-300 hover:border-gray-500"
                    onDragEnter={preventDragDefaults}
                    onDragOver={preventDragDefaults}
                    onDrop={async (e) => {
                      e.preventDefault();
                      const file = e.dataTransfer?.files?.[0];
                      if (!file) return;
                      try {
                        setLoading(true);
                        const url = await AdminService.uploadImage(file, token);
                        setFullTexte(prev => ({
                          ...prev,
                          hero: { ...prev?.hero, background_image: url }
                        }));
                      } catch (err) {
                        setError(err.message);
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    Glisser-déposer une image ici ou
                    <label className="ml-1 underline cursor-pointer">
                      choisir un fichier
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={async (e) => {
                          const file = e.target.files?.[0];
                          if (!file) return;
                          try {
                            setLoading(true);
                            const url = await AdminService.uploadImage(file, token);
                            setFullTexte(prev => ({
                              ...prev,
                              hero: { ...prev?.hero, background_image: url }
                            }));
                          } catch (err) {
                            setError(err.message);
                          } finally {
                            setLoading(false);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* META SEO */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Meta SEO</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Meta title</label>
                  <input
                    type="text"
                    value={fullTexte?.meta_seo?.meta_title || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      meta_seo: { ...prev?.meta_seo, meta_title: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Meta description</label>
                  <input
                    type="text"
                    value={fullTexte?.meta_seo?.meta_description || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      meta_seo: { ...prev?.meta_seo, meta_description: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
            </div>

            {/* EXPERTISE */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Expertise</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.expertise?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      expertise: { ...prev?.expertise, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Description</label>
                  <textarea
                    value={fullTexte?.expertise?.description || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      expertise: { ...prev?.expertise, description: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white min-h-[100px]"
                  />
                </div>
              </div>
              {/* Stats structurées */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Statistiques</label>
                <div className="space-y-2">
                  {(fullTexte?.expertise?.stats || []).map((item, idx) => {
                    const current = typeof item === 'string' ? { number: item, label: { fr: item, en: '' }, icon: '' } : (item || {});
                    return (
                      <div key={idx} className="bg-gray-800/50 rounded p-3">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Nombre</label>
                            <input
                              className="w-full p-2 rounded bg-gray-700 text-white text-sm"
                              value={current.number || ''}
                              onChange={(e) => setFullTexte(prev => {
                                const stats = [ ...(prev?.expertise?.stats || []) ];
                                const base = typeof stats[idx] === 'string' ? { number: stats[idx], label: { fr: stats[idx], en: '' }, icon: '' } : (stats[idx] || {});
                                stats[idx] = { ...base, number: e.target.value };
                                return { ...prev, expertise: { ...prev?.expertise, stats } };
                              })}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Label (FR)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-700 text-white text-sm"
                              value={(current.label?.fr) || ''}
                              onChange={(e) => setFullTexte(prev => {
                                const stats = [ ...(prev?.expertise?.stats || []) ];
                                const base = typeof stats[idx] === 'string' ? { number: stats[idx], label: { fr: stats[idx], en: '' }, icon: '' } : (stats[idx] || {});
                                const nextLabel = { ...(base.label || {}), fr: e.target.value };
                                stats[idx] = { ...base, label: nextLabel };
                                return { ...prev, expertise: { ...prev?.expertise, stats } };
                              })}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Label (EN)</label>
                            <input
                              className="w-full p-2 rounded bg-gray-700 text-white text-sm"
                              value={(current.label?.en) || ''}
                              onChange={(e) => setFullTexte(prev => {
                                const stats = [ ...(prev?.expertise?.stats || []) ];
                                const base = typeof stats[idx] === 'string' ? { number: stats[idx], label: { fr: stats[idx], en: '' }, icon: '' } : (stats[idx] || {});
                                const nextLabel = { ...(base.label || {}), en: e.target.value };
                                stats[idx] = { ...base, label: nextLabel };
                                return { ...prev, expertise: { ...prev?.expertise, stats } };
                              })}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Icône</label>
                            <input
                              className="w-full p-2 rounded bg-gray-700 text-white text-sm"
                              placeholder="Emoji ou nom d’icône"
                              value={current.icon || ''}
                              onChange={(e) => setFullTexte(prev => {
                                const stats = [ ...(prev?.expertise?.stats || []) ];
                                const base = typeof stats[idx] === 'string' ? { number: stats[idx], label: { fr: stats[idx], en: '' }, icon: '' } : (stats[idx] || {});
                                stats[idx] = { ...base, icon: e.target.value };
                                return { ...prev, expertise: { ...prev?.expertise, stats } };
                              })}
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          <button
                            className="text-xs bg-red-600 px-2 py-1 rounded"
                            onClick={() => setFullTexte(prev => ({
                              ...prev,
                              expertise: {
                                ...prev?.expertise,
                                stats: (prev?.expertise?.stats || []).filter((_, i) => i !== idx)
                              }
                            }))}
                          >Supprimer</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <button
                  className="mt-2 text-xs bg-indigo-600 px-3 py-1 rounded"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    expertise: {
                      ...prev?.expertise,
                      stats: [ ...(prev?.expertise?.stats || []), { number: '', label: { fr: '', en: '' }, icon: '' } ]
                    }
                  }))}
                >Ajouter</button>
              </div>
            </div>

            {/* SPÉCIALITÉS */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Spécialités</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.specialites?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      specialites: { ...prev?.specialites, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              {/* Services structurés */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Services</label>
                <div className="bg-gray-800/50 rounded p-3 space-y-3">
                  {(fullTexte?.specialites?.services || []).map((item, idx) => {
                    const current = typeof item === 'string' ? { titre: item, description: '', image: '', icone: '' } : (item || {});
                    return (
                      <div key={idx} className="bg-gray-700/50 rounded p-3">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Titre</label>
                            <input
                              className="w-full p-2 rounded bg-gray-700 text-white text-sm"
                              value={current.titre || ''}
                              onChange={(e) => setFullTexte(prev => {
                                const services = [ ...(prev?.specialites?.services || []) ];
                                const base = typeof services[idx] === 'string' ? { titre: services[idx], description: '', image: '', icone: '' } : (services[idx] || {});
                                services[idx] = { ...base, titre: e.target.value };
                                return { ...prev, specialites: { ...prev?.specialites, services } };
                              })}
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Icône</label>
                            <input
                              className="w-full p-2 rounded bg-gray-700 text-white text-sm"
                              placeholder="Emoji ou nom d’icône"
                              value={current.icone || ''}
                              onChange={(e) => setFullTexte(prev => {
                                const services = [ ...(prev?.specialites?.services || []) ];
                                const base = typeof services[idx] === 'string' ? { titre: services[idx], description: '', image: '', icone: '' } : (services[idx] || {});
                                services[idx] = { ...base, icone: e.target.value };
                                return { ...prev, specialites: { ...prev?.specialites, services } };
                              })}
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Description</label>
                          <textarea
                            className="w-full p-2 rounded bg-gray-700 text-white text-sm min-h-[80px]"
                            value={current.description || ''}
                            onChange={(e) => setFullTexte(prev => {
                              const services = [ ...(prev?.specialites?.services || []) ];
                              const base = typeof services[idx] === 'string' ? { titre: services[idx], description: '', image: '', icone: '' } : (services[idx] || {});
                              services[idx] = { ...base, description: e.target.value };
                              return { ...prev, specialites: { ...prev?.specialites, services } };
                            })}
                          />
                        </div>
                        <div className="mt-2">
                          <label className="block text-xs text-gray-300 mb-1">Image (URL)</label>
                          <input
                            className="w-full p-2 rounded bg-gray-700 text-white text-sm"
                            placeholder="/uploads/nom.jpg ou URL complète"
                            value={current.image || ''}
                            onChange={(e) => setFullTexte(prev => {
                              const services = [ ...(prev?.specialites?.services || []) ];
                              const base = typeof services[idx] === 'string' ? { titre: services[idx], description: '', image: '', icone: '' } : (services[idx] || {});
                              services[idx] = { ...base, image: e.target.value };
                              return { ...prev, specialites: { ...prev?.specialites, services } };
                            })}
                          />
                          {/* Dropzone pour drag-and-drop et choix de fichier */}
                          <div
                            className="mt-2 border-2 border-dashed border-gray-600 rounded p-3 text-center text-xs text-gray-300 hover:border-gray-500"
                            onDragEnter={preventDragDefaults}
                            onDragOver={preventDragDefaults}
                            onDrop={async (e) => {
                              e.preventDefault();
                              const file = e.dataTransfer?.files?.[0];
                              if (!file) return;
                              try {
                                setLoading(true);
                                const url = await AdminService.uploadImage(file, token);
                                setFullTexte(prev => {
                                  const services = [ ...(prev?.specialites?.services || []) ];
                                  const base = typeof services[idx] === 'string' ? { titre: services[idx], description: '', image: '', icone: '' } : (services[idx] || {});
                                  services[idx] = { ...base, image: url };
                                  return { ...prev, specialites: { ...prev?.specialites, services } };
                                });
                              } catch (err) {
                                setError(err.message);
                              } finally {
                                setLoading(false);
                              }
                            }}
                          >
                            Glisser-déposer une image ici ou
                            <label className="ml-1 underline cursor-pointer">
                              choisir un fichier
                              <input
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={async (e) => {
                                  const file = e.target.files?.[0];
                                  if (!file) return;
                                  try {
                                    setLoading(true);
                                    const url = await AdminService.uploadImage(file, token);
                                    setFullTexte(prev => {
                                      const services = [ ...(prev?.specialites?.services || []) ];
                                      const base = typeof services[idx] === 'string' ? { titre: services[idx], description: '', image: '', icone: '' } : (services[idx] || {});
                                      services[idx] = { ...base, image: url };
                                      return { ...prev, specialites: { ...prev?.specialites, services } };
                                    });
                                  } catch (err) {
                                    setError(err.message);
                                  } finally {
                                    setLoading(false);
                                  }
                                }}
                              />
                            </label>
                          </div>
                        </div>
                        <div className="mt-2">
                          <button
                            className="text-xs bg-red-600 px-2 py-1 rounded"
                            onClick={() => setFullTexte(prev => ({
                              ...prev,
                              specialites: {
                                ...prev?.specialites,
                                services: (prev?.specialites?.services || []).filter((_, i) => i !== idx)
                              }
                            }))}
                          >Supprimer</button>
                        </div>
                      </div>
                    );
                  })}
                  <div className="pt-2">
                    <button
                      className="text-xs bg-indigo-600 px-3 py-1 rounded"
                      onClick={() => setFullTexte(prev => ({
                        ...prev,
                        specialites: {
                          ...prev?.specialites,
                          services: [ ...(prev?.specialites?.services || []), { titre: '', description: '', image: '', icone: '' } ]
                        }
                      }))}
                    >Ajouter</button>
                  </div>
                </div>
              </div>
              {/* Images (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Images</label>
                <div className="grid grid-cols-4 gap-2 mb-2">
                  {(fullTexte?.specialites?.images || []).map((img, i) => (
                    <div key={i} className="relative w-16 h-16">
                      {img && <img src={img} alt={`img${i}`} className="w-16 h-16 object-cover rounded" />}
                      <button
                        className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded px-1"
                        onClick={() => setFullTexte(prev => ({
                          ...prev,
                          specialites: {
                            ...prev?.specialites,
                            images: (prev?.specialites?.images || []).filter((_, idx) => idx !== i)
                          }
                        }))}
                      >×</button>
                    </div>
                  ))}
                </div>
                <div
                  className="mb-2 border-2 border-dashed border-gray-600 rounded p-4 text-center text-sm text-gray-300 hover:border-gray-500"
                  onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    const files = Array.from(e.dataTransfer?.files || []);
                    if (!files.length) return;
                    try {
                      setLoading(true);
                      const uploaded = [];
                      for (const f of files) {
                        const url = await AdminService.uploadImage(f, token);
                        uploaded.push(url);
                      }
                      setFullTexte(prev => ({
                        ...prev,
                        specialites: {
                          ...prev?.specialites,
                          images: [ ...(prev?.specialites?.images || []), ...uploaded ]
                        }
                      }));
                    } catch (err) {
                      setError(err.message);
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  Glisser-déposer des images ici ou
                  <label className="ml-1 underline cursor-pointer">
                    choisir des fichiers
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={async (e) => {
                        const files = Array.from(e.target.files || []);
                        if (!files.length) return;
                        try {
                          setLoading(true);
                          const uploaded = [];
                          for (const f of files) {
                            const url = await AdminService.uploadImage(f, token);
                            uploaded.push(url);
                          }
                          setFullTexte(prev => ({
                            ...prev,
                            specialites: {
                              ...prev?.specialites,
                              images: [ ...(prev?.specialites?.images || []), ...uploaded ]
                            }
                          }));
                        } catch (err) {
                          setError(err.message);
                        } finally {
                          setLoading(false);
                        }
                      }}
                    />
                  </label>
                </div>
                <div className="flex gap-2 mt-2">
                  <input
                    type="text"
                    placeholder="Coller un lien d'image"
                    className="flex-1 bg-gray-700 text-white text-sm rounded px-2 py-1"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const val = e.currentTarget.value.trim();
                        if (!val) return;
                        setFullTexte(prev => ({
                          ...prev,
                          specialites: {
                            ...prev?.specialites,
                            images: [ ...(prev?.specialites?.images || []), val ]
                          }
                        }));
                        e.currentTarget.value = '';
                      }
                    }}
                  />
                  <button
                    className="text-xs bg-indigo-600 px-3 py-1 rounded"
                    onClick={(e) => {
                      const input = e.currentTarget.previousSibling;
                      const val = input && input.value ? input.value.trim() : '';
                      if (!val) return;
                      setFullTexte(prev => ({
                        ...prev,
                        specialites: {
                          ...prev?.specialites,
                          images: [ ...(prev?.specialites?.images || []), val ]
                        }
                      }));
                      if (input) input.value = '';
                    }}
                  >Ajouter lien</button>
                </div>
              </div>
            </div>

            {/* SOLUTIONS INNOVANTES */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Solutions innovantes</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.solutions_innovantes?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      solutions_innovantes: { ...prev?.solutions_innovantes, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              {/* Solutions (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Solutions</label>
                <div className="space-y-3">
                  {(fullTexte?.solutions_innovantes?.solutions || []).map((item, idx) => (
                    <div key={idx} className="bg-gray-700 rounded p-3">
                      {typeof item === 'object' && item !== null ? (
                        <div className="space-y-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Nom</label>
                            <input
                              type="text"
                              value={item.nom || ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                solutions_innovantes: {
                                  ...prev?.solutions_innovantes,
                                  solutions: (prev?.solutions_innovantes?.solutions || []).map((it, i) => i === idx ? { ...it, nom: e.target.value } : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Description</label>
                            <textarea
                              value={item.description || ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                solutions_innovantes: {
                                  ...prev?.solutions_innovantes,
                                  solutions: (prev?.solutions_innovantes?.solutions || []).map((it, i) => i === idx ? { ...it, description: e.target.value } : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm min-h-[80px]"
                            />
                          </div>
                          <div className="flex items-center justify-end gap-2">
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                solutions_innovantes: {
                                  ...prev?.solutions_innovantes,
                                  solutions: (prev?.solutions_innovantes?.solutions || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Texte (simple)</label>
                            <input
                              type="text"
                              value={typeof item === 'string' ? item : ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                solutions_innovantes: {
                                  ...prev?.solutions_innovantes,
                                  solutions: (prev?.solutions_innovantes?.solutions || []).map((it, i) => i === idx ? e.target.value : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                            />
                          </div>
                          <div className="flex items-center justify-between">
                            <button
                              className="text-xs bg-indigo-600 px-3 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                solutions_innovantes: {
                                  ...prev?.solutions_innovantes,
                                  solutions: (prev?.solutions_innovantes?.solutions || []).map((it, i) => i === idx ? { nom: typeof it === 'string' ? it : '', description: '' } : it)
                                }
                              }))}
                            >Structurer</button>
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                solutions_innovantes: {
                                  ...prev?.solutions_innovantes,
                                  solutions: (prev?.solutions_innovantes?.solutions || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <button
                  className="text-xs bg-indigo-600 px-3 py-1 rounded mt-2"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    solutions_innovantes: {
                      ...prev?.solutions_innovantes,
                      solutions: [ ...(prev?.solutions_innovantes?.solutions || []), { nom: '', description: '' } ]
                    }
                  }))}
                >Ajouter</button>
              </div>
              {/* Images (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Images</label>
                <div className="grid grid-cols-4 gap-2 mb-2">
                  {(fullTexte?.solutions_innovantes?.images || []).map((img, i) => (
                    <div key={i} className="relative w-16 h-16">
                      {img && <img src={img} alt={`img${i}`} className="w-16 h-16 object-cover rounded" />}
                      <button
                        className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded px-1"
                        onClick={() => setFullTexte(prev => ({
                          ...prev,
                          solutions_innovantes: {
                            ...prev?.solutions_innovantes,
                            images: (prev?.solutions_innovantes?.images || []).filter((_, idx) => idx !== i)
                          }
                        }))}
                      >×</button>
                    </div>
                  ))}
                </div>
                <div
                  className="mb-2 border-2 border-dashed border-gray-600 rounded p-4 text-center text-sm text-gray-300 hover:border-gray-500"
                  onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    const files = Array.from(e.dataTransfer?.files || []);
                    if (!files.length) return;
                    try {
                      setLoading(true);
                      const uploaded = [];
                      for (const f of files) {
                        const url = await AdminService.uploadImage(f, token);
                        uploaded.push(url);
                      }
                      setFullTexte(prev => ({
                        ...prev,
                        solutions_innovantes: {
                          ...prev?.solutions_innovantes,
                          images: [ ...(prev?.solutions_innovantes?.images || []), ...uploaded ]
                        }
                      }));
                    } catch (err) {
                      setError(err.message);
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  Glisser-déposer des images ici ou
                  <label className="ml-1 underline cursor-pointer">
                    choisir des fichiers
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={async (e) => {
                        const files = Array.from(e.target.files || []);
                        if (!files.length) return;
                        try {
                          setLoading(true);
                          const uploaded = [];
                          for (const f of files) {
                            const url = await AdminService.uploadImage(f, token);
                            uploaded.push(url);
                          }
                          setFullTexte(prev => ({
                            ...prev,
                            solutions_innovantes: {
                              ...prev?.solutions_innovantes,
                              images: [ ...(prev?.solutions_innovantes?.images || []), ...uploaded ]
                            }
                          }));
                        } catch (err) {
                          setError(err.message);
                        } finally {
                          setLoading(false);
                        }
                      }}
                    />
                  </label>
                </div>
                <div className="flex gap-2 mt-2">
                  <input
                    type="text"
                    placeholder="Coller un lien d'image"
                    className="flex-1 bg-gray-700 text-white text-sm rounded px-2 py-1"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const val = e.currentTarget.value.trim();
                        if (!val) return;
                        setFullTexte(prev => ({
                          ...prev,
                          solutions_innovantes: {
                            ...prev?.solutions_innovantes,
                            images: [ ...(prev?.solutions_innovantes?.images || []), val ]
                          }
                        }));
                        e.currentTarget.value = '';
                      }
                    }}
                  />
                  <button
                    className="text-xs bg-indigo-600 px-3 py-1 rounded"
                    onClick={(e) => {
                      const input = e.currentTarget.previousSibling;
                      const val = input && input.value ? input.value.trim() : '';
                      if (!val) return;
                      setFullTexte(prev => ({
                        ...prev,
                        solutions_innovantes: {
                          ...prev?.solutions_innovantes,
                          images: [ ...(prev?.solutions_innovantes?.images || []), val ]
                        }
                      }));
                      if (input) input.value = '';
                    }}
                  >Ajouter lien</button>
                </div>
              </div>
            </div>
            {/* GALERIE */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Galerie</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.galerie?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      galerie: { ...(prev?.galerie || {}), titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Images + Descriptions</label>
                <div className="space-y-3">
                  {(() => {
                    const images = Array.isArray(fullTexte?.galerie?.images) ? fullTexte.galerie.images : [];
                    const descriptions = Array.isArray(fullTexte?.galerie?.descriptions) ? fullTexte.galerie.descriptions : [];
                    const maxLen = Math.max(images.length, descriptions.length);
                    return Array.from({ length: maxLen }).map((_, idx) => {
                      const img = images[idx] || '';
                      const desc = descriptions[idx] || '';
                      return (
                        <div key={idx} className="bg-gray-700 rounded p-3">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-start">
                            <div>
                              <label className="block text-xs text-gray-300 mb-1">Image (URL)</label>
                              <input
                                type="text"
                                value={img}
                                onChange={(e) => setFullTexte(prev => ({
                                  ...prev,
                                  galerie: {
                                    ...prev?.galerie,
                                    images: (() => {
                                      const arr = [ ...(prev?.galerie?.images || []) ];
                                      arr[idx] = e.target.value;
                                      return arr;
                                    })()
                                  }
                                }))}
                                className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                                placeholder="ex: /uploads/galerie1.jpg"
                              />
                              {img && (
                                <div className="mt-2">
                                  <img src={resolveImageUrl(img)} alt={`galerie-${idx+1}`} className="w-full h-24 object-cover rounded border border-gray-600" />
                                </div>
                              )}
                              <div
                                className="mt-2 border-2 border-dashed border-gray-600 rounded p-3 text-center text-xs text-gray-300 hover:border-gray-500"
                                onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                onDrop={async (e) => {
                                  e.preventDefault();
                                  const files = Array.from(e.dataTransfer?.files || []);
                                  if (!files.length) return;
                                  try {
                                    setLoading(true);
                                    const file = files[0];
                                    const url = await AdminService.uploadImage(file, token);
                                    setFullTexte(prev => ({
                                      ...prev,
                                      galerie: {
                                        ...prev?.galerie,
                                        images: (() => {
                                          const arr = [ ...(prev?.galerie?.images || []) ];
                                          arr[idx] = url;
                                          return arr;
                                        })()
                                      }
                                    }));
                                  } catch (err) {
                                    setError(err.message);
                                  } finally {
                                    setLoading(false);
                                  }
                                }}
                              >
                                Glisser-déposer une image ici ou
                                <label className="ml-1 underline cursor-pointer">
                                  choisir un fichier
                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={async (e) => {
                                      const file = e.target.files?.[0];
                                      if (!file) return;
                                      try {
                                        setLoading(true);
                                        const url = await AdminService.uploadImage(file, token);
                                        setFullTexte(prev => ({
                                          ...prev,
                                          galerie: {
                                            ...prev?.galerie,
                                            images: (() => {
                                              const arr = [ ...(prev?.galerie?.images || []) ];
                                              arr[idx] = url;
                                              return arr;
                                            })()
                                          }
                                        }));
                                      } catch (err) {
                                        setError(err.message);
                                      } finally {
                                        setLoading(false);
                                      }
                                    }}
                                  />
                                </label>
                              </div>
                            </div>
                            <div>
                              <label className="block text-xs text-gray-300 mb-1">Description</label>
                              <textarea
                                value={desc}
                                onChange={(e) => setFullTexte(prev => ({
                                  ...prev,
                                  galerie: {
                                    ...prev?.galerie,
                                    descriptions: (() => {
                                      const arr = [ ...(prev?.galerie?.descriptions || []) ];
                                      arr[idx] = e.target.value;
                                      return arr;
                                    })()
                                  }
                                }))}
                                className="w-full p-2 rounded bg-gray-600 text-white text-sm min-h-[80px]"
                                placeholder="ex: Rénovation complète de salle de bain"
                              />
                            </div>
                          </div>
                          <div className="flex items-center justify-end gap-2 mt-3">
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                galerie: {
                                  ...prev?.galerie,
                                  images: (prev?.galerie?.images || []).filter((_, i) => i !== idx),
                                  descriptions: (prev?.galerie?.descriptions || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <button
                    className="text-xs bg-indigo-600 px-3 py-1 rounded"
                    onClick={() => setFullTexte(prev => ({
                      ...prev,
                      galerie: {
                        ...prev?.galerie,
                        images: [ ...(prev?.galerie?.images || []), '' ],
                        descriptions: [ ...(prev?.galerie?.descriptions || []), '' ]
                      }
                    }))}
                  >Ajouter paire</button>
                </div>
                <div
                  className="mt-3 border-2 border-dashed border-gray-600 rounded p-4 text-center text-sm text-gray-300 hover:border-gray-500"
                  onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    const files = Array.from(e.dataTransfer?.files || []);
                    if (!files.length) return;
                    try {
                      setLoading(true);
                      const uploaded = [];
                      for (const f of files) {
                        const url = await AdminService.uploadImage(f, token);
                        uploaded.push(url);
                      }
                      setFullTexte(prev => ({
                        ...prev,
                        galerie: {
                          ...prev?.galerie,
                          images: [ ...(prev?.galerie?.images || []), ...uploaded ],
                          descriptions: [ ...(prev?.galerie?.descriptions || []), ...uploaded.map(() => '') ]
                        }
                      }));
                    } catch (err) {
                      setError(err.message);
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  Glisser-déposer des images ici ou
                  <label className="ml-1 underline cursor-pointer">
                    choisir des fichiers
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={async (e) => {
                        const files = Array.from(e.target.files || []);
                        if (!files.length) return;
                        try {
                          setLoading(true);
                          const uploaded = [];
                          for (const f of files) {
                            const url = await AdminService.uploadImage(f, token);
                            uploaded.push(url);
                          }
                          setFullTexte(prev => ({
                            ...prev,
                            galerie: {
                              ...prev?.galerie,
                              images: [ ...(prev?.galerie?.images || []), ...uploaded ],
                              descriptions: [ ...(prev?.galerie?.descriptions || []), ...uploaded.map(() => '') ]
                            }
                          }));
                        } catch (err) {
                          setError(err.message);
                        } finally {
                          setLoading(false);
                        }
                      }}
                    />
                  </label>
                </div>
                <div className="flex gap-2 mt-2">
                  <input
                    type="text"
                    placeholder="Coller un lien d'image"
                    className="flex-1 bg-gray-700 text-white text-sm rounded px-2 py-1"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const val = e.currentTarget.value.trim();
                        if (!val) return;
                        setFullTexte(prev => ({
                          ...prev,
                          galerie: {
                            ...prev?.galerie,
                            images: [ ...(prev?.galerie?.images || []), val ],
                            descriptions: [ ...(prev?.galerie?.descriptions || []), '' ]
                          }
                        }));
                        e.currentTarget.value = '';
                      }
                    }}
                  />
                  <button
                    className="text-xs bg-indigo-600 px-3 py-1 rounded"
                    onClick={(e) => {
                      const input = e.currentTarget.previousSibling;
                      const val = input && input.value ? input.value.trim() : '';
                      if (!val) return;
                      setFullTexte(prev => ({
                        ...prev,
                        galerie: {
                          ...prev?.galerie,
                          images: [ ...(prev?.galerie?.images || []), val ],
                          descriptions: [ ...(prev?.galerie?.descriptions || []), '' ]
                        }
                      }));
                      if (input) input.value = '';
                    }}
                  >Ajouter lien</button>
                </div>
              </div>
            </div>
            {/* POURQUOI CHOISIR */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Pourquoi choisir</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.pourquoi_choisir?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      pourquoi_choisir: { ...prev?.pourquoi_choisir, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              {/* Raisons (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Raisons</label>
                <div className="space-y-3">
                  {(fullTexte?.pourquoi_choisir?.raisons || []).map((item, idx) => (
                    <div key={idx} className="bg-gray-700 rounded p-3">
                      {typeof item === 'object' && item !== null ? (
                        <div className="space-y-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Icône</label>
                            <input
                              type="text"
                              value={item.icone || ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                pourquoi_choisir: {
                                  ...prev?.pourquoi_choisir,
                                  raisons: (prev?.pourquoi_choisir?.raisons || []).map((it, i) => i === idx ? { ...it, icone: e.target.value } : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                              placeholder="ex: check-circle (nom d’icône)"
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Titre</label>
                            <input
                              type="text"
                              value={item.titre || ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                pourquoi_choisir: {
                                  ...prev?.pourquoi_choisir,
                                  raisons: (prev?.pourquoi_choisir?.raisons || []).map((it, i) => i === idx ? { ...it, titre: e.target.value } : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                              placeholder="ex: Intervention rapide"
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Description</label>
                            <textarea
                              value={item.description || ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                pourquoi_choisir: {
                                  ...prev?.pourquoi_choisir,
                                  raisons: (prev?.pourquoi_choisir?.raisons || []).map((it, i) => i === idx ? { ...it, description: e.target.value } : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm min-h-[80px]"
                              placeholder="ex: Nous intervenons sous 24h"
                            />
                          </div>
                          <div className="flex items-center justify-end gap-2">
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                pourquoi_choisir: {
                                  ...prev?.pourquoi_choisir,
                                  raisons: (prev?.pourquoi_choisir?.raisons || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Texte (simple)</label>
                            <input
                              type="text"
                              value={typeof item === 'string' ? item : ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                pourquoi_choisir: {
                                  ...prev?.pourquoi_choisir,
                                  raisons: (prev?.pourquoi_choisir?.raisons || []).map((it, i) => i === idx ? e.target.value : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                              placeholder="ex: Intervention rapide en 24h"
                            />
                          </div>
                          <div className="flex items-center justify-between">
                            <button
                              className="text-xs bg-indigo-600 px-3 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                pourquoi_choisir: {
                                  ...prev?.pourquoi_choisir,
                                  raisons: (prev?.pourquoi_choisir?.raisons || []).map((it, i) => i === idx ? { icone: '', titre: typeof it === 'string' ? it : '', description: '' } : it)
                                }
                              }))}
                            >Structurer</button>
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                pourquoi_choisir: {
                                  ...prev?.pourquoi_choisir,
                                  raisons: (prev?.pourquoi_choisir?.raisons || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <button
                  className="text-xs bg-indigo-600 px-3 py-1 rounded mt-2"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    pourquoi_choisir: {
                      ...prev?.pourquoi_choisir,
                      raisons: [ ...(prev?.pourquoi_choisir?.raisons || []), { icone: '', titre: '', description: '' } ]
                    }
                  }))}
                >Ajouter</button>
              </div>
            </div>

            {/* ZONE D'INTERVENTION */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Zone d'intervention</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.zone_intervention?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      zone_intervention: { ...prev?.zone_intervention, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              {/* Quartiers (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Quartiers</label>
                {(fullTexte?.zone_intervention?.quartiers || []).map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 mb-2">
                    <input
                      type="text"
                      value={typeof item === 'string' ? item : JSON.stringify(item)}
                      onChange={(e) => setFullTexte(prev => ({
                        ...prev,
                        zone_intervention: {
                          ...prev?.zone_intervention,
                          quartiers: (prev?.zone_intervention?.quartiers || []).map((it, i) => i === idx ? e.target.value : it)
                        }
                      }))}
                      className="flex-1 p-2 rounded bg-gray-700 text-white text-sm"
                    />
                    <button
                      className="text-xs bg-red-600 px-2 py-1 rounded"
                      onClick={() => setFullTexte(prev => ({
                        ...prev,
                        zone_intervention: {
                          ...prev?.zone_intervention,
                          quartiers: (prev?.zone_intervention?.quartiers || []).filter((_, i) => i !== idx)
                        }
                      }))}
                    >Supprimer</button>
                  </div>
                ))}
                <button
                  className="text-xs bg-indigo-600 px-3 py-1 rounded"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    zone_intervention: {
                      ...prev?.zone_intervention,
                      quartiers: [ ...(prev?.zone_intervention?.quartiers || []), '' ]
                    }
                  }))}
                >Ajouter</button>
              </div>
              {/* Proximité (nested) */}
              <div className="mt-6">
                <h4 className="text-md font-semibold mb-2">Proximité</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Titre</label>
                    <input
                      type="text"
                      value={fullTexte?.zone_intervention?.proximite?.titre || ''}
                      onChange={(e) => setFullTexte(prev => ({
                        ...prev,
                        zone_intervention: {
                          ...prev?.zone_intervention,
                          proximite: { ...(prev?.zone_intervention?.proximite || {}), titre: e.target.value }
                        }
                      }))}
                      className="w-full p-3 rounded bg-gray-700 text-white"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-300 mb-1">Contact</label>
                    <input
                      type="text"
                      value={fullTexte?.zone_intervention?.proximite?.contact || ''}
                      onChange={(e) => setFullTexte(prev => ({
                        ...prev,
                        zone_intervention: {
                          ...prev?.zone_intervention,
                          proximite: { ...(prev?.zone_intervention?.proximite || {}), contact: e.target.value }
                        }
                      }))}
                      className="w-full p-3 rounded bg-gray-700 text-white"
                    />
                  </div>
                </div>
                {/* Avantages (array) */}
                <div className="mt-4">
                  <label className="block text-sm text-gray-300 mb-2">Avantages</label>
                  {(fullTexte?.zone_intervention?.proximite?.avantages || []).map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2 mb-2">
                      <input
                        type="text"
                        value={typeof item === 'string' ? item : JSON.stringify(item)}
                        onChange={(e) => setFullTexte(prev => ({
                          ...prev,
                          zone_intervention: {
                            ...prev?.zone_intervention,
                            proximite: {
                              ...(prev?.zone_intervention?.proximite || {}),
                              avantages: (prev?.zone_intervention?.proximite?.avantages || []).map((it, i) => i === idx ? e.target.value : it)
                            }
                          }
                        }))}
                        className="flex-1 p-2 rounded bg-gray-700 text-white text-sm"
                      />
                      <button
                        className="text-xs bg-red-600 px-2 py-1 rounded"
                        onClick={() => setFullTexte(prev => ({
                          ...prev,
                          zone_intervention: {
                            ...prev?.zone_intervention,
                            proximite: {
                              ...(prev?.zone_intervention?.proximite || {}),
                              avantages: (prev?.zone_intervention?.proximite?.avantages || []).filter((_, i) => i !== idx)
                            }
                          }
                        }))}
                      >Supprimer</button>
                    </div>
                  ))}
                  <button
                    className="text-xs bg-indigo-600 px-3 py-1 rounded"
                    onClick={() => setFullTexte(prev => ({
                      ...prev,
                      zone_intervention: {
                        ...prev?.zone_intervention,
                        proximite: {
                          ...(prev?.zone_intervention?.proximite || {}),
                          avantages: [ ...(prev?.zone_intervention?.proximite?.avantages || []), '' ]
                        }
                      }
                    }))}
                  >Ajouter</button>
                </div>
              </div>
            </div>

            {/* TÉMOIGNAGES */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Témoignages</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.temoignages?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      temoignages: { ...prev?.temoignages, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              {/* Liste (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Liste</label>
                {(fullTexte?.temoignages?.liste || []).map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 mb-2">
                    <textarea
                      value={typeof item === 'string' ? item : JSON.stringify(item, null, 2)}
                      onChange={(e) => setFullTexte(prev => ({
                        ...prev,
                        temoignages: {
                          ...prev?.temoignages,
                          liste: (prev?.temoignages?.liste || []).map((it, i) => i === idx ? e.target.value : it)
                        }
                      }))}
                      className="flex-1 p-2 rounded bg-gray-700 text-white text-sm min-h-[80px]"
                    />
                    <button
                      className="text-xs bg-red-600 px-2 py-1 rounded"
                      onClick={() => setFullTexte(prev => ({
                        ...prev,
                        temoignages: {
                          ...prev?.temoignages,
                          liste: (prev?.temoignages?.liste || []).filter((_, i) => i !== idx)
                        }
                      }))}
                    >Supprimer</button>
                  </div>
                ))}
                <button
                  className="text-xs bg-indigo-600 px-3 py-1 rounded"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    temoignages: {
                      ...prev?.temoignages,
                      liste: [ ...(prev?.temoignages?.liste || []), '' ]
                    }
                  }))}
                >Ajouter</button>
              </div>
            </div>

            {/* GARANTIES */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Garanties</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.garanties?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      garanties: { ...prev?.garanties, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              {/* Images + Textes appariés par index */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Images + Textes</label>
                <div className="space-y-3">
                  {(() => {
                    const images = Array.isArray(fullTexte?.garanties?.images) ? fullTexte.garanties.images : [];
                    const textes = Array.isArray(fullTexte?.garanties?.liste) ? fullTexte.garanties.liste : [];
                    const maxLen = Math.max(images.length, textes.length);
                    return Array.from({ length: maxLen }).map((_, idx) => {
                      const img = images[idx] || '';
                      const txt = textes[idx];
                      return (
                        <div key={idx} className="bg-gray-700 rounded p-3">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-start">
                            <div>
                              <label className="block text-xs text-gray-300 mb-1">Image (URL)</label>
                              <input
                                type="text"
                                value={img}
                                onChange={(e) => setFullTexte(prev => ({
                                  ...prev,
                                  garanties: {
                                    ...prev?.garanties,
                                    images: (() => {
                                      const arr = [ ...(prev?.garanties?.images || []) ];
                                      arr[idx] = e.target.value;
                                      return arr;
                                    })()
                                  }
                                }))}
                                className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                                placeholder="ex: /uploads/garantie1.jpg"
                              />
                              {img && (
                                <div className="mt-2">
                                  <img src={resolveImageUrl(img)} alt={`garantie-${idx+1}`} className="w-full h-24 object-cover rounded border border-gray-600" />
                                </div>
                              )}
                              <div
                                className="mt-2 border-2 border-dashed border-gray-600 rounded p-3 text-center text-xs text-gray-300 hover:border-gray-500"
                                onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                onDrop={async (e) => {
                                  e.preventDefault();
                                  const files = Array.from(e.dataTransfer?.files || []);
                                  if (!files.length) return;
                                  try {
                                    setLoading(true);
                                    const file = files[0];
                                    const url = await AdminService.uploadImage(file, token);
                                    setFullTexte(prev => ({
                                      ...prev,
                                      garanties: {
                                        ...prev?.garanties,
                                        images: (() => {
                                          const arr = [ ...(prev?.garanties?.images || []) ];
                                          arr[idx] = url;
                                          return arr;
                                        })()
                                      }
                                    }));
                                  } catch (err) {
                                    setError(err.message);
                                  } finally {
                                    setLoading(false);
                                  }
                                }}
                              >
                                Glisser-déposer une image ici ou
                                <label className="ml-1 underline cursor-pointer">
                                  choisir un fichier
                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={async (e) => {
                                      const file = e.target.files?.[0];
                                      if (!file) return;
                                      try {
                                        setLoading(true);
                                        const url = await AdminService.uploadImage(file, token);
                                        setFullTexte(prev => ({
                                          ...prev,
                                          garanties: {
                                            ...prev?.garanties,
                                            images: (() => {
                                              const arr = [ ...(prev?.garanties?.images || []) ];
                                              arr[idx] = url;
                                              return arr;
                                            })()
                                          }
                                        }));
                                      } catch (err) {
                                        setError(err.message);
                                      } finally {
                                        setLoading(false);
                                      }
                                    }}
                                  />
                                </label>
                              </div>
                              
                            </div>
                            <div>
                              {typeof txt === 'object' && txt !== null ? (
                                <div className="space-y-2">
                                  <label className="block text-xs text-gray-300 mb-1">Texte</label>
                                  <input
                                    type="text"
                                    value={txt.nom || ''}
                                    onChange={(e) => setFullTexte(prev => ({
                                      ...prev,
                                      garanties: {
                                        ...prev?.garanties,
                                        liste: (prev?.garanties?.liste || []).map((it, i) => i === idx ? { ...it, nom: e.target.value } : it)
                                      }
                                    }))}
                                    className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                                    placeholder="ex: Garantie décennale"
                                  />
                                  <label className="block text-xs text-gray-300 mb-1">Description</label>
                                  <textarea
                                    value={txt.description || ''}
                                    onChange={(e) => setFullTexte(prev => ({
                                      ...prev,
                                      garanties: {
                                        ...prev?.garanties,
                                        liste: (prev?.garanties?.liste || []).map((it, i) => i === idx ? { ...it, description: e.target.value } : it)
                                      }
                                    }))}
                                    className="w-full p-2 rounded bg-gray-600 text-white text-sm min-h-[80px]"
                                    placeholder="ex: Couverture des travaux pendant 10 ans"
                                  />
                                </div>
                              ) : (
                                <div>
                                  <label className="block text-xs text-gray-300 mb-1">Texte</label>
                                  <input
                                    type="text"
                                    value={typeof txt === 'string' ? txt : ''}
                                    onChange={(e) => setFullTexte(prev => ({
                                      ...prev,
                                      garanties: {
                                        ...prev?.garanties,
                                        liste: (() => {
                                          const arr = [ ...(prev?.garanties?.liste || []) ];
                                          arr[idx] = e.target.value;
                                          return arr;
                                        })()
                                      }
                                    }))}
                                    className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                                    placeholder="ex: Garantie décennale"
                                  />
                                  <div className="flex items-center justify-between mt-2">
                                    <button
                                      className="text-xs bg-indigo-600 px-3 py-1 rounded"
                                      onClick={() => setFullTexte(prev => ({
                                        ...prev,
                                        garanties: {
                                          ...prev?.garanties,
                                          liste: (prev?.garanties?.liste || []).map((it, i) => i === idx ? { nom: typeof it === 'string' ? it : '', description: '' } : it)
                                        }
                                      }))}
                                    >Structurer</button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center justify-end gap-2 mt-3">
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                garanties: {
                                  ...prev?.garanties,
                                  images: (prev?.garanties?.images || []).filter((_, i) => i !== idx),
                                  liste: (prev?.garanties?.liste || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <button
                    className="text-xs bg-indigo-600 px-3 py-1 rounded"
                    onClick={() => setFullTexte(prev => ({
                      ...prev,
                      garanties: {
                        ...prev?.garanties,
                        images: [ ...(prev?.garanties?.images || []), '' ],
                        liste: [ ...(prev?.garanties?.liste || []), '' ]
                      }
                    }))}
                  >Ajouter paire</button>
                </div>
                {/* Zone d'upload / drag & drop pour ajouter des paires */}
                <div
                  className="mt-3 border-2 border-dashed border-gray-600 rounded p-4 text-center text-sm text-gray-300 hover:border-gray-500"
                  onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    const files = Array.from(e.dataTransfer?.files || []);
                    if (!files.length) return;
                    try {
                      setLoading(true);
                      const uploaded = [];
                      for (const f of files) {
                        const url = await AdminService.uploadImage(f, token);
                        uploaded.push(url);
                      }
                      setFullTexte(prev => ({
                        ...prev,
                        garanties: {
                          ...prev?.garanties,
                          images: [ ...(prev?.garanties?.images || []), ...uploaded ],
                          liste: [ ...(prev?.garanties?.liste || []), ...uploaded.map(() => '') ]
                        }
                      }));
                    } catch (err) {
                      setError(err.message);
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  Glisser-déposer des images ici ou
                  <label className="ml-1 underline cursor-pointer">
                    choisir des fichiers
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={async (e) => {
                        const files = Array.from(e.target.files || []);
                        if (!files.length) return;
                        try {
                          setLoading(true);
                          const uploaded = [];
                          for (const f of files) {
                            const url = await AdminService.uploadImage(f, token);
                            uploaded.push(url);
                          }
                          setFullTexte(prev => ({
                            ...prev,
                            garanties: {
                              ...prev?.garanties,
                              images: [ ...(prev?.garanties?.images || []), ...uploaded ],
                              liste: [ ...(prev?.garanties?.liste || []), ...uploaded.map(() => '') ]
                            }
                          }));
                        } catch (err) {
                          setError(err.message);
                        } finally {
                          setLoading(false);
                        }
                      }}
                    />
                  </label>
                </div>
                {/* Ajout via lien direct */}
                <div className="flex gap-2 mt-2">
                  <input
                    type="text"
                    placeholder="Coller un lien d'image"
                    className="flex-1 bg-gray-700 text-white text-sm rounded px-2 py-1"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const val = e.currentTarget.value.trim();
                        if (!val) return;
                        setFullTexte(prev => ({
                          ...prev,
                          garanties: {
                            ...prev?.garanties,
                            images: [ ...(prev?.garanties?.images || []), val ],
                            liste: [ ...(prev?.garanties?.liste || []), '' ]
                          }
                        }));
                        e.currentTarget.value = '';
                      }
                    }}
                  />
                  <button
                    className="text-xs bg-indigo-600 px-3 py-1 rounded"
                    onClick={(e) => {
                      const input = e.currentTarget.previousSibling;
                      const val = input && input.value ? input.value.trim() : '';
                      if (!val) return;
                      setFullTexte(prev => ({
                        ...prev,
                        garanties: {
                          ...prev?.garanties,
                          images: [ ...(prev?.garanties?.images || []), val ],
                          liste: [ ...(prev?.garanties?.liste || []), '' ]
                        }
                      }));
                      if (input) input.value = '';
                    }}
                  >Ajouter lien</button>
                </div>
              </div>
            </div>

            {/* PROCESSUS */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Processus</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.processus?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      processus: { ...prev?.processus, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
              </div>
              {/* Étapes (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Étapes</label>
                <div className="space-y-3">
                  {(fullTexte?.processus?.etapes || []).map((item, idx) => (
                    <div key={idx} className="bg-gray-700 rounded p-3">
                      {typeof item === 'object' && item !== null ? (
                        <div className="space-y-3">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Nom</label>
                            <input
                              type="text"
                              value={item.nom || ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                processus: {
                                  ...prev?.processus,
                                  etapes: (prev?.processus?.etapes || []).map((it, i) => i === idx ? { ...it, nom: e.target.value } : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                              placeholder="ex: Prise de contact"
                            />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Description</label>
                            <textarea
                              value={item.description || ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                processus: {
                                  ...prev?.processus,
                                  etapes: (prev?.processus?.etapes || []).map((it, i) => i === idx ? { ...it, description: e.target.value } : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm min-h-[80px]"
                              placeholder="ex: Nous définissons vos besoins"
                            />
                          </div>
                          <div className="flex items-center justify-end gap-2">
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                processus: {
                                  ...prev?.processus,
                                  etapes: (prev?.processus?.etapes || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          <div>
                            <label className="block text-xs text-gray-300 mb-1">Texte (simple)</label>
                            <input
                              type="text"
                              value={typeof item === 'string' ? item : ''}
                              onChange={(e) => setFullTexte(prev => ({
                                ...prev,
                                processus: {
                                  ...prev?.processus,
                                  etapes: (prev?.processus?.etapes || []).map((it, i) => i === idx ? e.target.value : it)
                                }
                              }))}
                              className="w-full p-2 rounded bg-gray-600 text-white text-sm"
                              placeholder="ex: Prise de contact"
                            />
                          </div>
                          <div className="flex items-center justify-between">
                            <button
                              className="text-xs bg-indigo-600 px-3 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                processus: {
                                  ...prev?.processus,
                                  etapes: (prev?.processus?.etapes || []).map((it, i) => i === idx ? { nom: typeof it === 'string' ? it : '', description: '' } : it)
                                }
                              }))}
                            >Structurer</button>
                            <button
                              className="text-xs border border-gray-500 px-2 py-1 rounded"
                              onClick={() => setFullTexte(prev => ({
                                ...prev,
                                processus: {
                                  ...prev?.processus,
                                  etapes: (prev?.processus?.etapes || []).filter((_, i) => i !== idx)
                                }
                              }))}
                            >Supprimer</button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <button
                  className="text-xs bg-indigo-600 px-3 py-1 rounded mt-2"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    processus: {
                      ...prev?.processus,
                      etapes: [ ...(prev?.processus?.etapes || []), { nom: '', description: '' } ]
                    }
                  }))}
                >Ajouter</button>
              </div>
            </div>

            {/* CALL TO ACTION */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-2">Call to action</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Titre</label>
                  <input
                    type="text"
                    value={fullTexte?.call_to_action?.titre || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      call_to_action: { ...prev?.call_to_action, titre: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-300 mb-1">Description</label>
                  <textarea
                    value={fullTexte?.call_to_action?.description || ''}
                    onChange={(e) => setFullTexte(prev => ({
                      ...prev,
                      call_to_action: { ...prev?.call_to_action, description: e.target.value }
                    }))}
                    className="w-full p-3 rounded bg-gray-700 text-white min-h-[100px]"
                  />
                </div>
              </div>
              {/* Boutons (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Boutons</label>
                {(fullTexte?.call_to_action?.boutons || []).map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 mb-2">
                    <input
                      type="text"
                      value={typeof item === 'string' ? item : JSON.stringify(item)}
                      onChange={(e) => setFullTexte(prev => ({
                        ...prev,
                        call_to_action: {
                          ...prev?.call_to_action,
                          boutons: (prev?.call_to_action?.boutons || []).map((it, i) => i === idx ? e.target.value : it)
                        }
                      }))}
                      className="flex-1 p-2 rounded bg-gray-700 text-white text-sm"
                    />
                    <button
                      className="text-xs bg-red-600 px-2 py-1 rounded"
                      onClick={() => setFullTexte(prev => ({
                        ...prev,
                        call_to_action: {
                          ...prev?.call_to_action,
                          boutons: (prev?.call_to_action?.boutons || []).filter((_, i) => i !== idx)
                        }
                      }))}
                    >Supprimer</button>
                  </div>
                ))}
                <button
                  className="text-xs bg-indigo-600 px-3 py-1 rounded"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    call_to_action: {
                      ...prev?.call_to_action,
                      boutons: [ ...(prev?.call_to_action?.boutons || []), '' ]
                    }
                  }))}
                >Ajouter</button>
              </div>
              {/* Garanties CTA (array) */}
              <div className="mt-4">
                <label className="block text-sm text-gray-300 mb-2">Garanties (CTA)</label>
                {(fullTexte?.call_to_action?.garanties || []).map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2 mb-2">
                    <input
                      type="text"
                      value={typeof item === 'string' ? item : JSON.stringify(item)}
                      onChange={(e) => setFullTexte(prev => ({
                        ...prev,
                        call_to_action: {
                          ...prev?.call_to_action,
                          garanties: (prev?.call_to_action?.garanties || []).map((it, i) => i === idx ? e.target.value : it)
                        }
                      }))}
                      className="flex-1 p-2 rounded bg-gray-700 text-white text-sm"
                    />
                    <button
                      className="text-xs bg-red-600 px-2 py-1 rounded"
                      onClick={() => setFullTexte(prev => ({
                        ...prev,
                        call_to_action: {
                          ...prev?.call_to_action,
                          garanties: (prev?.call_to_action?.garanties || []).filter((_, i) => i !== idx)
                        }
                      }))}
                    >Supprimer</button>
                  </div>
                ))}
                <button
                  className="text-xs bg-indigo-600 px-3 py-1 rounded"
                  onClick={() => setFullTexte(prev => ({
                    ...prev,
                    call_to_action: {
                      ...prev?.call_to_action,
                      garanties: [ ...(prev?.call_to_action?.garanties || []), '' ]
                    }
                  }))}
                >Ajouter</button>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button className="border border-gray-500 px-4 py-2 rounded" onClick={() => setShowFullEditor(false)}>Annuler</button>
              <button className="bg-primary text-white px-4 py-2 rounded" onClick={saveFullTemplate}>Enregistrer</button>
            </div>
          </div>
        </div>
      )}

      {/* Details Modal (Contenu) */}
      {showDetails && selectedTemplate && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto relative">
            {/* En-tête modale alignée */}
            <div className="relative flex items-center justify-between mb-4">
              <div className="flex justify-start">
                <button
                  className="rounded-full w-8 h-8 flex items-center justify-center bg-gray-800 border border-gray-600 text-white hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => { setShowDetails(false); setSelectedTemplate(null); }}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                </button>
              </div>
              <div className="absolute left-1/2 -translate-x-1/2">
                <h2 className="text-2xl font-bold text-center">Détails du template: {selectedTemplate?.categorie?.nom || selectedTemplate?.name || 'Overall'}</h2>
              </div>
              <div className="flex justify-end w-full">
                <button
                  className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
                  title="Éditer"
                  aria-label="Éditer"
                  onClick={() => { setShowDetails(false); openFullEditor(selectedTemplate); }}
                >Éditer</button>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <div className="text-gray-400 text-sm">ObjectID</div>
                <div className="text-white text-sm break-all">{selectedTemplate?._id}</div>
              </div>
              <div>
                <div className="text-gray-400 text-sm">Type</div>
                <div className="text-white text-sm">{selectedTemplate?.type}</div>
              </div>
              <div>
                <div className="text-gray-400 text-sm">Actif</div>
                <div className="text-white text-sm">{selectedTemplate?.actif ? 'Oui' : 'Non'}</div>
              </div>
            </div>
            <div className="max-h-[50vh] overflow-auto bg-gray-900 rounded p-4 text-xs">
              {renderValue(selectedTemplate?.texte || {})}
            </div>
            <div className="flex justify-end gap-3 mt-6">
              <button className="border border-gray-500 px-4 py-2 rounded" onClick={() => { setShowDetails(false); setSelectedTemplate(null); }}>Fermer</button>
            </div>
          </div>
        </div>
      )}

      {/* Details Modal (Page) */}
      {showDetails && selectedPage && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto relative">
            {/* En-tête modale alignée */}
            <div className="relative flex items-center justify-between mb-4">
              <div className="flex justify-start">
                <button
                  className="rounded-full w-8 h-8 flex items-center justify-center bg-gray-800 border border-gray-600 text-white hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => { setShowDetails(false); setSelectedPage(null); }}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                </button>
              </div>
              <div className="absolute left-1/2 -translate-x-1/2">
                <h2 className="text-2xl font-bold text-center">Détails de la page: {selectedPage?.title || selectedPage?.slug}</h2>
              </div>
              <div className="flex justify-end w-full">
                <button
                  className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
                  title="Éditer"
                  aria-label="Éditer"
                  onClick={() => { setPageDetailsEditMode(true); }}
                >Éditer</button>
              </div>
            </div>
            {detailsOverallTemplate ? (
              <div className="bg-gray-900 rounded p-4 text-sm">
                <div className="font-semibold mb-4">Accueil / À propos</div>
                {overallDetailsForm.hero.background_image && (
                  <img src={resolveImageUrl(overallDetailsForm.hero.background_image)} alt="Hero" className="w-full h-32 object-cover rounded mb-3" />
                )}
                {!pageDetailsEditMode ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <div className="text-gray-400 text-xs">Titre principal</div>
                      <div className="text-white text-xs">{overallDetailsForm.hero.titre_principal || '—'}</div>
                    </div>
                    <div>
                      <div className="text-gray-400 text-xs">Sous-titre</div>
                      <div className="text-white text-xs">{overallDetailsForm.hero.sous_titre || '—'}</div>
                    </div>
                    <div className="md:col-span-2">
                      <div className="text-gray-400 text-xs">Description</div>
                      <div className="text-white text-xs whitespace-pre-line">{overallDetailsForm.hero.description || '—'}</div>
                    </div>
                    <div>
                      <div className="text-gray-400 text-xs">Bouton principal</div>
                      <div className="text-white text-xs">{overallDetailsForm.hero.bouton_principal || '—'}</div>
                    </div>
                    <div>
                      <div className="text-gray-400 text-xs">Bouton secondaire</div>
                      <div className="text-white text-xs">{overallDetailsForm.hero.bouton_secondaire || '—'}</div>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Titre principal</label>
                      <input className="w-full p-2 rounded bg-gray-700 text-white" value={overallDetailsForm.hero.titre_principal} onChange={(e) => setOverallDetailsForm(prev => ({ ...prev, hero: { ...prev.hero, titre_principal: e.target.value } }))} />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Sous-titre</label>
                      <input className="w-full p-2 rounded bg-gray-700 text-white" value={overallDetailsForm.hero.sous_titre} onChange={(e) => setOverallDetailsForm(prev => ({ ...prev, hero: { ...prev.hero, sous_titre: e.target.value } }))} />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Description</label>
                      <textarea className="w-full p-2 rounded bg-gray-700 text-white h-20" value={overallDetailsForm.hero.description} onChange={(e) => setOverallDetailsForm(prev => ({ ...prev, hero: { ...prev.hero, description: e.target.value } }))} />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-gray-300 mb-1">Bouton principal</label>
                        <input className="w-full p-2 rounded bg-gray-700 text-white" value={overallDetailsForm.hero.bouton_principal} onChange={(e) => setOverallDetailsForm(prev => ({ ...prev, hero: { ...prev.hero, bouton_principal: e.target.value } }))} />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-300 mb-1">Bouton secondaire</label>
                        <input className="w-full p-2 rounded bg-gray-700 text-white" value={overallDetailsForm.hero.bouton_secondaire} onChange={(e) => setOverallDetailsForm(prev => ({ ...prev, hero: { ...prev.hero, bouton_secondaire: e.target.value } }))} />
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs text-gray-300 mb-1">Image de fond (URL)</label>
                      <input className="w-full p-2 rounded bg-gray-700 text-white" value={overallDetailsForm.hero.background_image} onChange={(e) => setOverallDetailsForm(prev => ({ ...prev, hero: { ...prev.hero, background_image: e.target.value } }))} />
                    </div>
                    <div className="flex justify-end gap-2">
                      <button className="border border-gray-500 px-3 py-1 rounded" onClick={() => setPageDetailsEditMode(false)}>Terminer</button>
                      <button className="bg-primary text-white px-3 py-1 rounded" onClick={async () => {
                        try {
                          setPagesLoading(true);
                          setPagesError(null);
                          await AdminService.updateProperty('overall', 'hero', 'titre_principal', overallDetailsForm.hero.titre_principal, token);
                          await AdminService.updateProperty('overall', 'hero', 'sous_titre', overallDetailsForm.hero.sous_titre, token);
                          await AdminService.updateProperty('overall', 'hero', 'description', overallDetailsForm.hero.description, token);
                          await AdminService.updateProperty('overall', 'hero', 'bouton_principal', overallDetailsForm.hero.bouton_principal, token);
                          await AdminService.updateProperty('overall', 'hero', 'bouton_secondaire', overallDetailsForm.hero.bouton_secondaire, token);
                          await AdminService.updateProperty('overall', 'hero', 'background_image', overallDetailsForm.hero.background_image, token);
                          // Update local
                          const updatedTpl = { ...detailsOverallTemplate };
                          if (!updatedTpl.texte) updatedTpl.texte = {};
                          updatedTpl.texte.hero = { ...updatedTpl.texte.hero, ...overallDetailsForm.hero };
                          setDetailsOverallTemplate(updatedTpl);
                          setPageDetailsEditMode(false);
                        } catch (err) {
                          setPagesError(err?.message || 'Sauvegarde échouée');
                        } finally {
                          setPagesLoading(false);
                        }
                      }}>Sauvegarder</button>
                    </div>
                  </div>
                )}

                {/* Sections Accueil (édition complète) */}
                {selectedPage?.slug === 'accueil' && (
                  <div className="mt-6 bg-gray-900 rounded p-4 text-sm">
                    <div className="font-semibold mb-2">Sections Accueil</div>
                    <div className="space-y-3 max-h-[40vh] overflow-auto">
                      {(pageForm?.sections || []).map((sec, idx) => (
                        <div key={sec.key || idx} className="bg-gray-800 rounded p-3">
                          <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                            <div>
                              <div className="text-gray-400 text-xs">Key</div>
                              <div className="text-white text-xs">{sec.key || '—'}</div>
                            </div>
                            <div>
                              <div className="text-gray-400 text-xs">Type</div>
                              <div className="text-white text-xs">{sec.type || '—'}</div>
                            </div>
                            <div>
                              <div className="text-gray-400 text-xs">Ordre</div>
                              <div className="text-white text-xs">{sec.order ?? 0}</div>
                            </div>
                            <div>
                              <div className="text-gray-400 text-xs">Actif</div>
                              <div className="text-white text-xs">{sec.actif ? 'Oui' : 'Non'}</div>
                            </div>
                          </div>
                          {sec?.data?.background_image && (
                            <img src={resolveImageUrl(sec.data.background_image)} alt={sec.title || sec.key || 'Section'} className="w-full h-24 object-cover rounded mt-2" />
                          )}
                          {!pageDetailsEditMode ? (
                            <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div>
                                <div className="text-gray-400 text-xs">Title (FR)</div>
                                <div className="text-white text-xs">{(sec.data?.title?.fr) || sec.title || '—'}</div>
                              </div>
                              <div>
                                <div className="text-gray-400 text-xs">Title (EN)</div>
                                <div className="text-white text-xs">{(sec.data?.title?.en) || '—'}</div>
                              </div>
                              <div>
                                <div className="text-gray-400 text-xs">Subtitle (FR)</div>
                                <div className="text-white text-xs">{(sec.data?.subtitle?.fr) || '—'}</div>
                              </div>
                              <div>
                                <div className="text-gray-400 text-xs">Subtitle (EN)</div>
                                <div className="text-white text-xs">{(sec.data?.subtitle?.en) || '—'}</div>
                              </div>
                              <div className="md:col-span-2">
                                <div className="text-gray-400 text-xs">Description (FR)</div>
                                <div className="text-white text-xs whitespace-pre-line">{(sec.data?.description?.fr) || '—'}</div>
                              </div>
                              <div className="md:col-span-2">
                                <div className="text-gray-400 text-xs">Description (EN)</div>
                                <div className="text-white text-xs whitespace-pre-line">{(sec.data?.description?.en) || '—'}</div>
                              </div>
                            </div>
                          ) : (
                            <div className="mt-2">
                              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                <div>
                                  <label className="block text-xs text-gray-300 mb-1">Title (FR)</label>
                                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.title?.fr) || ''} onChange={(e) => {
                                    const copy = [...pageForm.sections];
                                    const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                    nextData.title = { ...(nextData.title || {}), fr: e.target.value };
                                    copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                    setPageForm(prev => ({ ...prev, sections: copy }));
                                  }} />
                                </div>
                                <div>
                                  <label className="block text-xs text-gray-300 mb-1">Title (EN)</label>
                                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.title?.en) || ''} onChange={(e) => {
                                    const copy = [...pageForm.sections];
                                    const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                    nextData.title = { ...(nextData.title || {}), en: e.target.value };
                                    copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                    setPageForm(prev => ({ ...prev, sections: copy }));
                                  }} />
                                </div>
                                <div>
                                  <label className="block text-xs text-gray-300 mb-1">Background Image (URL)</label>
                                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.background_image) || ''} onChange={(e) => {
                                    const copy = [...pageForm.sections];
                                    const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                    nextData.background_image = e.target.value;
                                    copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                    setPageForm(prev => ({ ...prev, sections: copy }));
                                  }} />
                                </div>
                              </div>
                              <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                                <div>
                                  <label className="block text-xs text-gray-300 mb-1">Subtitle (FR)</label>
                                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.subtitle?.fr) || ''} onChange={(e) => {
                                    const copy = [...pageForm.sections];
                                    const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                    nextData.subtitle = { ...(nextData.subtitle || {}), fr: e.target.value };
                                    copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                    setPageForm(prev => ({ ...prev, sections: copy }));
                                  }} />
                                </div>
                                <div>
                                  <label className="block text-xs text-gray-300 mb-1">Subtitle (EN)</label>
                                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.subtitle?.en) || ''} onChange={(e) => {
                                    const copy = [...pageForm.sections];
                                    const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                    nextData.subtitle = { ...(nextData.subtitle || {}), en: e.target.value };
                                    copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                    setPageForm(prev => ({ ...prev, sections: copy }));
                                  }} />
                                </div>
                              </div>
                              <div className="mt-2">
                                <label className="block text-xs text-gray-300 mb-1">Description (FR)</label>
                                <textarea className="w-full p-2 rounded bg-gray-700 text-white h-20" value={(pageForm.sections[idx]?.data?.description?.fr) || ''} onChange={(e) => {
                                  const copy = [...pageForm.sections];
                                  const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                  nextData.description = { ...(nextData.description || {}), fr: e.target.value };
                                  copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                }} />
                              </div>
                              <div className="mt-2">
                                <label className="block text-xs text-gray-300 mb-1">Description (EN)</label>
                                <textarea className="w-full p-2 rounded bg-gray-700 text-white h-20" value={(pageForm.sections[idx]?.data?.description?.en) || ''} onChange={(e) => {
                                  const copy = [...pageForm.sections];
                                  const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                  nextData.description = { ...(nextData.description || {}), en: e.target.value };
                                  copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                }} />
                              </div>

                              {/* Spécifiques Accueil */}
                              {sec.type === 'stats' && (
                                <div className="mt-3">
                                  <div className="text-xs font-semibold mb-2">Éléments de statistiques</div>
                                  <div className="space-y-2">
                                    {Array.isArray(pageForm.sections[idx]?.data?.stats) && pageForm.sections[idx].data.stats.map((st, si) => (
                                      <div key={si} className="grid grid-cols-1 md:grid-cols-4 gap-2">
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Nombre" value={st.number ?? ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.stats || []) ];
                                          arr[si] = { ...arr[si], number: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), stats: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Label (FR)" value={st.label_fr || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.stats || []) ];
                                          arr[si] = { ...arr[si], label_fr: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), stats: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Icône (nom)" value={st.icon || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.stats || []) ];
                                          arr[si] = { ...arr[si], icon: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), stats: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <button className="text-xs bg-red-600 px-2 py-1 rounded" onClick={() => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.stats || []) ];
                                          arr.splice(si, 1);
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), stats: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }}>Supprimer</button>
                                      </div>
                                    ))}
                                    <button className="text-xs bg-indigo-600 px-3 py-1 rounded" onClick={() => {
                                      const copy = [...pageForm.sections];
                                      const arr = [ ...(copy[idx]?.data?.stats || []) ];
                                      arr.push({ number: '', label_fr: '', icon: '' });
                                      copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), stats: arr } };
                                      setPageForm(prev => ({ ...prev, sections: copy }));
                                    }}>Ajouter statistique</button>
                                  </div>
                                </div>
                              )}

                              {sec.type === 'gallery' && (
                                <div className="mt-3">
                                  <div className="text-xs font-semibold mb-2">Galerie d'images (drag & drop)</div>
                                  <div className="grid grid-cols-4 gap-2 mb-2">
                                    {(pageForm.sections[idx]?.data?.images || []).map((img, gi) => (
                                      <div key={gi} className="relative w-16 h-16">
                                        <img
                                          src={resolveImageUrl(img)}
                                          alt={`img${gi}`}
                                          className="w-16 h-16 object-cover rounded"
                                          draggable
                                          onDragStart={() => { draggingImageIndexRef.current = gi; }}
                                          onDragOver={(e) => e.preventDefault()}
                                          onDrop={(e) => {
                                            e.preventDefault();
                                            const from = draggingImageIndexRef.current;
                                            const to = gi;
                                            if (from === null || from === undefined || from === to) return;
                                            const copy = [...pageForm.sections];
                                            const arr = [ ...(copy[idx]?.data?.images || []) ];
                                            const [moved] = arr.splice(from, 1);
                                            arr.splice(to, 0, moved);
                                            copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), images: arr } };
                                            setPageForm(prev => ({ ...prev, sections: copy }));
                                            draggingImageIndexRef.current = null;
                                          }}
                                        />
                                        <button
                                          className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded px-1"
                                          onClick={() => {
                                            const copy = [...pageForm.sections];
                                            const arr = [ ...(copy[idx]?.data?.images || []) ];
                                            arr.splice(gi, 1);
                                            copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), images: arr } };
                                            setPageForm(prev => ({ ...prev, sections: copy }));
                                          }}
                                          title="Supprimer"
                                        >×</button>
                                      </div>
                                    ))}
                                  </div>
                                  <input type="file" multiple accept="image/*" onChange={async (e) => {
                                    const files = Array.from(e.target.files || []);
                                    if (!files.length) return;
                                    try {
                                      setPagesLoading(true);
                                      setPagesError(null);
                                      const urls = [];
                                      for (const f of files) {
                                        const url = await AdminService.uploadImage(f, token);
                                        urls.push(url);
                                      }
                                      const copy = [...pageForm.sections];
                                      const arr = [ ...(copy[idx]?.data?.images || []) ];
                                      copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), images: [ ...arr, ...urls ] } };
                                      setPageForm(prev => ({ ...prev, sections: copy }));
                                    } catch (err) {
                                      setPagesError(err?.message || 'Upload images échoué');
                                    } finally {
                                      setPagesLoading(false);
                                    }
                                  }} />
                                </div>
                              )}

                              {sec.type === 'testimonials' && (
                                <div className="mt-3">
                                  <div className="text-xs font-semibold mb-2">Témoignages</div>
                                  <div className="space-y-2">
                                    {Array.isArray(pageForm.sections[idx]?.data?.items) && pageForm.sections[idx].data.items.map((it, ti) => (
                                      <div key={ti} className="grid grid-cols-1 md:grid-cols-5 gap-2">
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Nom" value={it.name || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr[ti] = { ...arr[ti], name: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Projet" value={it.project || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr[ti] = { ...arr[ti], project: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Note (1-5)" value={it.rating ?? ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr[ti] = { ...arr[ti], rating: Number(e.target.value) };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <textarea className="p-2 rounded bg-gray-700 text-white md:col-span-2" placeholder="Commentaire" value={it.comment || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr[ti] = { ...arr[ti], comment: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <button className="text-xs bg-red-600 px-2 py-1 rounded" onClick={() => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr.splice(ti, 1);
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }}>Supprimer</button>
                                      </div>
                                    ))}
                                    <button className="text-xs bg-indigo-600 px-3 py-1 rounded" onClick={() => {
                                      const copy = [...pageForm.sections];
                                      const arr = [ ...(copy[idx]?.data?.items || []) ];
                                      arr.push({ name: '', rating: 5, comment: '', project: '' });
                                      copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                      setPageForm(prev => ({ ...prev, sections: copy }));
                                    }}>Ajouter témoignage</button>
                                  </div>
                                </div>
                              )}

                              {sec.type === 'expertise' && (
                                <div className="mt-3">
                                  <div className="text-xs font-semibold mb-2">Domaines d'expertise</div>
                                  <div className="space-y-2">
                                    {Array.isArray(pageForm.sections[idx]?.data?.items) && pageForm.sections[idx].data.items.map((it, ei) => (
                                      <div key={ei} className="grid grid-cols-1 md:grid-cols-4 gap-2">
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Titre" value={it.title || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr[ei] = { ...arr[ei], title: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Icône (nom)" value={it.icon || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr[ei] = { ...arr[ei], icon: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <input className="p-2 rounded bg-gray-700 text-white" placeholder="Image (URL)" value={it.image || ''} onChange={(e) => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr[ei] = { ...arr[ei], image: e.target.value };
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }} />
                                        <div
                                          className="mt-2 border-2 border-dashed border-gray-600 rounded p-2 text-center text-xs text-gray-300 hover:border-gray-500"
                                          onDragEnter={preventDragDefaults}
                                          onDragOver={preventDragDefaults}
                                          onDrop={async (e) => {
                                            e.preventDefault();
                                            const file = e.dataTransfer?.files?.[0];
                                            if (!file) return;
                                            try {
                                              setPagesLoading(true);
                                              const url = await AdminService.uploadImage(file, token);
                                              const copy = [...pageForm.sections];
                                              const arr = [ ...(copy[idx]?.data?.items || []) ];
                                              arr[ei] = { ...arr[ei], image: url };
                                              copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                              setPageForm(prev => ({ ...prev, sections: copy }));
                                            } catch (err) {
                                              setPagesError(err?.message || 'Upload image échoué');
                                            } finally {
                                              setPagesLoading(false);
                                            }
                                          }}
                                        >
                                          Glisser-déposer une image ici ou
                                          <label className="ml-1 underline cursor-pointer">
                                            choisir un fichier
                                            <input
                                              type="file"
                                              accept="image/*"
                                              className="hidden"
                                              onChange={async (e) => {
                                                const file = e.target.files?.[0];
                                                if (!file) return;
                                                try {
                                                  setPagesLoading(true);
                                                  const url = await AdminService.uploadImage(file, token);
                                                  const copy = [...pageForm.sections];
                                                  const arr = [ ...(copy[idx]?.data?.items || []) ];
                                                  arr[ei] = { ...arr[ei], image: url };
                                                  copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                                } catch (err) {
                                                  setPagesError(err?.message || 'Upload image échoué');
                                                } finally {
                                                  setPagesLoading(false);
                                                }
                                              }}
                                            />
                                          </label>
                                        </div>
                                        <button className="text-xs bg-red-600 px-2 py-1 rounded" onClick={() => {
                                          const copy = [...pageForm.sections];
                                          const arr = [ ...(copy[idx]?.data?.items || []) ];
                                          arr.splice(ei, 1);
                                          copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                          setPageForm(prev => ({ ...prev, sections: copy }));
                                        }}>Supprimer</button>
                                        <div className="md:col-span-4">
                                          <textarea className="p-2 rounded bg-gray-700 text-white w-full" placeholder="Description" value={it.description || ''} onChange={(e) => {
                                            const copy = [...pageForm.sections];
                                            const arr = [ ...(copy[idx]?.data?.items || []) ];
                                            arr[ei] = { ...arr[ei], description: e.target.value };
                                            copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                            setPageForm(prev => ({ ...prev, sections: copy }));
                                          }} />
                                        </div>
                                      </div>
                                    ))}
                                    <button className="text-xs bg-indigo-600 px-3 py-1 rounded" onClick={() => {
                                      const copy = [...pageForm.sections];
                                      const arr = [ ...(copy[idx]?.data?.items || []) ];
                                      arr.push({ title: '', description: '', icon: '', image: '' });
                                      copy[idx] = { ...copy[idx], data: { ...(copy[idx].data || {}), items: arr } };
                                      setPageForm(prev => ({ ...prev, sections: copy }));
                                    }}>Ajouter domaine</button>
                                  </div>
                                </div>
                              )}

                              <div className="flex justify-end gap-2 mt-3">
                                <button className="border border-gray-500 px-3 py-1 rounded" onClick={() => setPageDetailsEditMode(false)}>Terminer</button>
                                <button className="bg-primary text-white px-3 py-1 rounded" onClick={async () => {
                                  try {
                                    setPagesLoading(true);
                                    setPagesError(null);
                                    const updated = await AdminService.upsertPageSection(selectedPage.slug, pageForm.sections[idx], token);
                                    setSelectedPage(updated);
                                    setPageForm(prev => ({ ...prev, sections: updated.sections }));
                                  } catch (err) {
                                    setPagesError(err?.message || 'Sauvegarde section échouée');
                                  } finally {
                                    setPagesLoading(false);
                                  }
                                }}>Sauver section</button>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                  <div>
                    <div className="text-gray-400 text-sm">Slug</div>
                    <div className="text-white text-sm break-all">{selectedPage?.slug}</div>
                  </div>
                  <div>
                    <div className="text-gray-400 text-sm">Actif</div>
                    <div className="text-white text-sm">{selectedPage?.actif ? 'Oui' : 'Non'}</div>
                  </div>
                  <div>
                    <div className="text-gray-400 text-sm">Sections</div>
                    <div className="text-white text-sm">{Array.isArray(selectedPage?.sections) ? selectedPage.sections.length : 0}</div>
                  </div>
                </div>
                <div className="bg-gray-900 rounded p-4 text-sm">
                  <div className="font-semibold mb-2">Meta</div>
                  {!pageDetailsEditMode ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div>
                        <div className="text-gray-400 text-xs">Title (FR)</div>
                        <div className="text-white text-xs">{selectedPage?.meta?.title?.fr || '—'}</div>
                      </div>
                      <div>
                        <div className="text-gray-400 text-xs">Title (EN)</div>
                        <div className="text-white text-xs">{selectedPage?.meta?.title?.en || '—'}</div>
                      </div>
                      <div>
                        <div className="text-gray-400 text-xs">Description (FR)</div>
                        <div className="text-white text-xs">{selectedPage?.meta?.description?.fr || '—'}</div>
                      </div>
                      <div>
                        <div className="text-gray-400 text-xs">Description (EN)</div>
                        <div className="text-white text-xs">{selectedPage?.meta?.description?.en || '—'}</div>
                      </div>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-gray-300 mb-1">Meta Title (FR)</label>
                        <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.meta?.title?.fr) || ''} onChange={(e) => setPageForm(prev => ({ ...prev, meta: { ...(prev.meta || {}), title: { ...((prev.meta?.title) || {}), fr: e.target.value } } }))} />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-300 mb-1">Meta Title (EN)</label>
                        <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.meta?.title?.en) || ''} onChange={(e) => setPageForm(prev => ({ ...prev, meta: { ...(prev.meta || {}), title: { ...((prev.meta?.title) || {}), en: e.target.value } } }))} />
                      </div>
                      <div className="md:col-span-2">
                        <label className="block text-xs text-gray-300 mb-1">Meta Description (FR)</label>
                        <textarea className="w-full p-2 rounded bg-gray-700 text-white h-20" value={(pageForm.meta?.description?.fr) || ''} onChange={(e) => setPageForm(prev => ({ ...prev, meta: { ...(prev.meta || {}), description: { ...((prev.meta?.description) || {}), fr: e.target.value } } }))} />
                      </div>
                      <div className="md:col-span-2">
                        <label className="block text-xs text-gray-300 mb-1">Meta Description (EN)</label>
                        <textarea className="w-full p-2 rounded bg-gray-700 text-white h-20" value={(pageForm.meta?.description?.en) || ''} onChange={(e) => setPageForm(prev => ({ ...prev, meta: { ...(prev.meta || {}), description: { ...((prev.meta?.description) || {}), en: e.target.value } } }))} />
                      </div>
                      <div className="flex justify-end gap-2 md:col-span-2">
                        <button className="border border-gray-500 px-3 py-1 rounded" onClick={() => setPageDetailsEditMode(false)}>Terminer</button>
                        <button className="bg-primary text-white px-3 py-1 rounded" onClick={async () => {
                          try {
                            setPagesLoading(true);
                            setPagesError(null);
                            const updated = await AdminService.upsertPage(pageForm, token);
                            setSelectedPage(updated);
                            setPageForm({
                              slug: updated.slug,
                              title: updated.title || pageForm.title,
                              actif: !!updated.actif,
                              meta: updated.meta || {},
                              sections: Array.isArray(updated.sections) ? updated.sections : []
                            });
                          } catch (err) {
                            setPagesError(err?.message || 'Sauvegarde échouée');
                          } finally {
                            setPagesLoading(false);
                          }
                        }}>Sauvegarder Meta</button>
                      </div>
                    </div>
                  )}
                </div>
                <div className="mt-4 bg-gray-900 rounded p-4 text-sm">
                  <div className="font-semibold mb-2">Sections</div>
                  <div className="space-y-3 max-h-[40vh] overflow-auto">
                    {(selectedPage?.sections || []).map((sec, idx) => (
                      <div key={sec.key || idx} className="bg-gray-800 rounded p-3">
                        <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                          <div>
                            <div className="text-gray-400 text-xs">Key</div>
                            <div className="text-white text-xs">{sec.key || '—'}</div>
                          </div>
                          <div>
                            <div className="text-gray-400 text-xs">Type</div>
                            <div className="text-white text-xs">{sec.type || '—'}</div>
                          </div>
                          <div>
                            <div className="text-gray-400 text-xs">Ordre</div>
                            <div className="text-white text-xs">{sec.order ?? 0}</div>
                          </div>
                          <div>
                            <div className="text-gray-400 text-xs">Actif</div>
                            <div className="text-white text-xs">{sec.actif ? 'Oui' : 'Non'}</div>
                          </div>
                        </div>
                        {sec?.data?.background_image && (
                          <img src={resolveImageUrl(sec.data.background_image)} alt={sec.title || sec.key || 'Section'} className="w-full h-24 object-cover rounded mt-2" />
                        )}
                        {!pageDetailsEditMode ? (
                          <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                              <div className="text-gray-400 text-xs">Title (FR)</div>
                              <div className="text-white text-xs">{(sec.data?.title?.fr) || sec.title || '—'}</div>
                            </div>
                            <div>
                              <div className="text-gray-400 text-xs">Title (EN)</div>
                              <div className="text-white text-xs">{(sec.data?.title?.en) || '—'}</div>
                            </div>
                            <div>
                              <div className="text-gray-400 text-xs">Subtitle (FR)</div>
                              <div className="text-white text-xs">{(sec.data?.subtitle?.fr) || '—'}</div>
                            </div>
                            <div>
                              <div className="text-gray-400 text-xs">Subtitle (EN)</div>
                              <div className="text-white text-xs">{(sec.data?.subtitle?.en) || '—'}</div>
                            </div>
                            <div className="md:col-span-2">
                              <div className="text-gray-400 text-xs">Description (FR)</div>
                              <div className="text-white text-xs whitespace-pre-line">{(sec.data?.description?.fr) || '—'}</div>
                            </div>
                            <div className="md:col-span-2">
                              <div className="text-gray-400 text-xs">Description (EN)</div>
                              <div className="text-white text-xs whitespace-pre-line">{(sec.data?.description?.en) || '—'}</div>
                            </div>
                          </div>
                        ) : (
                          <div className="mt-2">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                              <div>
                                <label className="block text-xs text-gray-300 mb-1">Title (FR)</label>
                                <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.title?.fr) || ''} onChange={(e) => {
                                  const copy = [...pageForm.sections];
                                  const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                  nextData.title = { ...(nextData.title || {}), fr: e.target.value };
                                  copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                }} />
                              </div>
                              <div>
                                <label className="block text-xs text-gray-300 mb-1">Title (EN)</label>
                                <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.title?.en) || ''} onChange={(e) => {
                                  const copy = [...pageForm.sections];
                                  const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                  nextData.title = { ...(nextData.title || {}), en: e.target.value };
                                  copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                }} />
                              </div>
                              <div>
                                <label className="block text-xs text-gray-300 mb-1">Background Image (URL)</label>
                                <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.background_image) || ''} onChange={(e) => {
                                  const copy = [...pageForm.sections];
                                  const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                  nextData.background_image = e.target.value;
                                  copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                }} />
                              </div>
                            </div>
                            <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div>
                                <label className="block text-xs text-gray-300 mb-1">Subtitle (FR)</label>
                                <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.subtitle?.fr) || ''} onChange={(e) => {
                                  const copy = [...pageForm.sections];
                                  const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                  nextData.subtitle = { ...(nextData.subtitle || {}), fr: e.target.value };
                                  copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                }} />
                              </div>
                              <div>
                                <label className="block text-xs text-gray-300 mb-1">Subtitle (EN)</label>
                                <input className="w-full p-2 rounded bg-gray-700 text-white" value={(pageForm.sections[idx]?.data?.subtitle?.en) || ''} onChange={(e) => {
                                  const copy = [...pageForm.sections];
                                  const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                  nextData.subtitle = { ...(nextData.subtitle || {}), en: e.target.value };
                                  copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                  setPageForm(prev => ({ ...prev, sections: copy }));
                                }} />
                              </div>
                            </div>
                            <div className="mt-2">
                              <label className="block text-xs text-gray-300 mb-1">Description (FR)</label>
                              <textarea className="w-full p-2 rounded bg-gray-700 text-white h-20" value={(pageForm.sections[idx]?.data?.description?.fr) || ''} onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                nextData.description = { ...(nextData.description || {}), fr: e.target.value };
                                copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }} />
                            </div>
                            <div className="mt-2">
                              <label className="block text-xs text-gray-300 mb-1">Description (EN)</label>
                              <textarea className="w-full p-2 rounded bg-gray-700 text-white h-20" value={(pageForm.sections[idx]?.data?.description?.en) || ''} onChange={(e) => {
                                const copy = [...pageForm.sections];
                                const nextData = { ...(pageForm.sections[idx]?.data || {}) };
                                nextData.description = { ...(nextData.description || {}), en: e.target.value };
                                copy[idx] = { ...pageForm.sections[idx], data: nextData };
                                setPageForm(prev => ({ ...prev, sections: copy }));
                              }} />
                            </div>
                            <div className="flex justify-end gap-2 mt-3">
                              <button className="border border-gray-500 px-3 py-1 rounded" onClick={() => setPageDetailsEditMode(false)}>Terminer</button>
                              <button className="bg-primary text-white px-3 py-1 rounded" onClick={async () => {
                                try {
                                  setPagesLoading(true);
                                  setPagesError(null);
                                  const updated = await AdminService.upsertPageSection(selectedPage.slug, pageForm.sections[idx], token);
                                  setSelectedPage(updated);
                                  setPageForm(prev => ({ ...prev, sections: updated.sections }));
                                } catch (err) {
                                  setPagesError(err?.message || 'Sauvegarde section échouée');
                                } finally {
                                  setPagesLoading(false);
                                }
                              }}>Sauver section</button>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="flex justify-end gap-3 mt-6">
              <button className="border border-gray-500 px-4 py-2 rounded" onClick={() => { setShowDetails(false); setSelectedPage(null); }}>Fermer</button>
            </div>
          </div>
        </div>
      )}

      {/* Quick Edit Modal (éléments principaux) */}
      {showQuickEdit && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto relative">
            <div className="relative flex items-center justify-between mb-4">
              <div className="flex justify-start">
                <button
                  className="rounded-full w-8 h-8 flex items-center justify-center bg-gray-800 border border-gray-600 text-white hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => setShowQuickEdit(false)}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                </button>
              </div>
              <div className="absolute left-1/2 -translate-x-1/2">
                <h2 className="text-2xl font-bold text-center">Modifier (rapide): {quickEditForm.title || quickEditForm.slug}</h2>
              </div>
              <div className="flex justify-end w-full">
                <button
                  className="bg-red-600 text-white px-4 py-2 rounded-sm hover:bg-red-700"
                  title="Logout"
                  aria-label="Logout"
                  onClick={handleLogout}
                >Logout</button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              <div>
                <label className="block text-sm text-gray-300 mb-1">Titre de la page</label>
                <input className="w-full p-2 rounded bg-gray-700 text-white" value={quickEditForm.title} onChange={(e) => setQuickEditForm(prev => ({ ...prev, title: e.target.value }))} />
              </div>
              <div className="flex items-end gap-2">
                <label className="inline-flex items-center gap-2">
                  <input type="checkbox" checked={quickEditForm.actif} onChange={(e) => setQuickEditForm(prev => ({ ...prev, actif: e.target.checked }))} />
                  <span className="text-sm text-gray-300">Actif</span>
                </label>
              </div>
            </div>

            <div className="mt-2">
              <div className="font-semibold mb-2">Hero (image & titre)</div>
              {quickEditForm.hero.background_image && (
                <img src={resolveImageUrl(quickEditForm.hero.background_image)} alt="Hero" className="w-full h-32 object-cover rounded mb-2" />
              )}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-gray-300 mb-1">Titre principal</label>
                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={quickEditForm.hero.titre_principal} onChange={(e) => setQuickEditForm(prev => ({ ...prev, hero: { ...prev.hero, titre_principal: e.target.value } }))} />
                </div>
                <div>
                  <label className="block text-xs text-gray-300 mb-1">Sous-titre</label>
                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={quickEditForm.hero.sous_titre} onChange={(e) => setQuickEditForm(prev => ({ ...prev, hero: { ...prev.hero, sous_titre: e.target.value } }))} />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-xs text-gray-300 mb-1">Image de fond (URL)</label>
                  <input className="w-full p-2 rounded bg-gray-700 text-white" value={quickEditForm.hero.background_image} onChange={(e) => setQuickEditForm(prev => ({ ...prev, hero: { ...prev.hero, background_image: e.target.value } }))} />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-xs text-gray-300 mb-1">Ou importer une image</label>
                  <input type="file" accept="image/*" onChange={async (e) => {
                    try {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      setPagesLoading(true);
                      setPagesError(null);
                      const url = await AdminService.uploadImage(file, token);
                      setQuickEditForm(prev => ({ ...prev, hero: { ...prev.hero, background_image: url } }));
                    } catch (err) {
                      setPagesError(err?.message || 'Upload image échoué');
                    } finally {
                      setPagesLoading(false);
                    }
                  }} />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button className="border border-gray-500 px-4 py-2 rounded" onClick={() => setShowQuickEdit(false)}>Annuler</button>
              <button className="bg-primary text-white px-4 py-2 rounded" onClick={async () => {
                try {
                  setPagesLoading(true);
                  setPagesError(null);
                  const isOverall = (quickEditForm.slug === 'accueil' || quickEditForm.slug === 'apropos');
                  if (isOverall) {
                    await AdminService.updateProperty('overall', 'hero', 'titre_principal', quickEditForm.hero.titre_principal, token);
                    await AdminService.updateProperty('overall', 'hero', 'sous_titre', quickEditForm.hero.sous_titre, token);
                    await AdminService.updateProperty('overall', 'hero', 'background_image', quickEditForm.hero.background_image, token);
                  } else {
                    // Mettre à jour le titre/actif de la page
                    await AdminService.upsertPage({ slug: quickEditForm.slug, title: quickEditForm.title, actif: quickEditForm.actif }, token);
                    // Section hero
                    const baseSection = { key: 'hero', type: 'hero', order: 0, actif: true, data: {} };
                    baseSection.data.background_image = quickEditForm.hero.background_image || '';
                    baseSection.data.title = { fr: quickEditForm.hero.titre_principal || '' };
                    baseSection.data.subtitle = { fr: quickEditForm.hero.sous_titre || '' };
                    await AdminService.upsertPageSection(quickEditForm.slug, baseSection, token);
                  }
                  setShowQuickEdit(false);
                } catch (err) {
                  setPagesError(err?.message || 'Sauvegarde échouée');
                } finally {
                  setPagesLoading(false);
                }
              }}>Sauvegarder</button>
            </div>
          </div>
        </div>
      )}

      {/* Property Editor Modal (image upload utilitaire) */}
      {showEditor && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto relative">
            {/* En-tête modale alignée */}
            <div className="relative flex items-center justify-between mb-4">
              <div className="flex justify-start">
                <button
                  className="rounded-full w-8 h-8 flex items-center justify-center bg-gray-800 border border-gray-600 text-white hover:bg-gray-700"
                  title="Retour"
                  aria-label="Retour"
                  onClick={() => setShowEditor(false)}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                </button>
              </div>
              <div className="absolute left-1/2 -translate-x-1/2">
                <h2 className="text-2xl font-bold text-center">Modifier {editor.section}.{editor.property}</h2>
              </div>
              <div className="flex justify-end w-full">
                <button
                  className="bg-red-600 text-white px-4 py-2 rounded-sm hover:bg-red-700"
                  title="Logout"
                  aria-label="Logout"
                  onClick={handleLogout}
                >Logout</button>
              </div>
            </div>
            {Array.isArray(editor.value) ? (
              <div>
                <div className="grid grid-cols-4 gap-2 mb-4">
                  {editor.value.map((img, i) => (
                    <div key={i} className="relative w-16 h-16">
                      <img src={img} alt={`img${i}`} className="w-16 h-16 object-cover rounded" />
                      <button
                        className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded px-1"
                        onClick={() => removeImageAtIndex(i)}
                        title="Supprimer"
                      >×</button>
                    </div>
                  ))}
                </div>
                {/* Dropzone multi-fichiers */}
                <div
                  className="mb-4 border-2 border-dashed border-gray-600 rounded p-4 text-center text-sm text-gray-300 hover:border-gray-500"
                  onDragEnter={preventDragDefaults}
                  onDragOver={preventDragDefaults}
                  onDrop={handleDropFiles}
                >
                  Glisser-déposer des images ici ou
                  <label className="ml-1 underline cursor-pointer">
                    choisir des fichiers
                    <input type="file" accept="image/*" multiple className="hidden" onChange={handleFileChange} />
                  </label>
                </div>
                <div className="flex gap-2 mt-2">
                  <input
                    value={imageUrlInput}
                    onChange={(e) => setImageUrlInput(e.target.value)}
                    placeholder="Coller un lien d'image"
                    className="flex-1 bg-gray-700 text-white text-sm rounded px-2 py-1"
                  />
                  <button className="text-sm bg-indigo-600 px-3 py-1 rounded" onClick={addImageLink}>Ajouter lien</button>
                </div>
              </div>
            ) : (
              <div>
                {editor.value && <img src={editor.value} alt="preview" className="w-full h-48 object-cover rounded mb-4" />}
                {/* Dropzone fichier unique */}
                <div
                  className="border-2 border-dashed border-gray-600 rounded p-4 text-center text-sm text-gray-300 hover:border-gray-500"
                  onDragEnter={preventDragDefaults}
                  onDragOver={preventDragDefaults}
                  onDrop={handleDropFiles}
                >
                  Glisser-déposer une image ici ou
                  <label className="ml-1 underline cursor-pointer">
                    choisir un fichier
                    <input type="file" accept="image/*" className="hidden" onChange={handleFileChange} />
                  </label>
                </div>
                <div className="flex gap-2 mt-2">
                  <input
                    value={imageUrlInput}
                    onChange={(e) => setImageUrlInput(e.target.value)}
                    placeholder="Coller un lien d'image"
                    className="flex-1 bg-gray-700 text-white text-sm rounded px-2 py-1"
                  />
                  <button className="text-sm bg-indigo-600 px-3 py-1 rounded" onClick={addImageLink}>Utiliser lien</button>
                  {editor.value && (
                    <button className="text-sm bg-red-600 px-3 py-1 rounded" onClick={clearSingleImage}>Supprimer</button>
                  )}
                </div>
              </div>
            )}

            <div className="flex justify-end gap-3 mt-6">
              <button className="border border-gray-500 px-4 py-2 rounded" onClick={() => setShowEditor(false)}>Annuler</button>
              <button className="bg-primary text-white px-4 py-2 rounded" onClick={saveProperty}>Sauvegarder</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
